/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable max-len */
import { AfterViewInit, ChangeDetectorRef, Component, effect, ElementRef, Inject, Injectable, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { BryntumSchedulerProComponent } from '@bryntum/schedulerpro-angular-thin';
import { BryntumGridComponent } from '@bryntum/grid-angular-thin';
import {  DragHelper, DragHelperConfig, GridColumnConfig, Tooltip } from '@bryntum/core-thin';
import { Grid, GridConfig } from '@bryntum/grid-thin';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { Observable, ReplaySubject, Subject, Subscription, combineLatest, forkJoin, of, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, shareReplay, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { SettingsComponent } from '../settings/settings.component';
import { DispatchBoardService } from './dispatch-board.service';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { SharedService } from '../../core/services/shared.service';
import moment, { Moment } from 'moment';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MapsService } from 'app/modules/maps/maps.service';
import { Title } from '@angular/platform-browser';
import { DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { ManageDispatchFilterComponent } from '../manage-dispatch-filter/manage-dispatch-filter.component';
import { RescheduleJobComponent } from '../reschedule-job/reschedule-job.component';
import { RemarksComponent } from '../remarks/remarks.component';
import { PreviewDataOptions } from 'app/components/preview-data/preview-data.interface';
import { Router } from '@angular/router';
import { TemplateService } from '../../core/services/template.service';
import { ConfigurationService } from '../../core/services/configuration.service';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import { Location } from '@angular/common';
import tippy from 'tippy.js';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewTimeOffComponent } from 'app/components/new-timeoff/new-timeoff.component';
import { NoteDialogComponent } from 'app/components/notes/note-dialog/note-dialog.component';
import { NoteDialogService } from 'app/components/notes/note-dialog/note-dialog.service';
import { DispatchFilterService } from '../dispatch-filter/dispatch-filter.service';
import { JobFormComponent } from 'app/modules/jobs/job-form/job-form.component';
import { dataObj } from 'app/modules/jobs/job-form/job-form.type';
import _ from 'lodash';
import { ColorProfileOptions, MapPanData } from 'app/modules/maps/map.interface';
import 'moment-timezone';
import dayjs from 'dayjs';
import { UpdateDueDateComponent } from 'app/modules/jobs/job-details/edit-due-date/edit-due-date.component';
import { ActionSelectorComponent } from 'app/components/action-selector/action-selector.component';
import { ActionSelectorOption } from 'app/components/action-selector/action-selector.interface';
import { ZuperSdkEventService } from 'app/core/services/sdk_service/sdk-event.service';
import { dispatchSplitConfig, ModuleAccess, Permissions } from './dispatch-board.interface';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
@Injectable()
export class CustomRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  enableWeekRange: boolean = false;
  enableMonthRange: boolean = false;
  constructor(private _dateAdapter: DateAdapter<D>) { }
  selectionFinished(date: D | null): DateRange<D> {
    if (this.enableWeekRange) { return this._createWeekRange(date); }
    else if (this.enableMonthRange) { return this._createMonthRange(date); };
  }

  createPreview(activeDate: D | null): DateRange<D> {
    if (this.enableWeekRange) { return this._createWeekRange(activeDate); }
    else if (this.enableMonthRange) { return this._createMonthRange(activeDate); }
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, 0);
      const end = this._dateAdapter.addCalendarDays(date, 6);
      return new DateRange<D>(start, end);
    }
    return new DateRange<D>(null, null);
  }

  private _createMonthRange(date: D | null): DateRange<D> {
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, 0);
      const end = this._dateAdapter.addCalendarMonths(date, 1);
      return new DateRange<D>(start, end);
    }
    return new DateRange<D>(null, null);
  }
}

@Component({
  selector: 'app-dispatch-board',
  templateUrl: './dispatch-board.component.html',
  styleUrls: ['./dispatch-board.component.scss'],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: CustomRangeSelectionStrategy
    }
  ]
})
export class DispatchBoardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('employeeSearch', { read: ElementRef, static: true }) employeeSearchTemplate: ElementRef;
  @ViewChild('schedulerNewEventDialogContent', { static: true }) schedulerNewEventDialogContent: TemplateRef<any>;
  @ViewChild('noTeamAlertDialogContent', { static: true }) noTeamAlertDialogContent: TemplateRef<any>;
  @ViewChild('schedulerpro',  { static: false }) schedulerProComponent!: BryntumSchedulerProComponent;
  @ViewChild('cardView', { static: false }) cardViewComponent!: BryntumGridComponent;
  @ViewChild('tableView', { static: false }) tableViewComponent!: BryntumGridComponent;
  @ViewChild('mapLegendWrapper', { static: false }) mapLegendWrapperRef!: ElementRef;
  @ViewChild('mapContainer', { static: false }) mapContainerRef!: ElementRef;
  @ViewChild('mapLegendContainer', { static: false }) mapLegendContainerRef!: ElementRef;
  @ViewChildren('mapLegendItems') mapLegendItems!: QueryList<ElementRef>;
  //Dispatch tab config
  selectedDispatchTab: 'JOBS' | 'ROUTES' = 'JOBS';
  enableRoutesTab: boolean = true;
  enableServiceTerritory: boolean = true;

  quickFilters: any;
  selectedTimezone: string;
  selectedTeamTimezone: string;
  browserTimezone: string;
  allTeams: any[] = [];
  allTerritories: any[] = [];
  selectedQuickFilter: string = 'ALL';
  fallbackSelectedQuickFilter: string = 'ALL';
  gridFeatures = {};
  teams: Observable<any[]>;
  serviceTerritories: Observable<any[]>;
  schedulerData: any = [];
  routePrefillConfig: any = {};
  holidays = [];
  cardData = [];
  metaData: any;
  bufferMetaData: any;
  gridViewType: 'listView' | 'tableView';
  cardConfig: Partial<GridConfig>;
  tableConfig: Partial<GridConfig>;
  showGrid = false;
  totalGridPage: number = 1;
  totalGridRecords: number = 1;
  cardViewInstance: Grid;
  tableViewInstance: any;
  gridViewInstance: any;
  gridParam: any = {};
  mapParams: any = {};
  gridPreference: any;
  previewDataModule: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  defaultGridPreference = { page: 1, count: 10, type: 'UNASSIGNED', sort_by: 'scheduled_start_time', sort: 'DESC' };
  jobUid: any;
  openDrawer: boolean = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  sortOptions = { grid: { sort_by: 'scheduled_start_time', sort: 'DESC' }, scheduler: {} };
  gridSortBtn: any;
  sortTippyInstance: any;
  currentView: 'DAY' | 'WEEK' | 'MONTH' = 'DAY';
  currentDay: string;
  schedulerJobs: any = [];
  schedulerNonJobEvents: any[] = [];
  schedulerAssignments: any[] = [];
  schedulerNonJobAssignments: any[] = [];
  schedulerEmployees: any[] = [];
  schedulerEventRowHeight: number = 60;
  schedulerResourceRowHeight: number = 60;
  schedulerViewportCenterDate: any;
  timeFormat: string;
  dateFormat: string = this._utilityService.dateFormat;
  dateTimeFormat: string = this._utilityService.dateTimeFormat;
  schedulerFromDate: any;
  schedulerToDate: any;
  schedulerInstance: any;
  schedulerFeatures: any;
  employeePreviewdata: any = {};
  employeePreviewTippyInstance: any;
  tableGridData: any = [];
  selectedTeam: string;
  gridData: any = [];
  mapJobs: any = [];
  schedulerViewTypes = ['DAY', 'WEEK', 'MONTH'];
  schedulerFormGroup: UntypedFormGroup = new UntypedFormGroup({
    schedulerDate: new UntypedFormControl(moment(), Validators.required),
    scheduleStartDate: new UntypedFormControl(moment().startOf('week'), Validators.required),
    scheduleEndDate: new UntypedFormControl(moment().endOf('week'), Validators.required),
    selectedTeam: new UntypedFormControl(null),
    schedulerView: new UntypedFormControl(this.schedulerViewTypes[0], Validators.required)
  });
  schedulerParams: any = {};
  nonJobEventParams: any = { page: 1, count: 500 }; //Setting count 500 till backend work done
  gridJobTypeMap: any;
  schedulerProConfig: any;
  gridSortableColumns;
  settingsDialogdata: any = {};
  enablePreview: boolean = false;
  dispatchFilterDrawerData = { openFilter: false, dispatchFilterValues: {}, additionalFilters: {}, saveFilterByDefault: false, hideSaveFilter: false, addNewFilter: false, selectedModule: 'GRID', filterOptionalValues: { map: [] } };
  isLoading: boolean = true;
  gridFilterOptions: any;
  isMapViewEnabled: boolean;
  schedulerFocusData = { jobUid: null, userUid: null };
  defaultFilterOptions = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'job': { 'filterOptions': {'grid':[{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'scheduled_start_time','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'employee':[{ "displayKeyValue": [], "key": "assigned_to.user_uid", "operator": "CONTAINS", "field_type": "LOOKUP", "value": "", "module": "JOB", "type": "nested_field" },{'displayKeyValue':[],'key':'skillset_uid','operator':'EQUAL_TO','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'scheduler':[{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}],'map':{'filter.route_uid':[]}}, 'sortOptions': { 'grid': { 'sort_by': 'scheduled_start_time', 'sort': 'DESC' }, 'employee': {}, 'scheduler': {}, 'map': {} }, 'filterUid': 'ALL', 'filterCount': { 'grid': 0, 'employee': 0, 'scheduler': 0, 'map': 0 } },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'route': { 'filterOptions': { 'grid': [{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'scheduled_start_time','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'grid_route': [{'displayKeyValue':[],'key':'keyword','operator':'CONTAINS','field_type':'TEXT','value':'','module':'JOB','type':'default_field'}], 'employee': [{ "displayKeyValue": [], "key": "assigned_to.user_uid", "operator": "CONTAINS", "field_type": "LOOKUP", "value": "", "module": "JOB", "type": "nested_field" },{'displayKeyValue':[],'key':'skillset_uid','operator':'EQUAL_TO','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'scheduler': [{'displayKeyValue':[],'key':'job_category_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'displayKeyValue':[],'key':'due_date','operator':'EQUAL_TO','field_type':'DATE','module':'JOB','type':'default_field'},{'displayKeyValue':[],'key':'customer_uid','operator':'CONTAINS','field_type':'LOOKUP','value':'','module':'JOB','type':'nested_field'},{'key':'keyword','field_type':'TEXT','value':'','operator':'CONTAINS','type':'default_field'}], 'scheduler_route': [{'displayKeyValue':[],'key':'keyword','operator':'CONTAINS','field_type':'TEXT','value':'','module':'JOB','type':'default_field'}], 'map': { 'filter.route_uid': [] } }, 'sortOptions': { 'grid': { 'sort_by': 'scheduled_start_time', 'sort': 'DESC' }, 'employee': {}, 'scheduler': {}, 'map': {}, 'grid_route': { 'sort_by': 'departure', 'sort': 'DESC' } }, 'filterUid': 'ALL', 'filterCount': { 'grid': 0, 'employee': 0, 'scheduler': 0, 'map': 0, 'grid_route': 0, 'scheduler_route': 0 } }
  };
  defaultSchedulerPreference = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'job': { 'from_date': moment().format('YYYY-MM-DD'), 'to_date': moment().format('YYYY-MM-DD'), 'team_uid': '', 'currentView': 'DAY' },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'route': { 'date': moment().format('YYYY-MM-DD'), 'from_date': moment().format('YYYY-MM-DD'), 'to_date': moment().add(2, 'd').format('YYYY-MM-DD'), 'team_uid': '' },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'timezone': { 'JOBS': moment.tz.guess(), 'ROUTES': moment.tz.guess() },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'service_territory': { 'JOBS': { serviceTerritoryUid: null, serviceTerritoryName: null, type: null, radius: 0 }, 'ROUTES': { serviceTerritoryUid: null, serviceTerritoryName: null, type: null, radius: 0 } }
  };
  lastMapPanData: any;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  mapLayersRef = { 'jobs': 'JOB', 'users': 'USER', 'organizations': 'ORGANIZATION', 'properties': 'PROPERTY', 'customers': 'CUSTOMER', 'service_territories': '', 'assets': 'ASSETS' };
  customUserDetails: Object;
  dragConfig: Partial<DragHelperConfig>;
  dragInstance: DragHelper;
  currentRouteTab: string = 'TRACKING';
  gridTbar = { jobType: 'UNASSIGNED' };
  gridBbar: Object = { page: 1, count: 10 };
  gridSearchKeyword: string = '';
  schedulerSearchKeyword: string = '';
  employeeSearchKeyword: string = '';
  appliedSchedulerSearchKeyword: string = '';
  appliedEmployeeSearchKeyword: string = '';
  openGridSearch: boolean = false;
  gridPageNumber: string = '1';
  loadingGridData: boolean = false;
  isSchedulerInCurrentDate: boolean = false;
  schedulerPresets: any;
  schedulerZoomInBtnState: boolean = false;
  schedulerZoomOutBtnState: boolean = false;
  timeoffTooltipInstance: Tooltip;
  tooltipTimeoffEvent: any;
  schedulerSummaryTooltipInstance: any;
  outOfShiftHoursTooltipInstance: any;
  schedulerNewEventDialogInstance: any;
  employeeSearchTippy: any;
  newJobPrefillData: any = {};
  cloneJobData: any = null;
  openNewJobDrawer: boolean = false;
  schedulerDatePrevBtn: boolean = false;
  schedulerDateNextBtn: boolean = false;
  mapViewData: any = {};
  teamPickerLoading: boolean = false;
  teamValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  serviceTerritoryValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  teamSearchPagination = { currentPage: 1, totalPage: 1, keyword: '', filterUid: '', serviceTerritoryFilterUid: '' };
  territorySearchPagination = { currentPage: 1, totalPage: 1, keyword: '', filterUid: '', isLoading: false };
  teamPickerList: any[] = [];
  quickFilterLoading: boolean = false;
  schedulerSearchTippyInstance: any;
  schedulerResourceSortState: 'DEFAULT' | 'ASC' | 'DESC' = 'DEFAULT';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  filterCount = { grid: 0, employee: 0, scheduler: 0, map: 0 };
  permissions: Permissions;
  moduleAccess: ModuleAccess;
  dispatchJobSplitSettings: dispatchSplitConfig = {
    orientation: 'horizontal',
    grid: {
      size: 25,
      minSize: 20,
      maxSize: 35,
      order: 1
    },
    scheduler: {
      size: 75,
      minSize: 40,
      maxSize: null,
      order: 2
    },
    map: {
      size: 25,
      minSize: 15,
      maxSize: 30,
      order: 3
    },
    visible: {
      grid: true,
      scheduler: true,
      map: true
    },
    gutter: {
      toggleState: {
        0: 'neutral',
        1: 'neutral'
      }
    },
    maxSize: 80,
    minSize: 70
  };
  mapResizeTimeout: any;
  empDetailsDrawer = { drawerOpen: false, module: 'USER', moduleUID: '' };
  routePreviewDrawerData = { drawerName: 'dispatchRoutesPreview', show: false, routeDetailsUid: '', source: '' };
  mapPinDataSubscription: Subscription;
  openJobDetailsSubscription: Subscription;
  jobPreviewSubscription: Subscription;
  previewDataOptions: PreviewDataOptions;
  noTeamAlertDialogRef: MatDialogRef<any>;
  mapRouteData: any = {};
  nonJobEventCreateDrawerData = { openDrawer: false, options: null, eventData: null, source: null };
  nonJobEventDetailsDrawerData = { nonJobEventUid: '', openDrawer: false, options: null, drawerName: null };
  colorProfiletCreateDrawerData = { openDrawer: false, drawerName: 'colorProfileJobDrawer' };
  cancelNonJobEventRequest: Subject<void> = new Subject<void>();
  timeoffEditElement: HTMLElement;
  timeoffDeleteElement: HTMLElement;
  timeoffEditHandler: any;
  timeoffDeleteHandler: any;
  gridSortTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'right',
    offset: [80, 10],
    onShow: () => {
      this._dispatchBoardService.trackEvent('grid_sort');
    }
  };
  schedulerSearchTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'bottom',
    onShow: (instance: any) => {
      this.schedulerSearchTippyInstance = instance;
      this._dispatchBoardService.trackEvent('scheduler_search');
    },
    onMount: (instance: any) => {
      instance.popper.querySelector('input')?.focus();
    },

    onHide: () => {
      this.schedulerSearchKeyword = this.appliedSchedulerSearchKeyword;
      if (!this.schedulerSearchKeyword?.trim()?.length && this.schedulerInstance) {
        this.schedulerSearchKeyword = '';
        this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
      }
    }
  };
  isSchedulerInitialLoad = true;

  //Service Territory
  selectedServiceTerritory: string = 'ALL';
  selectedServiceTerritoryDetails = { name: null, geoCords: [], type: null, radius: 0 };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  allServiceTerritorySelectOption = { 'territory_uid': 'ALL', 'territory_name': this._utilityService.getLocaleValue('text.all_service_territory', 'All Service Territory') };
  serviceTerritoryPickerList: any[] = [this.allServiceTerritorySelectOption];
  mapColorProfileOptions: ColorProfileOptions = { isEnabled: true, enableLegend: true };
  mapLegendData = { legendDetails: [], extraCount: 0 };

  //Toast Ref
  geoCordsNotFoundToastRef: CreateHotToastRef<any>;
  closedJobScheduleErrorToastRef: CreateHotToastRef<any>;

  //Cleanup
  tearDown$: Subject<void> = new Subject<void>();

  getUserTeamId = _.memoize((userUid: any): string => {
    let teamId = '';
    const schedulerJobs = this.schedulerProConfig.events;
    schedulerJobs.forEach((job: any) => {
      const assignedTo = job?.assigned_to?.filter((assignee: any) => assignee?.user.user_uid === userUid);
      if (assignedTo.length) {
        const teamUid = assignedTo[0]?.team?.team_uid || this.selectedTeam;
        if (!this._utilityService.isEmptyOrUndefined(teamUid)) {
          teamId = teamUid;
          return false; // Exit loop
        }
      }
    });
    return teamId;
  });

  getTeamName = _.memoize((teamUid: any): string => {
    const teamDetails: any = this.allTeams.find((teamDetails: any) => teamDetails?.team_uid === teamUid);
    return teamDetails?.team_name || ''
  });

  setSchedulerStartEndDate = _.debounce((currentView: 'DAY' | 'WEEK' | 'MONTH', skipSchedulerScroll: boolean = false, onlyStartEndTime: boolean = false, animateScroll: boolean = true): void => {
    this.setSchedulerDate(currentView, skipSchedulerScroll, onlyStartEndTime, animateScroll);
  }, 500);

  addSchedulerEmpHeaderOnClickListener = _.debounce((): void => {
    const schedulerResourceHeader = (this.schedulerProComponent['elementRef']?.['nativeElement'] as HTMLElement).querySelector('#schedulerResourceHeader-JOBS');
    if(schedulerResourceHeader) {
      const searchBtn = schedulerResourceHeader.querySelector('#schedulerEmpHeaderSearchBtn-JOBS') as HTMLElement;
      this.employeeSearchTippy?.destroy();
      this.employeeSearchTippy = tippy((searchBtn), {
        allowHTML: true,
        theme: 'light',
        trigger: 'click',
        interactive: true,
        appendTo: document.body,
        placement: 'right',
        content: this.employeeSearchTemplate.nativeElement,
        onMount: () => {
          this.employeeSearchTemplate.nativeElement.classList.remove('hidden');
          this.employeeSearchTemplate.nativeElement.classList.add('flex');
          if (this.employeeSearchTemplate.nativeElement) {
            this.employeeSearchTemplate.nativeElement?.querySelector('input')?.focus();
          }
        },
        onHide: () => {
          if (searchBtn) {
            this.employeeSearchKeyword = this.appliedEmployeeSearchKeyword;
            if (this.employeeSearchKeyword?.trim()?.length) {
              if (this.schedulerInstance?.resourceStore?.filters?.values?.length) {
                schedulerResourceHeader.querySelector('#jobs-employee-search-active-indicator')?.remove();
                const searchIndicatorEleRef = document.createElement('div');
                searchIndicatorEleRef.id = 'jobs-employee-search-active-indicator';
                searchIndicatorEleRef.classList.add('w-2', 'h-2', 'bg-primary-600', 'rounded-full', 'absolute', 'top-1', 'right-1', 'z-10');
                searchBtn.classList.add('relative');
                searchBtn.appendChild(searchIndicatorEleRef);
              }
            }
            else {
              const searchIndicatorEleRef = searchBtn.querySelector('#jobs-employee-search-active-indicator');
              if (searchIndicatorEleRef) {
                searchIndicatorEleRef.remove();
              }
            }
          }
          if (!this.employeeSearchKeyword?.trim()?.length && this.schedulerInstance) {
            this.employeeSearchKeyword = '';
            this.schedulerInstance.resourceStore.removeFilter('userSearch');
          }
        }
      });
      schedulerResourceHeader.querySelector('#schedulerEmpHeaderFilterBtn-JOBS')?.addEventListener('click', () => {
        this.openDispatchFilter('EMPLOYEE');
      });
      schedulerResourceHeader.querySelector('#schedulerEmpHeaderSettingsBtn-JOBS')?.addEventListener('click', () => {
        this.openSettingsDialog('EMPLOYEE');
      });
      schedulerResourceHeader.querySelector('#schedulerEmpHeaderSearchBtn-JOBS')?.addEventListener('click', () => {
        this.employeeSearchTippy.show();
      });
      schedulerResourceHeader.querySelector('#schedulerEmpHeaderSortBtn-JOBS')?.addEventListener('click', (event) => {
        const button = (event.target as Element).closest('button');
        const icon = button.querySelector('i') as HTMLElement;
        if (this.schedulerResourceSortState === 'DEFAULT') {
          this.schedulerResourceSortState = 'ASC';
        }
        else {
          this.schedulerResourceSortState = this.schedulerResourceSortState === 'ASC' ? 'DESC' : 'ASC';
        }
        if (icon) {
          icon.classList.remove('ti-arrows-sort', 'ti-sort-ascending-letters', 'ti-sort-descending-letters');
          if (this.schedulerResourceSortState === 'ASC') {
            icon.classList.add('ti-sort-ascending-letters');
            button.title = this._utilityService.getLocaleValue('dataPicker.sort.ascending', 'Ascending');
          } else {
            icon.classList.add('ti-sort-descending-letters');
            button.title = this._utilityService.getLocaleValue('dataPicker.sort.descending', 'Descending');
          }
        }
        this.sortSchedulerResources('name', this.schedulerResourceSortState);
      });
      this.updateFilterCount();
    }
  }, 1000, { trailing: true });

  constructor(
    private _dataCollectorService: DataCollectorService,
    public _utilityService: UtilityService,
    private _localisationService: LocalisationService,
    private _zuperDialogService: ZuperDialogService,
    public _dispatchBoardService: DispatchBoardService,
    private _toastService: HotToastService,
    private _localStorageService: LocalStorageService,
    public _sharedService: SharedService,
    private _changeDetector: ChangeDetectorRef,
    private _zuperDrawerService: ZuperDrawerService,
    private _mapService: MapsService,
    private _title: Title,
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private customDatePicker: CustomRangeSelectionStrategy<any>,
    private location: Location,
    private _templateService: TemplateService,
    private _configurationService: ConfigurationService,
    private ngxTippyService: NgxTippyService,
    private matDialog: MatDialog,
    private router: Router,
    private _noteDialogService: NoteDialogService,
    private _dispatchFilterService: DispatchFilterService,
    private _sdkEventService: ZuperSdkEventService,
  ) {
    this.setupSignalEffects();
  }

  ngOnInit(): void {
    this._dispatchBoardService.trackNavigationEvent('DISPATCH_BOARD', true);
    this.updatePermissions();
    this._localisationService.setDefaultLanguage();
    this._title.setTitle(this._utilityService.getLocaleValue('dispatch.home.tab.title', 'Zuper Pro - Dispatch Board'));
    this.timeFormat = this._utilityService.timeFormat === '24_HRS' ? 'HH:mm' : 'hh:mm A';
    this.gridSortableColumns = this._configurationService.getGridSortableColumns();
    this.gridJobTypeMap = this._configurationService.getGridJobTypeMap();
    this.browserTimezone = moment.tz.guess();
    this.setDefaultFilters();
    this.getTimeZones();
    this.getHolidays();
    this._sharedService.initateForms(false);
    this.initSchedulerPresets();
    this.setDefaultMetaData();
    this.setPreferences();
    this.setCardConfig();
    this.setTableConfig();
    this.getMetaData();
    this.setSchedulerConfig();
    this.initMapDependencies();
  }


  ngAfterViewInit(): void {
    this.cardViewInstance = this.cardViewComponent?.instance;
    this.tableViewInstance = this.tableViewComponent?.instance;
    this.schedulerInstance = this.schedulerProComponent?.instance;
    this.jobPreviewSubscription = this._dispatchBoardService.jobPreview.subscribe(({ jobUid, timezone }) => {
      this.jobUid = jobUid;
      this.openDrawer = true;
      this.previewDataModule = 'JOB';
      this.previewDataOptions.timeZone = timezone;
    });

    this.initiateTableSortEventListener();
    const schedulerPreference = this.metaData?.scheduler?.display;
    this.toggleSchedulerSummary(schedulerPreference.job_summary);
    setTimeout(() => {
      if (this.schedulerInstance) {
        this.setSchedulerEventLisners();
        this.schedulerInstance.project.commitAsync().then(async () => {
            const hasJobFocusEvent: boolean = !!this.schedulerFocusData.jobUid;
            this.refreshSchedulerEvents(true, hasJobFocusEvent);
        });
        this.schedulerInstance.refresh();
        this.schedulerInstance.renderContents();
      }
    }, 500);
  }

  ngOnDestroy(): void {
    this.mapPinDataSubscription?.unsubscribe();
    this.jobPreviewSubscription?.unsubscribe();
    this.openJobDetailsSubscription?.unsubscribe();
    this.tearDown(true);
    this.tearDown$.next();
    this.tearDown$.complete();
  }

  tearDown(removeBackup: boolean = false): void {
    if (this.schedulerProConfig) {
      this.schedulerProConfig.events = [];
      this.schedulerProConfig.resources = [];
      this.schedulerProConfig.assignments = [];
    }
    if (this.schedulerInstance?.destroy) {
      this.schedulerInstance?.destroy();
      this.schedulerInstance = null;
    }
    if (this.cardViewInstance?.destroy) {
      this.cardViewInstance.destroy();
      this.cardViewInstance = null;
    }
    if (this.tableViewInstance?.destroy) {
      this.tableViewInstance.destroy();
      this.tableViewInstance = null;
    }
    this.destroyTooltipInstances();
    this.toggleMapLegendBar(false, null, true);
  }

  setupSignalEffects(): void {
    //Preview Route Details Drawer
    effect(() => {
      const { show, routeDetailsUid, source } = this._dispatchBoardService.previewRouteDetails();
      const drawer = this._zuperDrawerService.getComponent(this.routePreviewDrawerData.drawerName);
      if (drawer) {
        this.routePreviewDrawerData.routeDetailsUid = show ? routeDetailsUid : '';
        this.routePreviewDrawerData.show = show;
        this.routePreviewDrawerData.source = source;
        show ? drawer.open() : drawer.close();
      }
    });
  }

  commitFinalizedHandler = () => {
    this.applyQueryParams();
  };

  setSchedulerEventLisners(): void {
    if (this.schedulerFocusData.jobUid || this.schedulerFocusData.userUid) {
      this.schedulerInstance.project.on('commitfinalized', this.commitFinalizedHandler);
    }
  }

  removeSchedulerEventLisners(): void {
    this.schedulerFocusData.jobUid = null;
    this.schedulerFocusData.userUid = null;
    this.schedulerInstance.project.un('commitfinalized', this.commitFinalizedHandler);
  }

  onToggleRouteTab(selectedTab: string): void {
    this.currentRouteTab = selectedTab;
    this.closeDispatchFilter();
  }

  initiateGridShimmer(count: number): any[] {
    return Array(count).fill({ showShimmer: true });
  }

  initMapDependencies(): void {
    this.mapPinDataSubscription = this._mapService.mapCurrentLocation
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((mapPanData: MapPanData) => {
        this.lastMapPanData = mapPanData;
        if (mapPanData?.additionalData?.metaData) {
          this.bufferMetaData = mapPanData.additionalData.metaData;
        }
        if (!mapPanData.isWithinBound) {
          this._dispatchBoardService.getNearByData(this.metaData, mapPanData).then((nearByData: any) => {
            this._dispatchBoardService.injectNearByMapData(this.metaData, nearByData, this._dispatchBoardService.activeDispatchTab);
          });
        }
        else if (!this.isMapViewEnabled) {
          this._dispatchBoardService.injectNearByMapData(this.metaData, [], this._dispatchBoardService.activeDispatchTab);
        }
      });

    this._dispatchBoardService.getServiceTerritory()
      .then((data) => {
        if (!this.metaData) {
          this.updateMetaData();
        }
        this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
      });

    this.openJobDetailsSubscription = this._mapService.openPreviewDetailsInDispatchBoard
      .subscribe((data: any) => {
        this.jobUid = data?.previewUid;
        this.openDrawer = data?.openDrawer;
        this.previewDataModule = data?.module || 'JOB';
      });
  }

  onDispatchTabChange(module: 'JOBS' | 'ROUTES'): void {
    this.selectedDispatchTab = module;
    this._dispatchBoardService.activeDispatchTab = module;
    this._dispatchBoardService.currentTab = module;
    this._mapService.openTooltip.jobUid = null;
    this.closeDispatchFilter();
    this.loadSchedulerPreferenceFromLocal();
    this.selectedTimezone = this._dispatchBoardService.getTimezonePrecedence(this.selectedTeamTimezone);
    if (module === 'JOBS') {
      this.location.replaceState('/dispatch_board');
      this._dispatchBoardService.trackNavigationEvent(module);
    }
    //Enable shimmer effect while switching tabs
    setTimeout(() => {
      this.setGridSchedulerInstance();
      if (this.schedulerInstance) {
        this.schedulerInstance.resourceStore.removeAll();
        this.schedulerInstance.resourceStore.add(this.initiateGridShimmer(7))
      }
    });
    //Need some time to load the scheduler DOM after destroying
    setTimeout(() => {
      this.setGridSchedulerInstance();
      this.setSchedulerFillTricks();
      this.updateSettings(this.bufferMetaData);
      this.getSchedulerData(true);
      this.updateLastMapLayerData();
      this.initiateTooltipInstances();
      this.refreshSchedulerTimezone();
    }, 300);
  }

  updateLastMapLayerData(): void {
    this._dispatchBoardService.injectJobLocationMapData('JOBS', null, this.metaData, null, false, true);
    this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
    this._dispatchBoardService.injectEmployeeLocationMapData('JOBS', this.metaData);
    this.updateMapRouteFilter();
  }

  onToggleDispatchTab(module: 'JOBS' | 'ROUTES', subModule: any, additionalParams?: any): void {
    if (module === 'ROUTES') {
      this.tearDown();
    }
    this.selectedDispatchTab = module;
    this._dispatchBoardService.currentTab = module;
    this._dispatchBoardService.activeDispatchTab = module;
    if (module === 'JOBS') {
      this.location.replaceState('/dispatch_board');
    } else if (module === 'ROUTES') {
      this._dispatchBoardService.trackNavigationEvent(module);
      this._dispatchBoardService.jobRouteTransferEmitter.next({ module: module, subModule: subModule, additionalParams: additionalParams });
    }
    this.closeDispatchFilter();
    this.toggleMapLegendBar(false, null, true);
    this._dispatchBoardService.isSchedulerHolidayMounted.JOBS = false;
  }

  getTimeZones(): void {
    this._dispatchBoardService.timezones = this._dataCollectorService.getData(this._dispatchBoardService.timezoneUrl)
    .pipe(map((response) => {
      let timezones = response?.data || [];
      timezones = timezones.map((timezone: any) => ({...timezone, name: `${timezone?.key || ''} ${timezone?.display_name || ''}`}));
      this._dispatchBoardService.allTimezoneDetails = timezones;
      return timezones;
    }));
  }

  setPreferences(): void {
    //Get local storage data
    let saveschedulerPreference: boolean = false;
    let dispatchFilterValues = this._localStorageService.getLocalStorage('dispatch_board_advance_filter');
    let schedulerPreference = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    let gridPreferenceLocal = this._localStorageService.getLocalStorage('dispatch_board_grid_preferences');

    if (!dispatchFilterValues) {
      dispatchFilterValues = this.defaultFilterOptions;
    }
    if (!schedulerPreference) {
      schedulerPreference = this.defaultSchedulerPreference;
      saveschedulerPreference = true;
    }
    if (!gridPreferenceLocal) {
      gridPreferenceLocal = { job: this.defaultGridPreference, route: {} };
    }

    if (dispatchFilterValues?.job?.filterOptions) {
      dispatchFilterValues.job.filterOptions = this._dispatchBoardService.sanitizeFilterOptions(dispatchFilterValues?.job?.filterOptions);
    }

    if (gridPreferenceLocal?.job?.filter_rules) {
      gridPreferenceLocal.job.filter_rules = gridPreferenceLocal.job.filter_rules.map((rule: any) => this._utilityService.setPrepopulatedDateValue(rule));
    }

    //Route tab visibility
    const currentUrl = window.location.href;
    const queryParams = this._configurationService.extractQueryParams(currentUrl);
    const newGridFilterRules: any[] = [];
    let tab = queryParams?.tab || 'JOBS';
    if (this.moduleAccess.map) {
      const recurringRouteUid = queryParams?.['recurrence-route-uid'];
      if (tab === 'TRACKING' && recurringRouteUid) {
        tab = 'PLANNING';
      }
      if (tab === 'ROUTES') {
        delete queryParams['tab'];
        const hasPrefillData = !_.isEmpty(queryParams);
        this.onToggleDispatchTab('ROUTES', hasPrefillData ? 'PLANNING' : 'TRACKING');
        this.routePrefillConfig = queryParams;
      }
      else if (tab === 'PLANNING') {
        if (recurringRouteUid) {
          this.onToggleDispatchTab('ROUTES', 'PLANNING', { recurringRouteUid: recurringRouteUid });
        }
        else {
          this.onToggleDispatchTab('ROUTES', 'PLANNING');
        }
        this.routePrefillConfig = queryParams;
      }
      else {
        this.location.replaceState('/dispatch_board');
        this._dispatchBoardService.activeDispatchTab = 'JOBS';
        tab = 'JOBS';
      }
    }
    else {
      this.enableRoutesTab = false;
      this.routePrefillConfig = {};
      this.location.replaceState('/dispatch_board');
    }
    this._mapService.openTooltip.jobUid = null;

    // Job tab prefill configs
    if (tab === 'JOBS' && !_.isEmpty(queryParams)) {
      this.routePrefillConfig = {};
      let hasSchedulerParamsChanged: boolean = false;
      this.selectedQuickFilter = 'ALL';
      dispatchFilterValues.job.filterUid = 'ALL';
      schedulerPreference.service_territory.JOBS = { serviceTerritoryUid: 'ALL', geoCords: [], radius: 0, serviceTerritoryName: this._utilityService.getLocaleValue('text.all_service_territory', 'All Service Territory') };
      //Prefill Grid filters
      if (queryParams?.['work-order-number'] && Number(queryParams?.['work-order-number']) && this._utilityService.isPlainPositiveNumber(queryParams?.['work-order-number'])) {
        const workOrderFilterRules: any[] = this._dispatchFilterService.constructFilterRules([{ key: 'work_order_number', value: queryParams?.['work-order-number'] }]);
        newGridFilterRules.push(...workOrderFilterRules);
      }

      //Prefill Scheduler Params
      if (queryParams?.['job-uid']) {
        this.schedulerFocusData.jobUid = queryParams?.['job-uid'];
        this._mapService.openTooltip.jobUid = queryParams?.['job-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (queryParams?.['user-uid']) {
        this.schedulerFocusData.userUid = queryParams?.['user-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (queryParams?.['team-uid']) {
        schedulerPreference.job.team_uid = queryParams?.['team-uid'];
        hasSchedulerParamsChanged = true;
      }
      if (queryParams?.['scheduled-start-date'] && moment(queryParams?.['scheduled-start-date'], 'YYYY-MM-DD', true).isValid()) {
        schedulerPreference.job.from_date = queryParams?.['scheduled-start-date'];
        hasSchedulerParamsChanged = true;
      }
      if (queryParams?.timezone && this._utilityService.isValidTimezone(queryParams?.timezone)) {
        schedulerPreference.timezone.JOBS = queryParams?.timezone;
      }

      if (newGridFilterRules?.length) {
        gridPreferenceLocal.job.type = 'ALL';
        gridPreferenceLocal.job.filter_rules = newGridFilterRules;
        dispatchFilterValues.job.filterOptions.grid = newGridFilterRules;
      }
      if (hasSchedulerParamsChanged) {
        dispatchFilterValues.job.filterOptions.employee = this.defaultFilterOptions.job.filterOptions.employee;
        dispatchFilterValues.job.filterOptions.scheduler = this.defaultFilterOptions.job.filterOptions.scheduler;
      }
      this.schedulerParams['filter_rules'] = dispatchFilterValues.job.filterOptions.scheduler || [];
      this.schedulerParams['employee_filter_rules'] = dispatchFilterValues.job.filterOptions.employee || [];
      this.gridFilterOptions = dispatchFilterValues.job.filterOptions.grid;
      this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchFilterValues);
      this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
      this.refreshFilterCount();
    }
    else {
      if (saveschedulerPreference) {
        this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
      }
      this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchFilterValues);
    }

    this.enableServiceTerritory = this._dispatchBoardService.companyConfig.serviceTerritory;
    //Scheduler preferences
    this.currentView = schedulerPreference?.job?.currentView || 'DAY';
    this.loadSchedulerPreferenceFromLocal(schedulerPreference);
    this.selectedServiceTerritory = schedulerPreference?.service_territory?.JOBS?.serviceTerritoryUid || 'ALL';
    this.selectedServiceTerritoryDetails.name = schedulerPreference?.service_territory?.JOBS?.serviceTerritoryName || '';
    this.selectedServiceTerritoryDetails.type = schedulerPreference?.service_territory?.JOBS?.type || null;
    this.selectedServiceTerritoryDetails.radius = schedulerPreference?.service_territory?.JOBS?.radius || 0;
    if (schedulerPreference?.service_territory?.JOBS?.geoCords?.length) {
      this.selectedServiceTerritoryDetails.geoCords[0] = schedulerPreference?.service_territory?.JOBS?.geoCords[0] || null;
      this.selectedServiceTerritoryDetails.geoCords[1] = schedulerPreference?.service_territory?.JOBS?.geoCords[1] || null;
    }
    this.territorySearchPagination.filterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';
    this.teamSearchPagination.serviceTerritoryFilterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';
    this.selectedTimezone = schedulerPreference?.timezone?.JOBS || this.browserTimezone;
    if (this.schedulerInstance) {
      this.schedulerInstance.timeZone = this.selectedTimezone;
    }
    this._dispatchBoardService.selectedTimezone.JOBS = this.selectedTimezone;
    this._dispatchBoardService.customTimezone = this.selectedTimezone;
    this.toggleDatePickerStrategy(this.currentView);
    this.getPreviewDataOptions();

    //Grid preferences
    this.gridPreference = gridPreferenceLocal?.['job'];
    if (this._utilityService.isEmptyOrUndefined(this.gridPreference)) {
      this.gridPreference = this.defaultGridPreference;
    }
    this.gridPreference.page = 1;
    this.gridParam = this.gridPreference;
    this.sortOptions.grid.sort = this.gridParam['sort'];
    this.sortOptions.grid.sort_by = this.gridParam['sort_by'];
    let gridFilterOptions = dispatchFilterValues?.job?.filterOptions?.grid || [];
    if (gridFilterOptions?.length && this.enableServiceTerritory) {
      const existingServiceTerritoryFilterRule = this._dispatchBoardService.getFilterRuleByKey('territory_uid', gridFilterOptions);
      if (existingServiceTerritoryFilterRule) {
        //Set filter rules based on global service territory selection - Grid
        const serviceTerritoryFilterRules = this._dispatchBoardService.getServiceTerritoryFilterRule([this.selectedServiceTerritory], [this.selectedServiceTerritoryDetails.name], existingServiceTerritoryFilterRule?.source || null);
        gridFilterOptions = this._dispatchBoardService.removeFilterKey('territory_uid', gridFilterOptions) || [];
        gridFilterOptions.push(serviceTerritoryFilterRules);
        gridPreferenceLocal.job.filter_rules = gridFilterOptions;
        this._localStorageService.setLocalStorage('dispatch_board_grid_preferences', gridPreferenceLocal);

        //Advanced filter values
        dispatchFilterValues.job['filterOptions']['grid'] = gridFilterOptions;
        this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchFilterValues);
        this.refreshFilterCount();
      }
    }
    this.gridViewType = this.metaData?.grid.view_type;
    this.isMapViewEnabled = this.metaData?.map?.enable_map_view;
    this.gridData = this.cardData = this.tableGridData = this.initiateGridShimmer(7);
    this.editResourceTimeRangeEvent.bind(this);
    this.deleteResourceTimeRangeEvent.bind(this);
    this.updateDispatchJobSplitSettings();
  }

  loadSchedulerPreferenceFromLocal(schedulerPreference?: any): void {
    if (!schedulerPreference) {
      schedulerPreference = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    }
    if (!this._utilityService.isEmptyOrUndefined(schedulerPreference)) {
      this.currentView = schedulerPreference?.job.currentView;
      this.selectedTeam = schedulerPreference?.job.team_uid || '';
      this.schedulerFormGroup.get('schedulerView').setValue(this.currentView);
      this.schedulerFormGroup.get('selectedTeam')?.setValue(this.selectedTeam);
      this.teamSearchPagination.filterUid = this.selectedTeam;
      this.schedulerFormGroup?.get('schedulerDate')?.setValue(moment(schedulerPreference?.job.from_date, 'YYYY-MM-DD'));
      this.schedulerFormGroup?.get('scheduleStartDate')?.setValue(moment(schedulerPreference?.job.from_date, 'YYYY-MM-DD'));
      this.schedulerFormGroup?.get('scheduleEndDate')?.setValue(moment(schedulerPreference?.job.to_date, 'YYYY-MM-DD'));
      this.schedulerFormGroup?.get('schedulerView')?.setValue(schedulerPreference?.job.currentView);
    }
  }

  setQuickFilterPreference(): void {
    //Quick filter preferences
    let dispatchBoardFilter = this._localStorageService.getLocalStorage('dispatch_board_advance_filter');
    if (!dispatchBoardFilter) {
      dispatchBoardFilter = this.defaultFilterOptions;
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', this.defaultFilterOptions);
      this.dispatchFilterDrawerData.addNewFilter = true;
    }
    const quickFilterOptions = dispatchBoardFilter.job;
    this.selectedQuickFilter = quickFilterOptions?.filterUid || 'ALL';
    this.gridFilterOptions = quickFilterOptions?.filterOptions?.grid;

    if (this.selectedQuickFilter !== 'ALL') {
      this.gridParam.sort_by = quickFilterOptions?.sortOptions?.grid.sort_by;
      this.gridParam.sort = quickFilterOptions?.sortOptions?.grid.sort;
    }
  }

  refreshFilterCount(): void {
    const advanceFilterValue = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultFilterOptions;
    this.filterCount = this._dispatchFilterService.getFilterCount(advanceFilterValue?.job.filterOptions, 'JOBS');
    advanceFilterValue.job.filterCount = this.filterCount;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', advanceFilterValue);
  }

  setFilterCount(key: string, value: number): void {
    if(!key) { return; };
    const dispatchBoardFilter = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultFilterOptions;
    dispatchBoardFilter.job.filterCount[key] = value;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilter);
    this.filterCount[key] = value;
    this.updateFilterCount();
  }

  updateFilterCount(refreshFilterCount: boolean = true): void {
    if (!this.mapContainerRef) { return; }
    const mapFilterBadge = (this.mapContainerRef.nativeElement as HTMLElement).querySelector('#mapFilterBadge');
    const employeeFilterBadge = (this.schedulerProComponent['elementRef']?.['nativeElement'] as HTMLElement).querySelector(`#employeeFilterBadge-JOBS`);
    if (refreshFilterCount) {
      this.refreshFilterCount();
    }

    if (mapFilterBadge) {
      if (this.filterCount.map > 0) {
        mapFilterBadge.classList.remove('opacity-0');
        mapFilterBadge.innerHTML = this.filterCount.map.toString();
      }
      else {
        mapFilterBadge.classList.add('opacity-0');
      }
    }

    if (employeeFilterBadge) {
      if (this.filterCount.employee > 0) {
        employeeFilterBadge.classList.remove('opacity-0');
        employeeFilterBadge.innerHTML = this.filterCount.employee.toString();
      }
      else {
        employeeFilterBadge.classList.add('opacity-0');
      }
    }
  }

  getQuickFilters(init: boolean, newFilterUid: any = this.selectedQuickFilter): Observable<any> {
    const params = {
      'count': '50',
      'filter.module': 'DISPATCH_BOARD',
      'page': '1'
    };
    this.quickFilterLoading = true;
    return this._dataCollectorService.getData(this._dispatchBoardService.quickFilterUrl, params).pipe(
      tap((response: any) => {
        this.quickFilters = response?.data;
        if (init) {
          this.setQuickFilterPreference();
        } else {
          this.selectedQuickFilter = newFilterUid;
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const isQuickFilterAvailable = _.find(this.quickFilters, { 'filter_uid': this.selectedQuickFilter });
        let considerExistingFilter = true;
        if (!isQuickFilterAvailable && this.selectedQuickFilter !== 'ALL') {
          this.selectedQuickFilter = 'ALL';
          considerExistingFilter = false;
        }
        this.updateFilterCount();
        this.onQuickFilterChange(this.selectedQuickFilter, init, considerExistingFilter);
        this.quickFilterLoading = false;
      }),
      catchError((error: any) => {
        this.updateFilterCount();
        this.onQuickFilterChange('ALL', true, true);
        this.quickFilterLoading = false;
        return throwError(() => error);
      })
    );
  }

  initiateTableSortEventListener(): void {
    const _this = this;
    _this.tableViewInstance?.store.addListener({
      beforeSort({ sorters }) {
        _this.tableViewInstance.store.removeAll();
        _this.gridParam['sort'] = sorters[0]['ascending'] === true ? 'ASC' : 'DESC';
        _this.gridParam['sort_by'] = _this.gridSortableColumns[sorters[0]['field']];
        _this.gridParam['page'] = 1;
        _this.getGridData(_this.gridParam).then((jobs: any) => {
          _this.gridPageNumber = '1';
          _this.updateTableContent(jobs);
        });
      }
    });
  }

  sortSchedulerResources(sortBy: string, sort: 'ASC' | 'DESC'): void {
    if (this.schedulerInstance) {
      this.schedulerInstance.resourceStore.sort({
        field: sortBy,
        ascending: sort === 'ASC',
        silent: true
      });
    }
  }

  get hasGridInstanceMounted(): boolean {
    return  (this.gridViewType === 'listView' && this.cardViewInstance) || (this.gridViewType === 'tableView' && this.tableViewInstance);
  }

  initiateDragHelper(viewType: any): void {
    let targetSelector: any;
    let gridTemplateType: 'tableProxy' | 'jobGridCard';
    if (viewType === 'tableView') {
      targetSelector = '#table-view';
      gridTemplateType = 'tableProxy';
    }
    else if (viewType === 'listView') {
      targetSelector = '#card-view';
      gridTemplateType = 'jobGridCard';
    }
    targetSelector += ' .b-grid-row:not(.b-group-row)';
    this.dragConfig = {
      cloneTarget: true,
      autoSizeClonedTarget: false,
      mode: 'translateXY',
      dropTargetSelector: '.b-timeline-subgrid',
      targetSelector: targetSelector,
      lockX: !this.permissions.updateJobAssignment || !(this.permissions.scheduleJob || this.permissions.rescheduleJob),
      lockY: !this.permissions.updateJobAssignment || !(this.permissions.scheduleJob || this.permissions.rescheduleJob),
      createProxy: (element: any): any => {
        const proxy = document.createElement('div');
        if (!this.permissions.updateJobAssignment || !(this.permissions.scheduleJob || this.permissions.rescheduleJob)) {
          return proxy;
        }
        const record = this.gridViewInstance?.getRecordFromElement(element);
        const jobUid = record?.data?.job_uid || '';
        proxy.style.maxWidth = '400px';
        this._dispatchBoardService.setTableProxyRecords(record?.data);
        proxy.innerHTML = this._templateService.getJobRendererTemplate('jobs', gridTemplateType, jobUid);
        return proxy;
      }
    };
    this.dragInstance = this.createDragerInstance(this.dragConfig);

    //Drag from grid to scheduler
    this.dragInstance.on({
      dragstart: (event: any) => {
        const context = event.context;
        let task: any;
        this.schedulerInstance.features.eventTooltip.disabled = true;
        this.schedulerInstance.features.cellTooltip.disabled = true;
        this.timeoffTooltipInstance.disabled = true;
        if (this.gridViewInstance && context) {
          task = event?.context?.task || this.gridViewInstance?.getRecordFromElement(context.grabbed);
          context.task = task;
        }
      },

      beforeDragStart: (event: any) => {
        const eventElement = event.context?.element;
        if (eventElement) {
          const jobDetails = this.gridViewInstance?.getRecordFromElement(eventElement);
          if (jobDetails) {
            event.context.task = jobDetails;
          }
          if (jobDetails?.data?.current_job_status?.status_type === 'CLOSED') {
            this.closedJobScheduleErrorToastRef?.close();
            event.context.valid = false;
            this.closedJobScheduleErrorToastRef = this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.error.job_status_closed', 'This job is closed and can’t be updated'));
            return false;
          }
        }
      },

      drag: _.debounce((event: any) => {
        const context = event.context;
        if (this.schedulerInstance) {
          const date = this.schedulerInstance?.getDateFromCoordinate(context.clientX, 'round', false);
          const resource = context.target && this.schedulerInstance?.resolveResourceRecord(context.target);
          context.valid = context.valid && (date && resource);
          context.resource = resource;
          context.date = date;
        }
      }, 100, { leading: true }),

      drop: (event: any) => {
        const context = event.context;
        let hasPermission: boolean = false;
        const task = context.task;
        const resouce = context.resource;
        let jobDetails = task?.originalData;
        const userDetails = resouce?.data;
        const dropDateTime = moment(this.schedulerInstance?.getDateFromCoordinate(event.event.clientX, 'round', false));
        this.schedulerInstance.features.eventTooltip.disabled = false;
        this.schedulerInstance.features.cellTooltip.disabled = false;
        this.timeoffTooltipInstance.disabled = false;
        if (this.gridViewType === 'tableView') {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          jobDetails = _.find(this._dispatchBoardService.getGridRecords(), { 'job_uid': jobDetails?.id });
        }

        let openRescheduleDialog: boolean = true;
        let scheduledStartTime = jobDetails?.scheduled_start_time;
        let scheduledEndTime = jobDetails?.scheduled_end_time;
        if (!this._utilityService.isEmptyOrUndefined(scheduledStartTime) && !this._utilityService.isEmptyOrUndefined(scheduledEndTime)) {
          scheduledStartTime = moment(scheduledStartTime);
          scheduledEndTime = moment(scheduledEndTime);
          hasPermission = this.permissions.updateJobAssignment && this.permissions.rescheduleJob;
          const userUid = userDetails?.user_uid;
          const jobAssignedTo: any[] = jobDetails?.assigned_to;
          const isSameDayJob = scheduledStartTime.isSame(scheduledEndTime, 'date');
          const isSameAsEndDate = scheduledEndTime.isSame(moment(dropDateTime), 'date');
          const isUserAlreadyAssigned = jobAssignedTo.filter((assignee: any) => assignee?.user.user_uid === userUid).length > 0;
          openRescheduleDialog = !(isSameDayJob && isSameAsEndDate) || isUserAlreadyAssigned;
        }
        else {
          hasPermission = this.permissions.updateJobAssignment && this.permissions.scheduleJob;
        }

        //Track event
        if(context.valid) {
          this._dispatchBoardService.trackEvent('grid_drag_and_drop_job');
        }

        //Open reschedule dialog
        if (openRescheduleDialog && context.valid) {
          if (hasPermission) {
            this._sdkEventService.openCustomWithPreEventListener(RescheduleJobComponent, {
              dialogId: `dispatch_board.job_reschedule`,
              data: {
                holidays: this.holidays,
                userDetails: userDetails,
                jobDetails: jobDetails,
                dropDateTime: dropDateTime,
                customUserDetails: this.customUserDetails,
                teamUid: this.selectedTeam
              },
              extraClass: 'w-fit'
            }, jobDetails).then((rescheduleDialogInstance) => {
              if(!rescheduleDialogInstance && context) {
                context.finalize(false)
              }
              rescheduleDialogInstance?.afterClosed()
                .subscribe((dialogData: any) => {
                  if (dialogData) {
                    //Converting date time to browser timezone as a workaround of bryntum scheduler issue
                    const _startDateTime = moment.tz(dialogData?.scheduledStartTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone).tz(this.browserTimezone);
                    const _endDateTime = moment.tz(dialogData?.scheduledEndTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone).tz(this.browserTimezone);
                    this.createNewSchedulerResourceAndEvent(jobDetails, userDetails, _startDateTime, _endDateTime);
                    this._dispatchBoardService.trackEvent(['drag_drop_job_user', 'drag_drop_job_reschedule']);
                    this.updateGridJobRecords(jobDetails, task);
                    this.setDistanceBetweenJobs();
                    this.upadteCustomEmployeeDetails();
                  }
                });
            });
          }
          else {
            this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
          }
        }
        else if (!openRescheduleDialog && context.valid) {
          if (hasPermission) {
            const jobUid = jobDetails?.job_uid;
            const userUid = userDetails?.user_uid;
            const teamUid = this.selectedTeam;
            const startDateTime = scheduledStartTime;
            const endDateTime = scheduledEndTime;
            const warnings: any[] = this._dispatchBoardService.getScheduleWarningMsg('job', jobDetails, userDetails, startDateTime, endDateTime, this.customUserDetails, true);
            const openJobAssignConfirmationDialog = Object.values(warnings).filter((warning: any) => warning.show).length > 0;
            const jobType = this.getGridJobType();
            let jobAssignConfirmation: any;

            //Open confirmation dialog with warnings
            if (openJobAssignConfirmationDialog) {
              jobAssignConfirmation = this._dispatchBoardService.scheduleConfirmationDialog('job', jobDetails, warnings);
              jobAssignConfirmation?.afterClosed()
                .subscribe((result: boolean) => {
                  if (result) {
                    this._dispatchBoardService.assignJob(jobUid, userUid, teamUid, (status: boolean) => {
                      if (status) {
                        if (['UNSCHEDULED', 'UNASSIGNED'].includes(jobType)) {
                          this.removeJobFromGrid(task);
                        }
                        const _startDateTime = dayjs(scheduledStartTime).tz(this.selectedTimezone);
                        const _endDateTime = dayjs(scheduledEndTime).tz(this.selectedTimezone);
                        this.createNewSchedulerResourceAndEvent(jobDetails, userDetails, _startDateTime, _endDateTime, null, true);
                        this._dispatchBoardService.trackEvent('drag_drop_job_user');
                        this.updateGridJobRecords(jobDetails, task);
                        this.setDistanceBetweenJobs();
                        this.upadteCustomEmployeeDetails();
                      }
                    });
                  }
                });
            }
            else {
              this._dispatchBoardService.assignJob(jobUid, userUid, teamUid, (status: boolean) => {
                if (status) {
                  if (['UNSCHEDULED', 'UNASSIGNED'].includes(jobType)) {
                    this.removeJobFromGrid(task);
                  }
                  const _startDateTime = dayjs(scheduledStartTime).tz(this.selectedTimezone);
                  const _endDateTime = dayjs(scheduledEndTime).tz(this.selectedTimezone);
                  this.createNewSchedulerResourceAndEvent(jobDetails, userDetails, _startDateTime, _endDateTime, null, true);
                  this._dispatchBoardService.trackEvent('drag_drop_job_user');
                  this.updateGridJobRecords(jobDetails, task);
                  this.setDistanceBetweenJobs();
                  this.upadteCustomEmployeeDetails();
                }
              });
            }
          }
          else {
            this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
          }
        }
      },

      abort: (event: any) => {
        this.schedulerInstance.features.eventTooltip.disabled = false;
        this.schedulerInstance.features.cellTooltip.disabled = false;
        this.timeoffTooltipInstance.disabled = false;
      }
    });
  }

  updateGridJobRecords(jobDetails: any, task: any): void {
    this.schedulerJobs.push(jobDetails);
    this._dispatchBoardService.setSchedulerRecords(this.schedulerJobs);
    setTimeout(() => {
      const jobUid = jobDetails?.job_uid;
      if (['UNSCHEDULED', 'UNASSIGNED'].includes(this.getGridJobType())) {
        this.gridData = this.gridData.filter((job: any) => job.job_uid !== jobUid);
        this.removeJobFromGrid(task);
        if (this.gridData.length === 0) {
          this.getGridData(this.gridParam).then((jobs: any) => {
            this.updateGridViewData(jobs);
          });
        }
      }
    }, 100);
  }

  addNewSchedulerRecord(jobDetails: any): void {
    this.schedulerJobs.push(jobDetails);
    this._dispatchBoardService.setSchedulerRecords(this.schedulerJobs);
  }

  initSchedulerPresets(): void {
    this.schedulerPresets = _.cloneDeep(this._dispatchBoardService.getSchedulerPresets());
  }

  loadSchedulerPresets( schedulerPresets: any = this.schedulerPresets): void {
    const currentPresets = schedulerPresets?.[this.currentView.toLowerCase()];
    if (!this._utilityService.isEmptyOrUndefined(currentPresets)) {
      this.schedulerProConfig.presets = currentPresets;
      if (this.schedulerInstance) {
        this.schedulerInstance.presets.add(currentPresets);
      }
    }
  }

  setSchedulerPreset(currentView: 'DAY' | 'WEEK' | 'MONTH', schedulerPresets: any = this.schedulerPresets, skipSetDate: boolean = false): void {
    const hasSchedulerFocusEvent: boolean = !!this.schedulerFocusData.jobUid;
    if (!skipSetDate) {
      this.setSchedulerDate(this.currentView, hasSchedulerFocusEvent, false, true, this.schedulerViewportCenterDate);
    }
    this.loadSchedulerPresets(schedulerPresets);
    if (currentView === 'DAY') {
      this.schedulerProConfig.viewPreset = 'customHourAndDay';
      if (this.schedulerInstance) {
        this.schedulerInstance.viewPreset = 'customHourAndDay';
      }

    } else if (currentView === 'WEEK' || currentView === 'MONTH') {
      this.schedulerProConfig.viewPreset = 'dayAndWeek';
      if (this.schedulerInstance) {
        this.schedulerInstance.viewPreset = 'dayAndWeek';
      }
    }
    this.setSchedulerFillTricks();
    if (this.schedulerInstance) {
      this.schedulerInstance.timeRangeStore.refreshData();
      this.schedulerInstance.timeAxis.refreshData();
      this.schedulerInstance.resourceStore.refreshData();
    }
  }

  setSchedulerDate(currentView: 'DAY' | 'WEEK' | 'MONTH', skipSchedulerScroll: boolean = false, onlyStartEndTime: boolean = false, animateScroll: boolean = true, scrollToDate?: any): void {
    let startDate: any;
    let endDate: any;
    let startDateTime: any;
    let endDateTime: any;

    const isDayView = currentView === 'DAY';
    const isWeekOrMonthView = currentView === 'WEEK' || currentView === 'MONTH';

    // Handling 'DAY' view
    if (isDayView) {
      startDate = this.schedulerFormGroup.get('schedulerDate').value.clone().format('YYYY-MM-DD');
      endDate = startDate;
      this.isSchedulerInCurrentDate = moment().isSame(moment(startDate, 'YYYY-MM-DD'), 'date');
      const businessStartTime: string = this._dispatchBoardService.getBusinessHours('start');
      const businessEndTime: string = this._dispatchBoardService.getBusinessHours('end');

      // If displaying business hours only, apply start and end of business hours
      if (this.metaData?.scheduler.display.business_hours_only) {
        startDateTime = new Date(`${startDate} ${businessStartTime}`);
        endDateTime = new Date(`${endDate} ${businessEndTime}`);
      } else {
        startDateTime = new Date(`${startDate} 00:00:00`);
        endDateTime = new Date(`${endDate} 23:59:59`);
      }
    }

    // Handling 'WEEK' or 'MONTH' views
    if (isWeekOrMonthView) {
      startDate = this.schedulerFormGroup.get('scheduleStartDate').value.clone().format('YYYY-MM-DD');
      endDate = this.schedulerFormGroup.get('scheduleEndDate').value.clone().format('YYYY-MM-DD');
      startDateTime = new Date(`${startDate} 00:00:00`);
      endDateTime = new Date(`${endDate} 23:59:59`);
      this.isSchedulerInCurrentDate = false;
    }

    if (this.schedulerInstance) {
      this.suspendAllSchedulerEvents();
      this.schedulerInstance.setTimeSpan(startDateTime, endDateTime);
      if (!onlyStartEndTime) {
        if (!isDayView || this.metaData?.scheduler.display.business_hours_only ) {
          setTimeout(() => this.buildBusinessHoursTimeRange('remove'));
        }
        else {
          setTimeout(() => this.buildBusinessHoursTimeRange('add'));
        }
      }
      this.resumeAllSchedulerEvents();
    }
    // Set the scroll position if not skipped
    if (!skipSchedulerScroll) {
      this._dispatchBoardService.setSchedulerScrollPosition(this.schedulerInstance, this.currentView, animateScroll, scrollToDate);
    }
  }

  scrollSchedulerToToady(): void {
    if(this.currentView === 'DAY' && this.isSchedulerInCurrentDate) {
      this._dispatchBoardService.setSchedulerScrollPosition(this.schedulerInstance, 'DAY');
    }
    else {
      this.onSchedulerViewChange(true);
    }
  }

  setSchedulerZoom(type: 'zoomIn' | 'zoomOut'): void {
    this.setSchedulerStartEndDate(this.currentView, true);
    if (type === 'zoomIn') {
      this.schedulerInstance?.zoomIn(1, { startDate: this.schedulerInstance?.startDate, endDate: this.schedulerInstance?.endDate });
    }
    else if (type === 'zoomOut') {
      this.schedulerInstance?.zoomOut(1, { startDate: this.schedulerInstance?.startDate, endDate: this.schedulerInstance?.endDate });
    }
    this.setSchedulerFillTricks();
    this.updateEmpShiftRenderer();
  }

  setSchedulerFillTricks(): any {
    if (this.schedulerInstance) {
      this.schedulerZoomInBtnState = this.schedulerInstance?.maxZoomLevel === this.schedulerInstance?.zoomLevel;
      this.schedulerZoomOutBtnState = this.schedulerInstance?.minZoomLevel === this.schedulerInstance?.zoomLevel;
      if (this.currentView === 'DAY') {
        this.schedulerInstance.fillTicks = false;
      }
      else if (this.currentView === 'MONTH' || this.currentView === 'WEEK') {
        if (this.schedulerInstance?.zoomLevel === -1 || this.schedulerInstance?.zoomLevel === this.schedulerInstance?.minZoomLevel) {
          this.schedulerInstance.fillTicks = true;
        }
        else {
          this.schedulerInstance.fillTicks = false;
        }
      }
    }
  }

  updateEmpShiftRenderer(): void {
    if (this.schedulerInstance) {
      const zoomLevel = this.schedulerInstance?.zoomLevel;
      const addShiftDetails = this.currentView === 'DAY' || (this.currentView === 'WEEK' && (zoomLevel === 1 || zoomLevel === 2)) || (this.currentView === 'MONTH' && zoomLevel === 1);
      if (addShiftDetails) {
        this._dispatchBoardService.setResourceShift(this.schedulerInstance, this.schedulerEmployees, 'DAY');
      }
      else {
        let resourceTimeRanges: any[] = this.schedulerInstance?.resourceTimeRanges;
        resourceTimeRanges = resourceTimeRanges.filter((resourceTimeRange: any) => !resourceTimeRange.id.startsWith('empShift_'));
        this.schedulerInstance.resourceTimeRanges = resourceTimeRanges;
      }
    }
  }

  removeJobFromGrid(task: any): void {
    this.gridViewInstance?.store.remove(task);
    const gridDataCount = this.gridViewInstance?.data.length || 0;
    if (gridDataCount === 0) {
      this.getGridData(this.gridParam).then((jobs: any) => {
        this.updateGridViewData(jobs);
      });
    }
  }

  toggleGridSearch(): void {
    this.openGridSearch = !this.openGridSearch;
    if(this.openGridSearch) {
      this._dispatchBoardService.trackEvent('grid_search');
    }
    if (!this.openGridSearch) {
      this.gridSearchKeyword = '';
      this.applyGridSearch(null, 'clear');
    }
  }

  updateDispatchJobSplitSettings(): void {
    const tablePosition = this.metaData?.grid.table_grid_position;
    if (this.gridViewType === 'tableView') {
      this.dispatchJobSplitSettings.grid.order = tablePosition === 'LEFT' ? 1 : 2;
      this.dispatchJobSplitSettings.scheduler.order = tablePosition === 'LEFT' ? 2 : 1;
      this.dispatchJobSplitSettings.orientation = tablePosition === 'LEFT' ? 'horizontal' : 'vertical';
    }
    if (this.gridViewType === 'tableView' && tablePosition === 'BOTTOM') {
      this.dispatchJobSplitSettings.grid.size = 50;
      this.dispatchJobSplitSettings.grid.minSize = 40;
      this.dispatchJobSplitSettings.grid.maxSize = 60;
    } else {
      this.dispatchJobSplitSettings.grid.order = 1;
      this.dispatchJobSplitSettings.scheduler.order = 2;
      this.dispatchJobSplitSettings.orientation = 'horizontal';
      this.dispatchJobSplitSettings.grid.size = this.isMapViewEnabled ? 28 : 23;
      this.dispatchJobSplitSettings.grid.minSize = this.isMapViewEnabled ? 25 : 20;
      this.dispatchJobSplitSettings.grid.maxSize = this.isMapViewEnabled ? 33 : 28;
    }
    this.dispatchJobSplitSettings.scheduler.size = 100 - this.dispatchJobSplitSettings.grid.size;
    if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
      this.dispatchJobSplitSettings.minSize = 45;
      this.dispatchJobSplitSettings.maxSize = 75;
      this.dispatchJobSplitSettings.map.maxSize = 50;
      this.dispatchJobSplitSettings.map.minSize = 25;
    } else {
      this.dispatchJobSplitSettings.minSize = 70;
      this.dispatchJobSplitSettings.maxSize = 80;
    }
    this.dispatchJobSplitSettings.grid.size = Math.max(this.dispatchJobSplitSettings.grid.minSize, Math.min(this.dispatchJobSplitSettings.grid.size, this.dispatchJobSplitSettings.grid.maxSize));
    this.dispatchJobSplitSettings.scheduler.size = 100 - this.dispatchJobSplitSettings.grid.size;
  }

  updateSplitVisibility(gutterIndex: number, position: 'left' | 'right') {
    const toggleState = this.dispatchJobSplitSettings.gutter.toggleState;
    const mapSettings = this.dispatchJobSplitSettings.map;
    const schedulerSettings = this.dispatchJobSplitSettings.scheduler;
    const gridSettings = this.dispatchJobSplitSettings.grid;

    const setMapSettings = (size: number, maxSize: number, minSize: number, visible: boolean) => {
      mapSettings.size = size;
      mapSettings.maxSize = maxSize;
      mapSettings.minSize = minSize;
      this.dispatchJobSplitSettings.visible.map = visible;
      this.triggerMapResize();
    };

    const setSchedulerSettings = (size: number, maxSize: number, minSize: number, visible: boolean) => {
      schedulerSettings.size = size;
      schedulerSettings.maxSize = maxSize;
      schedulerSettings.minSize = minSize;
      this.dispatchJobSplitSettings.visible.scheduler = visible;
    };

    switch (toggleState[gutterIndex]) {
      case 'left':
        if (position === 'right') {
          toggleState[gutterIndex] = 'neutral';
          setMapSettings(25, 30, 15, true);
          setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
        }
        break;
      case 'neutral':
        if (position === 'left') {
          toggleState[gutterIndex] = position;
          setMapSettings(80, 80, 70, true);
          setSchedulerSettings(0, 0, 0, false);
        } else if (position === 'right') {
          toggleState[gutterIndex] = position;
          setMapSettings(0, 0, 0, false);
        }
        break;
      case 'right':
        if (position === 'left') {
          toggleState[gutterIndex] = 'neutral';
          setMapSettings(25, 30, 15, true);
          setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
        }
        break;
    }

    if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
      this.dispatchJobSplitSettings.minSize = 45;
      this.dispatchJobSplitSettings.maxSize = 75;
      mapSettings.maxSize = 50;
      mapSettings.minSize = 25;
      setSchedulerSettings(50, 55, 45, true);
    } else {
      this.dispatchJobSplitSettings.minSize = 70;
      this.dispatchJobSplitSettings.maxSize = 80;
    }

    if (this.dispatchJobSplitSettings.visible.scheduler) {
      if (this.gridViewType === 'tableView' && this.metaData?.grid.table_grid_position === 'BOTTOM') {
        gridSettings.size = 50;
        gridSettings.minSize = 40;
        gridSettings.maxSize = 60;
      }
      else {
        gridSettings.size = toggleState[gutterIndex] === 'neutral' ? 30 : 22;
        gridSettings.minSize = toggleState[gutterIndex] === 'neutral' ? 25 : 18;
        gridSettings.maxSize = toggleState[gutterIndex] === 'neutral' ? 35 : 25;
      }
      setSchedulerSettings(100 - gridSettings.size, 100 - gridSettings.minSize, 100 - gridSettings.maxSize, true);
    } else {
      setSchedulerSettings(0, 0, 0, false);
      gridSettings.size = 100;
      gridSettings.minSize = 0;
      gridSettings.maxSize = 100;
    }

    this.dispatchJobSplitSettings.size = 100 - mapSettings.size;
    this.dispatchJobSplitSettings.maxSize = 100 - mapSettings.minSize;
    this.dispatchJobSplitSettings.minSize = 100 - mapSettings.maxSize;
  }

  resetSplitVisibility(gutterIndex: number): void {
    const toggleState = this.dispatchJobSplitSettings.gutter.toggleState;
    if (toggleState[gutterIndex] === 'left') {
      this.updateSplitVisibility(gutterIndex, 'right');
    }
    else if (toggleState[gutterIndex] === 'right') {
      this.updateSplitVisibility(gutterIndex, 'left');
    }
  }
  
  triggerMapResize(): void {
    if (this.mapResizeTimeout) {
      cancelAnimationFrame(this.mapResizeTimeout);
    }
    this.mapResizeTimeout = requestAnimationFrame(() => {
      this._mapService.mapResizeIndicator.next(true);
    });
  }

  updateGridPageNumber(event: any): void {
    if (event?.keyCode === 13) {
      if (this.gridPageNumber.length === 0 || Number(this.gridPageNumber) === 0) {
        this.gridPageNumber = '1';
      }
      if (Number(this.gridPageNumber) > this.totalGridPage) {
        this.gridPageNumber = this.totalGridPage.toString();
      }
      if (this.gridParam['page'] !== Number(this.gridPageNumber)) {
        this.gridParam['page'] = this.gridPageNumber;
        this.getGridData(this.gridParam).then((jobs: any) => {
          this.updateGridViewData(jobs);
        });
      }
    }
  }

  onTeamSearch(): void {
    if (this.teamSearchPagination.currentPage !== this.teamSearchPagination.totalPage || this.teamSearchPagination.filterUid) {
      this.teams = this.teamValueSubject.pipe(
        distinctUntilChanged(),
        debounceTime(500),
        switchMap((term: any) => {
          if (!_.isNil(term)) {
            this.teamSearchPagination.keyword = term;
            this.teamSearchPagination.currentPage = 1;
            this.teamSearchPagination.filterUid = '';
            if (term?.trim().length === 0) {
              this.teamSearchPagination.keyword = '';
            }
            return this.getTeams();
          }
          else {
            return of(this.teamPickerList);
          }
        })
      );
    }
  }

  onServiceTerritorySearch(): void {
    if (this.territorySearchPagination.currentPage !== this.territorySearchPagination.totalPage || this.territorySearchPagination.filterUid) {
      this.serviceTerritories = this.serviceTerritoryValueSubject.pipe(
        distinctUntilChanged(),
        debounceTime(500),
        switchMap((term: any) => {
          if (!_.isNil(term)) {
            this.territorySearchPagination.keyword = term;
            this.territorySearchPagination.currentPage = 1;
            this.territorySearchPagination.filterUid = '';
            if (term?.trim().length === 0) {
              this.territorySearchPagination.keyword = '';
            }
            return this.getServiceTerritory();
          }
          else {
            return of(this.serviceTerritoryPickerList);
          }
        })
      );
    }
  }

  onTeamPickerOpen(): void {
    if (this.teamSearchPagination.filterUid && this.selectedTeam) {
      this.teamSearchPagination.currentPage = 1;
      this.teamSearchPagination.filterUid = '';
      this.teamSearchPagination.keyword = '';
      this.getTeams().subscribe((teams: any) => {
        this.teams = of(_.unionBy(teams, this.teamPickerList, 'team_uid'));
      });
    }
  }

  onServiceTerritoryPickerOpen(): void {
    if (this.territorySearchPagination.filterUid && this.selectedServiceTerritory) {
      this.territorySearchPagination.currentPage = 1;
      this.territorySearchPagination.filterUid = '';
      this.territorySearchPagination.keyword = '';
      this.getServiceTerritory().subscribe((territories: any) => {
        this.serviceTerritories = of(_.unionBy(territories, this.serviceTerritoryPickerList, 'territory_uid'));;
      });
    }
  }

  teamPickerScrollToEnd(): any {
    if (this.teamSearchPagination.currentPage < this.teamSearchPagination.totalPage) {
      this.teamSearchPagination.currentPage += 1;
      this.getTeams().subscribe(() => {
        this.teams = of(_.uniqBy(this.teamPickerList, 'team_uid'));
      });

    }
  }

  serviceTerritoryPickerScrollToEnd(): any {
    if (this.territorySearchPagination.currentPage < this.territorySearchPagination.totalPage) {
      this.territorySearchPagination.currentPage += 1;
      this.getServiceTerritory().subscribe(() => {
        this.serviceTerritories = of(_.uniqBy(this.serviceTerritoryPickerList, 'territory_uid'));
      });

    }
  }

  changeGridJobType(): void {
    if (this.gridTbar.jobType === 'UNSCHEDULED') {
      if (this.sortOptions.grid.sort_by === 'scheduled_start_time') {
        this.sortOptions.grid.sort_by = 'due_date';
      }
    }
    this.gridParam['page'] = 1;
    this.gridParam['type'] = this.gridTbar.jobType;
    this.getGridData(this.gridParam).then((jobs: any) => {
      this.updateGridViewData(jobs);
      this.gridPageNumber = '1';
    });
  }

  updateGridViewData(jobs): void {
    this.suspendAllGridEvents();
    if (this.gridViewType === 'listView') {
      this.cardData = jobs;
    }
    else if (this.gridViewType === 'tableView') {
      this.updateTableContent(jobs);
    }
    this.resumeAllGridEvents();
  }

  gridPageIncrement(type: 'next' | 'prev'): void {
    const updatedPageNumber = type === 'next' ? Number(this.gridPageNumber) + 1 : Number(this.gridPageNumber) - 1;
    if (updatedPageNumber > 0 && updatedPageNumber <= this.totalGridPage) {
      this.gridParam['page'] = updatedPageNumber.toString();
      this.getGridData(this.gridParam).then((jobs: any) => {
        this.gridPageNumber = updatedPageNumber.toString();
        this.updateGridViewData(jobs);
      });
    }
  }

  schedulerDateIncrement(type: 'next' | 'prev'): void {
    let fromDate: Moment;
    let toDate: Moment;
    if (this.currentView === 'DAY') {
      fromDate = this.schedulerFormGroup.get('schedulerDate')?.value;
      if (type === 'next') {
        fromDate = fromDate.add(1, 'day');
      }
      else if (type === 'prev') {
        fromDate = fromDate.subtract(1, 'day');
      }
      this.schedulerFormGroup.get('schedulerDate').setValue(fromDate);
      this.onSchedulerDateChange();
    }
    else if (this.currentView === 'WEEK') {
      fromDate = this.schedulerFormGroup.get('scheduleStartDate')?.value;
      toDate = this.schedulerFormGroup.get('scheduleEndDate')?.value;
      if (type === 'next') {
        fromDate = fromDate.add(1, 'week');
        toDate = toDate.add(1, 'week');
      }
      else if (type === 'prev') {
        fromDate = fromDate.subtract(1, 'week');
        toDate = toDate.subtract(1, 'week');
      }
      this.schedulerFormGroup.get('scheduleStartDate').setValue(fromDate);
      this.schedulerFormGroup.get('scheduleEndDate').setValue(toDate);
      this.onSchedulerDateRangeChange();
    }
    else if (this.currentView === 'MONTH') {
      fromDate = this.schedulerFormGroup.get('scheduleStartDate')?.value;
      toDate = this.schedulerFormGroup.get('scheduleEndDate')?.value;
      if (type === 'next') {
        fromDate = fromDate.add(1, 'month');
        toDate = toDate.add(1, 'month');
      }
      else if (type === 'prev') {
        fromDate = fromDate.subtract(1, 'month');
        toDate = toDate.subtract(1, 'month');
      }
      this.schedulerFormGroup.get('scheduleStartDate').setValue(fromDate);
      this.schedulerFormGroup.get('scheduleEndDate').setValue(toDate);
      this.onSchedulerDateRangeChange();
    }
  }

  applyGridSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.gridSearchKeyword.trim();
      const oldFilterKeyword = this._dispatchBoardService.getFilterValue('keyword', this.gridParam?.filter_rules) || '';
      if (oldFilterKeyword !== searchKeyword) {
        this.gridParam['filter_rules'] = this._dispatchBoardService.addSearchKeywordFilterRule(searchKeyword, this.gridParam['filter_rules']);
        this.gridParam['page'] = 1;
        this.getGridData(this.gridParam).then((jobs: any) => {
          this.gridPageNumber = '1';
          this.updateGridViewData(jobs);
        });
      }
    }
  }

  applySchedulerSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.schedulerSearchKeyword.trim();
      this.appliedSchedulerSearchKeyword = searchKeyword;
      if (this.schedulerInstance) {
        if (searchKeyword) {
          this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
          this.schedulerInstance.eventStore.filter({
            id: 'schedulerEventSearch',
            filterBy: (eventDetails: any) => eventDetails?.name?.toLowerCase().includes(searchKeyword.toLowerCase())
          });
        }
        else {
          this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
        }
      }
    }
  }

  resetEmployeeSearch(): void {
    if (this.employeeSearchKeyword || this.appliedEmployeeSearchKeyword) {
      this.employeeSearchKeyword = '';
      this.appliedEmployeeSearchKeyword = '';
      if (this.schedulerInstance) {
        this.schedulerInstance.resourceStore.removeFilter('userSearch');
      }
      if (this.employeeSearchTippy) {
        this.employeeSearchTippy.props.onHide(this.employeeSearchTippy)
      }
    }
  }

  resetEventSearch(): void {
    if (this.schedulerSearchKeyword || this.appliedSchedulerSearchKeyword) {
      this.schedulerSearchKeyword = '';
      this.appliedSchedulerSearchKeyword = '';
      if (this.schedulerInstance) {
        this.schedulerInstance.eventStore.removeFilter('schedulerEventSearch');
      }
      if (this.schedulerSearchTippyInstance) {
        this.schedulerSearchTippyInstance.props.onHide(this.schedulerSearchTippyInstance)
      }
    }
  }

  applyEmployeeSearch(event: any, action?: string): void {
    if (event?.keyCode === 13 || action === 'clear') {
      const searchKeyword = this.employeeSearchKeyword.trim();
      this.appliedEmployeeSearchKeyword = searchKeyword;
      if (this.schedulerInstance) {
        if (searchKeyword) {
          this.schedulerInstance.resourceStore.removeFilter('userSearch');
          this.schedulerInstance.resourceStore.filter({
            id: 'userSearch',
            filterBy: (resource: any) => resource?.name?.toLowerCase().includes(searchKeyword.toLowerCase())
          });
        }
        else {
          this.schedulerInstance.resourceStore.removeFilter('userSearch');
        }
      }
    }
  }

  getGridJobType(): string {
    return this.gridParam?.type;
  }

  createDragerInstance(dragConfig: Partial<DragHelperConfig>): DragHelper {
    return new DragHelper(dragConfig);
  }

  getMapRoutes(): void {
    if (this.currentView === 'WEEK' || this.currentView === 'MONTH' || !this.metaData?.map?.layers.routes || !this.metaData?.map?.enable_map_view) {
      this._mapService.routeLocationData.next([]);
      return;
    }

    if (this.metaData?.map.enable_map_view) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const routesCountparams = { from_date: this.schedulerParams?.from_date, to_date: this.schedulerParams?.to_date };
      this._dataCollectorService.getData(this._dispatchBoardService.routesCountUrl, routesCountparams)
        .subscribe((response) => {
          const routesCount = response?.data;
          const totalJobCount = _.sumBy(routesCount, 'job_routes');
          if (totalJobCount > 0) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.mapParams = { 'from_date': this.schedulerParams?.from_date, 'to_date': this.schedulerParams?.to_date, 'page': 1, 'count': totalJobCount, 'filter.team_uid': this.selectedTeam || '' };
            this._dataCollectorService.getData(this._dispatchBoardService.routesDataUrl, this.mapParams)
              .subscribe((routeResponse: any) => {
                this.mapRouteData = routeResponse || { data: []};
                this.updateMapRouteFilter();
              });
          }
          else {
            this.updateMapRouteFilter();
          }
        });
    }
  }

  updateMapRouteFilter(): void {
    if (this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      const dispatchFilters = this.getDispatchFilterValues();
      const routeFilterUids: any[] = dispatchFilters.filterOptions.map['filter.route_uid'] || [];
      if(this.isMapViewEnabled && this.metaData?.map?.layers.routes && this.mapRouteData?.data?.length) {
        if (routeFilterUids?.length) {
          const selectedRoutes = { data: [] };
          selectedRoutes.data = this.mapRouteData?.data.filter((route: any) => routeFilterUids.includes(route?.route_uid));
          this._mapService.routeLocationData.next(selectedRoutes);
          this.setFilterCount('map', selectedRoutes.data.length);
        }
        else{
          this._mapService.routeLocationData.next(this.mapRouteData);
          this.setFilterCount('map', 0);
        }
      }
      else {
        this._mapService.routeLocationData.next([]);
        this.setFilterCount('map', 0);
      }
    }
  }

  getGridDataParam(page: number, count: number, type: string): Object {
    return { page: page, count: count, type: type, ...this.sortOptions?.grid, ...this.gridFilterOptions };
  }

  openSettingsDialog(moduleName: string): void {
    this.toggleMapLegendBar(false, null, true);
    this.settingsDialogdata['module'] = moduleName;
    this.settingsDialogdata['tab'] = this.selectedDispatchTab;
    this.settingsDialogdata['moduleAccess'] = this.moduleAccess;
    this.settingsDialogdata['display'] = { grid: true, employee: true, scheduler: true, map: true };
    this._dispatchBoardService.trackEvent('settings_' + moduleName);
    this._sharedService.settingsDialogInstance = this._zuperDialogService.openCustom(SettingsComponent, {
      data: this.settingsDialogdata,
      extraClass: ['w-fit', 'overflow-hidden']
    });
    this._sharedService.settingsDialogInstance.afterClosed()
      .subscribe((dialogData: any) => {
        if (dialogData?.openColorProfile) {
          this.openColorProfileDrawer();
        }
        else {
          this.updateSettings(dialogData);
        }
      });
  }

  updateMapLayersData(skipGetRoutes: boolean = false, oldMetaData?: any, newMetaData?: any, changedLayers?: any, forceUpdate?: boolean): void {
    setTimeout(() => {
      if (this.isMapViewEnabled) {
        let isValueChanged: boolean = false;
        if (_.isEmpty(changedLayers)) {
          [isValueChanged, changedLayers] = this._dispatchBoardService.isMapLayerChanged(oldMetaData, newMetaData);
        }
        else {
          isValueChanged = true;
        }
        if ((newMetaData?.map?.layers && oldMetaData?.map?.layers) || changedLayers || forceUpdate) {
          if (isValueChanged && changedLayers?.nearby_jobs && !newMetaData?.map?.layers?.nearby_jobs) {
            this._dispatchBoardService.jobLocationMapData.JOBS.nearByJob = [];
          }
          if (changedLayers?.jobs || forceUpdate) {
            this._dispatchBoardService.injectJobLocationMapData('JOBS', null, this.metaData, null, false, true);
          }  
          if (!skipGetRoutes && changedLayers?.routes) {
            this.getMapRoutes();
          }
          if (changedLayers?.users) {
            this.getEmployeeLocationData(this.schedulerEmployees?.length);
          }
          if (changedLayers?.service_territories || forceUpdate) {
            this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
          }
          if ((isValueChanged && (changedLayers?.assets || changedLayers?.customers || changedLayers?.jobs || changedLayers?.organizations || changedLayers?.properties || changedLayers?.nearby_jobs)) || forceUpdate) {
            this._dispatchBoardService.getNearByData(this.metaData).then((nearByData: any) => {
              this._dispatchBoardService.injectNearByMapData(this.metaData, nearByData, 'JOBS');
            });
          }
        }
        else {
          this._dispatchBoardService.getNearByData(this.metaData).then((nearByData: any) => {
            this._dispatchBoardService.injectNearByMapData(this.metaData, nearByData, 'JOBS');
          });
        }
      }
    }, 300);
  }

  calculateMapLegendVisibleItems(): void {
    if (!this.mapLegendWrapperRef) { return; }
    const container = this.mapLegendWrapperRef?.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const previousExtraCount: number = this.mapLegendData.extraCount;
    let totalWidth = 0;
    let visibleCount = 0;
    let lastElement: any = null;
    this.mapLegendItems.forEach((item) => {
      const element = item.nativeElement;
      const itemRect = element.getBoundingClientRect();
      const itemWidth = itemRect.width;
      if (totalWidth + itemWidth <= containerWidth && itemRect.right <= containerRect.right) {
        totalWidth += itemWidth;
        element.style.display = 'inline-block';
        lastElement = element;
        visibleCount++;
      } else {
        element.style.display = 'none';
      }
    });
    this.mapLegendData.extraCount = this.mapLegendData.legendDetails?.length - visibleCount || 0;
    if (this.mapLegendData.extraCount && (!!previousExtraCount !== !!this.mapLegendData.extraCount)) {
      if (lastElement) {
        lastElement.style.display = 'none';
        this.mapLegendData.extraCount += 1;
      }
    }
    else {
      this.mapLegendData.extraCount = this.mapLegendData.legendDetails?.length - visibleCount || 0;
    }
  }

  //Update settings
  updateSettings(metaData: any): void {
    this.suspendAllSchedulerEvents({resource: true, event: true });
    this.suspendAllGridEvents();
    if (!metaData) {
      metaData = this.metaData;
    }
    const oldMetaData = _.cloneDeep(this.metaData);
    if (metaData) {
      this.metaData = this._templateService.updateTemplateMetaDataFromLocal();
      if (this._dispatchBoardService.activeDispatchTab === 'JOBS') {
        if (!metaData?.map.layers.jobs) {
          this._dispatchBoardService.enableMapLayerByDefault.jobs = false;
        }
        if (!metaData?.map.layers?.service_territories) {
          this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
        }
      }
      this.updateMetaData(this.metaData);
      this.calculateSchedulerHeight();
      this.updateSchedulerSettings(this.metaData?.scheduler);
      this.isMapViewEnabled = this.metaData?.map?.enable_map_view;
      const [isMapLayerChanged, changedLayers] = this._dispatchBoardService.isMapLayerChanged(oldMetaData, metaData);
      if (isMapLayerChanged) {
        this.updateMapLayersData(false, oldMetaData, this.metaData, changedLayers);
      }
      if(oldMetaData?.scheduler?.display.duration_between_jobs !== this.metaData?.scheduler?.display.duration_between_jobs ||
        oldMetaData?.scheduler?.mode_of_transport !== this.metaData?.scheduler?.mode_of_transport ) {
        this.setDistanceBetweenJobs();
      }
      if (this.gridParam.count !== metaData?.grid?.job_count) {
        this.gridParam.count = metaData?.grid?.job_count || 10;
        this.gridParam.page = 1;
        this.gridPageNumber = '1';
        if (metaData?.grid.view_type === this.gridViewType) {
          this.getGridData(this.gridParam).then((jobs: any) => {
            this.updateGridViewData(jobs);
          });
        }
      }

      if (this.metaData?.grid.view_type !== oldMetaData?.grid.view_type) {
        this.gridViewType = this.metaData?.grid.view_type;
        this.gridParam.sort_by = this.sortOptions.grid?.sort_by;
        this.gridParam.sort = this.sortOptions.grid?.sort;
        this.gridParam.page = 1;
        this.gridPageNumber = '1';
        this.getGridData(this.gridParam).then((jobs: any) => {
          this.updateGridViewData(jobs);
        });

        setTimeout(() => {
          this.setGridSchedulerInstance();
          this.dragInstance?.destroy();
          this.initiateDragHelper(this.gridViewType);
        }, 100);
      }
      else {
        this.setGridSchedulerInstance();
        this.reRenderGridData();
      }
      if (this.gridViewType === 'tableView') {
        this.updateTableColumns();
      }

      //Update gutter split settings to default if grid position is changed
      this.updateDispatchJobSplitSettings();
      if (this.metaData?.grid?.table_grid_position !== oldMetaData?.grid?.table_grid_position || (this.metaData?.grid?.table_grid_position === 'BOTTOM' && this.metaData?.grid.view_type === 'listView')) {
        this.resetSplitVisibility(1);
      }
      this.resumeAllGridEvents();
      this.resumeAllSchedulerEvents({resource: true, event: true });
    }
  }

  reRenderGridData(): void {
    this.setGridSchedulerInstance();
    if (this.gridViewType === 'tableView') {
      this.updateTableContent(this.gridData);
    }
    else if (this.gridViewType === 'listView') {
      this.cardViewInstance?.renderContents();
    }
  }

  setGridSchedulerInstance(): void {
    if (this.gridViewType === 'listView' && (!this.cardViewInstance || this.cardViewInstance?.isDestroyed)) {
      this.cardViewInstance = this.cardViewComponent?.instance;
    }
    else if (this.gridViewType === 'tableView' && (!this.tableViewInstance || this.tableViewInstance?.isDestroyed)) {
      this.tableViewInstance = this.tableViewComponent?.instance;
    }
    this.gridViewInstance = this.gridViewType === 'listView' ? this.cardViewInstance : this.tableViewInstance;
    if (!this.schedulerInstance || this.schedulerInstance?.isDestroyed) {
      this.schedulerInstance = this.schedulerProComponent?.instance;
    }
  }

  //Update Card/Table/Scheduler view's local data
  updateLocalRecordsAfterChanges(job: any, action: 'update' | 'delete', updateScheduler: boolean = false, schedulerEventRefresh: boolean = true): void {
    this.suspendAllGridEvents();
    this.suspendAllSchedulerEvents({ event: true });
    try {
      let gridData = _.cloneDeep(this.gridData);
      if (action === 'update') {
        const jobUid = job?.job_uid;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const gridDataIndex = _.findIndex(gridData, { 'job_uid': jobUid });
        if (gridDataIndex !== -1) {
          gridData.splice(gridDataIndex, 1);
          gridData.splice(gridDataIndex, 0, job);
          this._dispatchBoardService.setGridRecords(gridData);
          this.updateGridViewData(gridData);
        }
        this.schedulerJobs = this.schedulerJobs.filter((_job: any) => _job.job_uid !== jobUid);
        this.schedulerJobs.push(job);

        if (updateScheduler) {
          this.schedulerProConfig.events = this.schedulerProConfig.events.map((event: any) => {
            if (event.job_uid === jobUid) {
              event = _.merge(event, job);
              event.name = this._dispatchBoardService.getJobTitle(job?.prefix, job?.work_order_number, job?.job_title);
              event.startDate = moment(job.scheduled_start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
              event.endDate = moment(job.scheduled_end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
            }
            return event;
          });
          if (schedulerEventRefresh) {
            const existingEvent = this.schedulerInstance.eventStore.getById(jobUid);
            if (existingEvent) {
              /* eslint-disable @typescript-eslint/naming-convention */
            existingEvent.set({
              scheduled_start_time: job.scheduled_start_time,
              scheduled_end_time: job.scheduled_end_time,
              startDate: moment(job.scheduled_start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'),
              endDate: moment(job.scheduled_end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'),
              assigned_to: job.assigned_to,
              job_priority: job.job_priority,
              due_date: job.due_date,
              color_profile: job?.color_profile,
              job_tags: job.job_tags
            });
              /* eslint-enable @typescript-eslint/naming-convention */
          }
        }
        this.updateSchedulerMasterRecords(jobUid, job);
        this._dispatchBoardService.injectJobLocationMapData('JOBS', 'gridJob', this.metaData, gridData);
        this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', this.metaData, this.schedulerJobs);
        this.schedulerInstance?.refresh();
      }
    }
    else if (action === 'delete') {
      const jobUid = job?.job_uid;

        //Delete grid event
        gridData = gridData.filter((_job: any) => _job.job_uid !== jobUid);
        this._dispatchBoardService.setGridRecords(gridData);
        this.schedulerJobs = this.schedulerJobs.filter((_job: any) => _job.job_uid !== jobUid);

        //Delete scheduler event
        let allEvents = this.schedulerProConfig.events;
        allEvents = allEvents.filter((event: any) => event.job_uid !== jobUid);
        this.schedulerInstance.eventStore.remove(jobUid);
        this.schedulerProConfig.events = allEvents;

        //Delete assignments
        let allAssignments: any = this.schedulerProConfig.assignments;
        allAssignments = allAssignments.filter(assignment => assignment.id?.indexOf(job.job_uid + '_') === -1);
        this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
        this.schedulerProConfig.assignments = allAssignments;
        this.setDistanceBetweenJobs();
        this.upadteCustomEmployeeDetails();
      }
      this.gridData = gridData;
    }
    finally {
      this.resumeAllSchedulerEvents({ event: true });
      this.resumeAllGridEvents();
    }
  }

  updateLocalRecordsAfterNonJobEventChanges(nonJobEvent: any, action: 'update' | 'delete', updateScheduler: boolean = false, schedulerEventRefresh: boolean = true): void {
    this.suspendAllSchedulerEvents({ event: true });
    if (action === 'update') {
      const nonJobEventUid = nonJobEvent?.event_uid;
      this.schedulerNonJobEvents = this.schedulerNonJobEvents.filter((_job: any) => _job.event_uid !== nonJobEventUid);
      this.schedulerNonJobEvents.push(nonJobEvent);
      this.upadteCustomEmployeeDetails();
      if (updateScheduler) {
        this.schedulerProConfig.events = this.schedulerProConfig.events.map((event: any) => {
          if (event.event_uid === nonJobEventUid) {
            event = _.merge (event, nonJobEvent);
            event.startDate = moment(nonJobEvent.start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
            event.endDate = moment(nonJobEvent.end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
            if (event?.recurrence) {
              event.recurrence = nonJobEvent?.recurrence;
            }
          }
          return event;
        });
        if (schedulerEventRefresh) {
          const existingEvent = this.schedulerInstance.eventStore.getById(nonJobEventUid);
          if (existingEvent) {
            /* eslint-disable @typescript-eslint/naming-convention */
            existingEvent.set({
              start_time : nonJobEvent.start_time,
              end_time : nonJobEvent.end_time,
              startDate : moment(nonJobEvent.start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'),
              endDate : moment(nonJobEvent.end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss'),
              assigned_to : nonJobEvent.assigned_to,
              is_available : nonJobEvent.is_available,
              event_address : nonJobEvent.event_address,
              event_description : nonJobEvent.event_description,
              event_name : nonJobEvent.event_name,
              timezone : nonJobEvent.timezone,
              is_recurrence : nonJobEvent.is_recurrence,
              event_category : nonJobEvent.event_category,
              recurrence : nonJobEvent?.recurrence
            });
            /* eslint-enable @typescript-eslint/naming-convention */
          }
        }
      }
    }
    else if (action === 'delete') {
      const eventUid = nonJobEvent?.event_uid;
      this.schedulerNonJobEvents = this.schedulerNonJobEvents.filter((event: any) => event.event_uid !== eventUid);
      this.upadteCustomEmployeeDetails();

      //Delete scheduler event
      let allEvents = this.schedulerProConfig.events;
      allEvents = allEvents.filter((event: any) => event.event_uid !== eventUid);
      this.schedulerInstance.eventStore.remove(eventUid);
      this.schedulerProConfig.events = allEvents;

      //Delete assignments
      let allAssignments: any = this.schedulerProConfig.assignments;
      allAssignments = allAssignments.filter((assignment: any) => assignment.id?.indexOf(nonJobEvent.event_uid + '_') === -1);
      this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
      this.schedulerProConfig.assignments = allAssignments;
    }
    this.resumeAllSchedulerEvents({ event: true });
  }

  updateSchedulerAssignement(job: any): void {
    this.suspendAllSchedulerEvents({ assignment: true });
    const jobUid = job?.job_uid;
    const allEvents = this.schedulerProConfig.events;
    _.forEach(allEvents, (event: any) => {
      if (event.job_uid === jobUid) {
        event.assigned_to = job.assigned_to;
      }
    });
    this.schedulerProConfig.events = allEvents;
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  updateNonJobEventSchedulerAssignement(nonJobEvent: any): void {
    this.suspendAllSchedulerEvents({ assignment: true });
    const nonJobEventUid = nonJobEvent?.event_uid;
    const allEvents = this.schedulerProConfig.events;
    _.forEach(allEvents, (event: any) => {
      if (event.event_uid === nonJobEventUid) {
        event.assigned_to = nonJobEvent.assigned_to;
      }
    });
    this.schedulerProConfig.events = allEvents;
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  upadteCustomEmployeeDetails(): void {
    const startDate = moment(this.schedulerParams?.from_date, 'YYYY-MM-DD').startOf('day');
    const endDate = moment(this.schedulerParams?.to_date, 'YYYY-MM-DD').endOf('day');
    this.customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsLocal(startDate, endDate, this.schedulerEmployees, this.schedulerJobs, this.schedulerNonJobEvents);
  }

  updateTimeOffInLocalRecords(action: 'add' | 'delete', userUid: any, timeOffDetails: any): void {
    this.schedulerEmployees = this.schedulerEmployees.map((user: any) => {
      if (user.user_uid === userUid && user?.timeoff_request?.length) {
        user.timeoff_request = user.timeoff_request.filter((requestDetail: any) => requestDetail.request_uid !== timeOffDetails.request_uid);
        if(action === 'add') {
          user.timeoff_request.push(timeOffDetails);
        }
      }
      return user;
    });
    this.upadteCustomEmployeeDetails();
  }

  //Update Scheduler records in shared service to render updated scheduler template
  updateSchedulerMasterRecords(jobUid: any, updatedJob: any): void {
    const schedulerRecords: any[] = this._dispatchBoardService.getSchedulerRecords();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const recordIndex = _.findIndex(schedulerRecords, { 'job_uid': jobUid });
    if (recordIndex === -1) {
      schedulerRecords.push(updatedJob);
      this._dispatchBoardService.setSchedulerRecords(schedulerRecords);
      return;
    }
    schedulerRecords[recordIndex] = _.merge (schedulerRecords[recordIndex], updatedJob);
    this._dispatchBoardService.setSchedulerRecords(schedulerRecords);
    this.upadteCustomEmployeeDetails();
  }

  //Create and update new Event and Rescouces when new job is dragged into scheduler
  createNewSchedulerResourceAndEvent(jobDetails: any, userDetails: any, scheduledStartTime: any, scheduledEndTime: any, teamUid?: string, skipUpdateScheduledTime: boolean = false, skipAssignmentUpdate: boolean = false): any {
    this.suspendAllSchedulerEvents({ assignment: true });
    const assignedTo = {
      user: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        user_uid: userDetails?.user_uid, first_name: userDetails?.first_name, last_name: userDetails?.last_name
      },
      team: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        team_uid: teamUid ? teamUid : this.selectedTeam
      }
    };
    const isUserAlreadyExist = jobDetails?.assigned_to.filter((assignee: any) => assignee?.user.user_uid === userDetails?.user_uid).length !== 0;
    if (!isUserAlreadyExist) {
      jobDetails?.assigned_to?.push(assignedTo);
    }
    const createNewEvent = this.schedulerProConfig.events?.filter((event: any) => event.id === jobDetails?.job_uid).length === 0;
    if (!skipUpdateScheduledTime) {
      this.schedulerProConfig.events = this._dispatchBoardService.updateJobEventsScheduleDateTime(this.schedulerProConfig.events, jobDetails?.job_uid, scheduledStartTime, scheduledEndTime);
    }
    const newEvent = this._dispatchBoardService.createSchedulerJobEvent(jobDetails, scheduledStartTime, scheduledEndTime);

    if (createNewEvent) {
      const allEvents: Object[] = this.schedulerProConfig.events;
      allEvents.push(newEvent);
      this.schedulerProConfig.events = allEvents;
      this.schedulerInstance.eventStore.add(newEvent);
      if (this.schedulerInstance?.eventStore?.allRecords?.length === 1) {
        this.setSchedulerStartEndDate(this.currentView, false, false, false);
      }
    }

    this.updateLocalRecordsAfterChanges(newEvent, 'update', true);
    if (!skipAssignmentUpdate) {
      this.updateEventSchedulerAssignment(jobDetails, 'job');
    }
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  createNewSchedulerNonJobEvent(nonJobEventDetails: any, userDetails: any, eventStartTime: any, eventEndTime: any, teamUid?: string, skipAssignmentUpdate: boolean = false): any {
    this.suspendAllSchedulerEvents({ assignment: true });
    const assignedTo = {
      user: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        user_uid: userDetails?.user_uid, first_name: userDetails?.first_name, last_name: userDetails?.last_name
      },
      team: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        team_uid: teamUid ? teamUid : this.selectedTeam
      }
    };
    const isUserAlreadyExist = nonJobEventDetails?.assigned_to.filter((assignee: any) => assignee?.user.user_uid === userDetails?.user_uid).length !== 0;
    if (!isUserAlreadyExist) {
      nonJobEventDetails?.assigned_to?.push(assignedTo);
    }
    const createNewEvent = this.schedulerProConfig.events?.filter((event: any) => event.id === nonJobEventDetails?.event_uid).length === 0;
    const newEvent = this._dispatchBoardService.createSchedulerNonJobEvent(nonJobEventDetails, eventStartTime, eventEndTime);
    if (createNewEvent) {
      this.schedulerProConfig.events.push(newEvent);
      this.schedulerInstance.eventStore.add(newEvent);
      if (this.schedulerInstance?.eventStore?.allRecords?.length === 1) {
        this.setSchedulerStartEndDate(this.currentView, false, false, false);
      }
    }

    this.updateLocalRecordsAfterNonJobEventChanges(newEvent, 'update', true);
    if (!skipAssignmentUpdate) {
      this.updateEventSchedulerAssignment(nonJobEventDetails, 'nonJobEvent');
    }
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  updateEventSchedulerAssignment(eventDetails: any, type: 'job' | 'nonJobEvent'): void {
    this.suspendAllSchedulerEvents({ assignment: true });
    let eventUid: string;
    let newAssignments: any[];
    if (type === 'job') {
      eventUid = eventDetails?.job_uid;
      newAssignments = _.uniqBy(this._dispatchBoardService.createJobAssignmentRecord(eventDetails), 'id');
    }
    else if (type === 'nonJobEvent') {
      eventUid = eventDetails?.event_uid;
      newAssignments = _.uniqBy(this._dispatchBoardService.createNonJobAssignmentRecord(eventDetails), 'id');
    }
    const allAssignments: Object[] = this.schedulerProConfig.assignments;
    const oldAssignmentsIds: any[] = allAssignments.filter((assignment: any) => assignment.eventId === eventUid).map((assignment: any) => assignment.id);
    const newAssignmentsIds: any[] = newAssignments.map((assignment: any) => assignment.id);
    const removedAssigmentIds: any[] = _.difference(oldAssignmentsIds, newAssignmentsIds);
    newAssignments?.forEach((assignment: any) => {
      const isAlreadyExist = !this._utilityService.isEmptyOrUndefined(_.find(allAssignments, { 'id': assignment?.id }));
      if (!isAlreadyExist) {
        this.schedulerProConfig.assignments.push(assignment);
        this.schedulerInstance.assignmentStore.add(assignment);
      }
    });
    removedAssigmentIds.forEach((removedId: any) => {
      _.remove(this.schedulerProConfig.assignments, {'id': removedId});
      this.schedulerInstance.assignmentStore.remove(removedId);
    });
    this.resumeAllSchedulerEvents({ assignment: true });
  }

  getDefaultMetaSettings(): any {
    if (!this._sharedService.gridForm?.value) {
      return {};
    }
    const gridData = this._sharedService.gridForm.value || {};
    const schedulerData = this._sharedService.schedulerForm.value || {};
    const employeeData = this._sharedService.employeeForm.value || {};
    const mapData = this._sharedService.mapForm.value || {};
    return { 'grid': gridData, 'scheduler': schedulerData, 'employee': employeeData, 'map': mapData };
  }

  setDefaultMetaData(): any {
    let settingsData: Object;
    const localMetadata = this._dispatchBoardService.getLocalMetaData();
    if (!this._utilityService.isEmptyOrUndefined(localMetadata)) {
      settingsData = localMetadata;
    }
    else {
      settingsData = this.getDefaultMetaSettings();
      this._localStorageService.setLocalStorage('dispatch_board_metadata', settingsData);
    }
    settingsData = this._dispatchBoardService.metaFeatureGuard(settingsData);
    this.updateMetaData(settingsData);
    return settingsData;
  }

  setDefaultFilters(): void {
    let dispatchFilterValues = this._localStorageService.getLocalStorage('dispatch_board_advance_filter');
    if (!dispatchFilterValues) {
      dispatchFilterValues = this.defaultFilterOptions;
      this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchFilterValues);
    }
    const filters = dispatchFilterValues.job;
    if (filters) {
      this.schedulerParams['filter_rules'] = filters?.filterOptions.scheduler || [];
      this.schedulerParams['employee_filter_rules'] = filters?.filterOptions.employee || [];
      this.gridFilterOptions = filters?.filterOptions.grid;
    }
  }

  getMetaData(): void {
    const params = {
      module: 'SCHEDULE',
      key: 'DISPATCH_BOARD_V3'
    };
    this.territorySearchPagination.isLoading = true;
    this.teamPickerLoading = true;
    this.quickFilterLoading = true;
    this._dataCollectorService.getData(this._dispatchBoardService.metaDataUrl, params)
      .subscribe(async (response: any) => {
        this.settingsDialogdata = {};
        this.metaData = response['data']?.[0]['value'] ? JSON.parse(response['data']?.[0]['value']) : {};
        if (!this.metaData?.grid) {
          this.metaData = this.setDefaultMetaData();
          this.gridParam = this.defaultGridPreference;
          this.settingsDialogdata['newToDispatchBoard'] = true;
        }
        this.metaData = _.merge({}, this.getDefaultMetaSettings(), this.metaData);
        this.metaData = this._dispatchBoardService.metaFeatureGuard(this.metaData);
        this.metaData = await this._dispatchBoardService.sanitizeTemplateMetaData(this.metaData);
        this.updateMetaData(this.metaData);
        this._localStorageService.setLocalStorage('dispatch_board_metadata', this.metaData);
        this._templateService.updateTemplateMetaDataFromLocal();
        this.gridViewType = this.metaData?.grid.view_type;
        this.isMapViewEnabled = this.metaData?.map?.enable_map_view;
        this.gridViewInstance = this.gridViewType === 'listView' ? this.cardViewInstance : this.tableViewInstance;
        this.gridParam.count = this.metaData?.grid?.job_count || 10;
        this.calculateSchedulerHeight();
        this.updateDispatchJobSplitSettings();
        this.updateSchedulerSettings(this.metaData?.scheduler);
        this.initiateDragHelper(this.gridViewType);
        this.loadSchedulerData();
      });
  }

  loadSchedulerData(): void {
    if (this.isSchedulerInitialLoad) {
      this.serviceTerritories = this.getServiceTerritory(true).pipe(shareReplay(1));
      const quickFilter$ = this.getQuickFilters(true).pipe(shareReplay(1));
      
      this.teams = this.serviceTerritories.pipe(
        switchMap(serviceTerritory => this.getTeams(true)),
        shareReplay(1)
      );
      
      forkJoin([this.serviceTerritories, this.teams, quickFilter$])
        .pipe(takeUntil(this.tearDown$))
        .subscribe({
          next: () => {
            this.getSchedulerData(true);
          }
        });
    }
  }
  
  getTeams(onInit: boolean = false): Observable<any> {
    this.teamPickerLoading = true;
    const params = { 
      'page': this.teamSearchPagination.currentPage, 
      'filter.keyword': this.teamSearchPagination.keyword || '', 
      'filter.team_uid': this.teamSearchPagination.filterUid, 
      'sort': 'ASC', 
      'sort_by': 'team_name', 
      'filter.service_territory': this.enableServiceTerritory ? this.teamSearchPagination.serviceTerritoryFilterUid || '' : '', 
      'consider_service_territory': true 
    };
    const originalFilterUid = this.teamSearchPagination.filterUid;
    return this._dataCollectorService.getData(this._dispatchBoardService.teamDataUrl, params).pipe(
      switchMap(response => {
        if (onInit && (!response?.data || response.data.length === 0) && originalFilterUid) {
          const fallbackParams = {...params};
          fallbackParams['filter.team_uid'] = '';
          this.teamSearchPagination.filterUid = '';
          this.schedulerFormGroup.get('selectedTeam').setValue(null);
          this.selectedTeam = null;
          return this._dataCollectorService.getData(this._dispatchBoardService.teamDataUrl, fallbackParams);
        }
        return of(response);
      }),
      map(response => {
        if (onInit) {
          this.allTeams = response?.data || [];
          this.teamPickerList = [];
          if (this.allTeams.length === 0) {
            this.schedulerFormGroup.get('selectedTeam').setValue(null);
            this.selectedTeam = null;
            if (!this._sharedService.isNoTeamCreatedAlertIsOpened && !this.teamSearchPagination.serviceTerritoryFilterUid) {
              this.openNoTeamAlert();
            } else {
              this.onTeamClear();
            }
          } else {
            if (this._utilityService.isEmptyOrUndefined(this.schedulerFormGroup.get('selectedTeam').value)) {
              this.schedulerFormGroup.get('selectedTeam').setValue(response.data[0]?.team_uid);
              this.selectedTeam = response.data[0]?.team_uid;
            }
            this.onTeamChange(onInit);
          }
        } else {
          this.allTeams.push(...response.data);
          this.allTeams = _.uniqBy(this.allTeams, 'team_uid');
        }
        this.teamSearchPagination.totalPage = response.total_pages || 1;
        this.teamPickerList = _.union(this.teamPickerList, response.data || []);
        this.teamPickerList = _.uniqBy(this.teamPickerList, 'team_uid');
        this.teamPickerLoading = false;
        return response.data || [];
      }),
      catchError(error => {
        this.teamPickerLoading = false;
        return throwError(() => error);
      }),
      shareReplay(1)
    );
  }

  getServiceTerritory(onInit: boolean = false): Observable<any> {
    if (!this.enableServiceTerritory) {
      return of([]);
    }
  
    this.territorySearchPagination.isLoading = true;
    const params = { 
      'page': this.territorySearchPagination.currentPage, 
      'filter.keyword': this.territorySearchPagination.keyword || '', 
      'filter.territory_uid': this.territorySearchPagination.filterUid || '', 
      'filter.is_active': true 
    };
  
    const originalFilterUid = this.territorySearchPagination.filterUid;
    return this._dataCollectorService.getData(this._dispatchBoardService.territoryDataUrl, params).pipe(
      switchMap(response => {
        if (onInit && (!response?.data || response.data?.length === 0) && originalFilterUid) {
          const fallbackParams = {...params};
          fallbackParams['filter.territory_uid'] = '';
          this.territorySearchPagination.filterUid = '';
          this.selectedServiceTerritory = 'ALL';
          this.teamSearchPagination.serviceTerritoryFilterUid = '';
          this.saveServiceTerritorySchedulerPreference("ALL", this._utilityService.getLocaleValue('text.all_service_territory', 'All Service Territory'), [], null, 0);
          return this._dataCollectorService.getData(this._dispatchBoardService.territoryDataUrl, fallbackParams);
        }
        return of(response);
      }),
      map(response => {
        if (onInit) {
          this.allTerritories = [this.allServiceTerritorySelectOption, ...(response?.data || [])];
          
          if (this.allTerritories?.length <= 1) {
            this.territorySearchPagination.filterUid = '';
            this.selectedServiceTerritory = 'ALL';
          }
        } else {
          this.allTerritories.push(this.allServiceTerritorySelectOption, ...(response.data || []));
          this.allTerritories = _.uniqBy(this.allTerritories, 'territory_uid');
        }
        
        this.territorySearchPagination.totalPage = response.total_pages || 1;
        this.territorySearchPagination.currentPage = Number(response.current_page) || 1;
        this.serviceTerritoryPickerList = _.unionBy(
          [this.allServiceTerritorySelectOption], 
          this.serviceTerritoryPickerList, 
          response.data || [], 
          'territory_uid'
        );
        this.territorySearchPagination.isLoading = false;
        
        return [this.allServiceTerritorySelectOption, ...(response?.data || [])];
      }),
      
      catchError(error => {
        this.territorySearchPagination.isLoading = false;
        return of([]);
      }),
      shareReplay(1)
    );
  }

  onTeamClear(): void {
    if (this.schedulerInstance) {
      this.schedulerInstance.eventStore.removeAll();
      this.schedulerInstance.assignmentStore.removeAll();
      this.schedulerInstance.resourceStore.removeAll();
      this.schedulerInstance.resourceTimeRangeStore.removeAll();
    }
    this.schedulerProConfig.events = [];
    this.schedulerProConfig.assignments = [];
    this.schedulerProConfig.resources = [];
    this.schedulerJobs = [];
    this._dispatchBoardService.jobLocationMapData.JOBS.schedulerJob = [];
    this.updateMapLayersData();
  }

  updatePermissions(): void {
    this.permissions = this._dispatchBoardService.permissions;
    this.moduleAccess = this._dispatchBoardService.moduleAccess;
  }

  onMapEventChange(event: any): void {
    if (event?.event === 'FILTER') {
      this.openDispatchFilter('MAP');
    }
    else if (event?.event === 'SETTINGS') {
      this.openSettingsDialog('MAP');
    }
    else if (event?.event === 'MAP-LOADED') {
      const skipGetRoutes: boolean = true;
      this.updateMapLayersData(skipGetRoutes, null, null, null, true);
      this._dispatchBoardService.injectServiceTerritoryMapData(this.metaData);
      //Timeout to load map and service territory on map ready
      setTimeout(() => {
        if (this.selectedServiceTerritoryDetails.type === 'RADIUS' && this.selectedServiceTerritoryDetails.geoCords?.length === 2) {
          const bounds = this._mapService.getCircleBounds(this.selectedServiceTerritoryDetails.geoCords[0], this.selectedServiceTerritoryDetails.geoCords[1], this.selectedServiceTerritoryDetails.radius);
          this._mapService.mapFitBoundByGeoCords.next(bounds);
        }
        else if (this.selectedServiceTerritoryDetails.type === 'GEOFENCE' && this.selectedServiceTerritoryDetails.geoCords) {
          this._mapService.mapFitBoundByGeoCords.next(this.selectedServiceTerritoryDetails.geoCords || []);
        }
      });
    }
    else if (event?.event === 'PIN') {
      const oldMetaData = this.metaData;
      this.updateMetaData();
      this.updateMapLayersData(false, oldMetaData, this.metaData);
    }
    else if (event?.event === 'LEGEND') {
      this.toggleMapLegendBar(event?.isOpen, event?.legendDetails);
    }
  }

  toggleMapLegendBar(isOpen: boolean, legendDetails: any, updateLegendStateOnMap: boolean = false): void {
    if (!this.mapLegendContainerRef) {
      return;
    }
    const mapLegendBarElement: HTMLElement = (this.mapLegendContainerRef.nativeElement as HTMLElement).querySelector('#map-legend-bar');
    if (mapLegendBarElement) {
      if (isOpen) {
        mapLegendBarElement.classList.add('open');
      }
      else {
        mapLegendBarElement.classList.remove('open'); 
      }
    }

    if (updateLegendStateOnMap) {
      const legendContainer = (this.mapLegendContainerRef.nativeElement as HTMLElement).querySelector('.custom-control-container.legend-container') as HTMLElement;
      this._mapService.setMapLegendActiveState(legendContainer, false);
    }

    if (_.isPlainObject(legendDetails) && isOpen) {
      let allLegends = Object.values(legendDetails).flatMap(value => Object.values(value));
      allLegends = allLegends.map((legend: any) => ({ ...legend, textColor: this._utilityService.getTextColorBasedOnBg(legend?.color) }));
      this.mapLegendData.legendDetails = allLegends;
    }
    if (isOpen) {
      setTimeout(() => {
        this.calculateMapLegendVisibleItems();
      }, 100);
    }
  }

  onMapViewDrag(event: any): void {
    this._mapService.mapResizeIndicator.next(true);
  }

  async onJobClickFromMap(jobDetails: any): Promise<void> {
    if (jobDetails) {
      const jobUid = jobDetails?.job_uid;
      const schedulerAssignments = this.schedulerProConfig.assignments;
      this._dispatchBoardService.trackEvent('map_click_on_job');
      const scrollOptions: any = {
        block: 'center',
        extendTimeAxis: false,
        animate: {
          easing: 'easeFromTo',
          duration: 500
        }
      };
      const jobFromScheduler = this.schedulerInstance?.eventStore.getById(jobUid);
      const jobFromGrid = this.gridViewInstance?.store.getById(jobUid);
      const assignedTo = jobDetails?.assigned_to || [];
      let resouceRecord: any;
      if (jobFromScheduler) {
        const eventRecord: any = this.schedulerInstance?.eventStore.getById(jobUid);
        _.forEach(assignedTo, (assignee: any) => {
          const userUid = assignee.user.user_uid;
          const isResourceInScheduler = schedulerAssignments?.filter((assignment: any) => assignment.resourceId === userUid).length > 0;
          if (isResourceInScheduler) {
            resouceRecord = this.schedulerInstance?.resourceStore.getById(userUid);
          }
          if (resouceRecord) {
            return false;
          }
        });
        if (eventRecord && resouceRecord) {
          const schedulerStart = this.schedulerInstance.timeAxis.startDate;
          const schedulerEnd = this.schedulerInstance.timeAxis.endDate;
          const isEventInScheduler = eventRecord.startDate < schedulerEnd && eventRecord.endDate > schedulerStart;
          if (isEventInScheduler) {
            await this.schedulerInstance?.scrollResourceEventIntoView(resouceRecord, eventRecord, scrollOptions);
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
        }
      }

      if (jobFromGrid) {
        this.gridViewInstance?.scrollRowIntoView(jobFromGrid, { scrollOptions, highlight: true });
      }
    }
  }

  getEmployeeLocationData(count: number): void {
    const isCurrentDate = moment().isSame(this.schedulerFormGroup.get('schedulerDate')?.value, 'date');
    if (this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (this.currentView === 'WEEK' || this.currentView === 'MONTH' || !this.metaData.map.layers.users || !isCurrentDate || !this.metaData?.map.enable_map_view) {
        this._mapService.employeeLocationData.next([]);
        return;
      }
      if (count > 0) {
        const params = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          team_uid: this.selectedTeam,
          page: 1,
          limit: count
        };
        this._dataCollectorService.getData(this._dispatchBoardService.employeeLocationDataUrl, params)
          .subscribe((response: any) => {
            this._dispatchBoardService.employeeLocationData['JOBS'] = response?.data?.user_data;
            this._dispatchBoardService.injectEmployeeLocationMapData('JOBS', this.metaData);
          });
      }
    }
  }

  schedulerDateIncrementBtnState(action: 'enable' | 'disable'): void {
    if (action === 'enable') {
      this.schedulerDatePrevBtn = false;
      this.schedulerDateNextBtn = false;
    }
    else if (action === 'disable') {
      this.schedulerDatePrevBtn = true;
      this.schedulerDateNextBtn = true;
    }
  }

  getSchedulerData(updateResource: boolean = true, onlyJobData: boolean = false): void {
    if (this.currentView === 'DAY') {
      this.schedulerParams['from_date'] = this.schedulerFormGroup.get('schedulerDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['to_date'] = this.schedulerFormGroup.get('schedulerDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['populate_route'] = true;
    }
    else if (this.currentView === 'WEEK' || this.currentView === 'MONTH') {
      this.schedulerParams['from_date'] = this.schedulerFormGroup.get('scheduleStartDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['to_date'] = this.schedulerFormGroup.get('scheduleEndDate')?.value.format('YYYY-MM-DD');
      this.schedulerParams['populate_route'] = false;
    }

    if (this.currentView === 'MONTH') {
      const isWeekNumberEnabled = this.metaData?.scheduler.display.week_numbers ?? false;
      if (isWeekNumberEnabled) {
        this.schedulerParams['from_date'] = this.schedulerFormGroup.get('scheduleStartDate')?.value.startOf('week').format('YYYY-MM-DD');
        this.schedulerParams['to_date'] = this.schedulerFormGroup.get('scheduleEndDate')?.value.endOf('week').format('YYYY-MM-DD');
      }
    }
    this.schedulerParams['populate_user_shift'] = true;
    this.schedulerParams['timezone'] = this.selectedTimezone;
    this.schedulerParams['use_color_profile'] = true;
    this.schedulerDateIncrementBtnState('disable');
    this.currentDay = this.schedulerFormGroup.get('schedulerDate')?.value.format('dddd');
    this.schedulerParams['filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.filter_rules || []); //Workaround untill API bug fix on keyword empty search
    // Removed service erritory filter rules temporarily
    // if (this.selectedServiceTerritory !== 'ALL') {
    //   const serviceTerritoryFilterRules = this._dispatchBoardService.getServiceTerritoryFilterRule([this.selectedServiceTerritory], [this.selectedServiceTerritoryDetails.name]);
    //   params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
    //   params['filter_rules'].push(serviceTerritoryFilterRules);
    // }
    // else {
    //   params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
    // }
    this.schedulerSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', this.schedulerParams?.filter_rules);
    this.employeeSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', this.schedulerParams?.employee_filter_rules);
    this.updateSearchFilterValue('scheduler');
    this.cancelNonJobEventRequest.next();
    this.schedulerParams['filter.team_uid'] = this.selectedTeam || '';
    if (!this.schedulerParams['filter.team_uid']) {
      return;
    }
    if (updateResource && this.schedulerInstance) {
      this.schedulerInstance.resourceStore.removeAll();
      this.schedulerInstance.resourceStore.add(this.initiateGridShimmer(7));
    }
    const params: any = _.cloneDeep(this.schedulerParams);
    this.saveSchedulerPreference({ ...params, currentView: this.currentView });
    this._dataCollectorService.postData(this._dispatchBoardService.schedulerDataUrl, params)
      .subscribe({
        next: (response: any) => {
          this.customUserDetails = {};
          this.schedulerData = response?.data;
          this.schedulerEmployees = [];
          this.schedulerJobs = [];
          this.schedulerAssignments = [];
          const jobs = response.data?.jobs;
          const users = response.data?.users;
          this.resetEventSearch();
          jobs?.forEach((job: any) => {
            if (!job?.job_uid) {
              return;
            }
            job.id = job?.job_uid;
            job.name = this._dispatchBoardService.getJobTitle(job?.prefix, job?.work_order_number, job?.job_title);
            job.detailsType = 'job';
            if (job.scheduled_start_time && job.scheduled_end_time) {
              job.startDate = moment(job.scheduled_start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
              job.endDate = moment(job.scheduled_end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
            }
            job.eventColor = '#3c763d';
            if (job.current_job_status && job.current_job_status.status_type === 'CLOSED') {
              job.resizable = false;
              job.draggable = false;
            }
            job.assigned_to.forEach((assignment: any) => {
              if (!assignment?.user?.user_uid) {
                return;
              }
              const assignmentRecord = {
                id: job.job_uid + '_' + assignment.user.user_uid,
                eventId: job.job_uid,
                resourceId: assignment.user.user_uid
              };
              this.schedulerAssignments.push(assignmentRecord);
            });
            this.schedulerJobs.push(job);
          });
          users?.forEach((user, index) => {
            user.name = user.first_name + ' ' + user.last_name;
            user.role_name = user?.role?.role_name || '';
            if (user.profile_picture && this._utilityService.hasValidProfilePicture(user.profile_picture)) {
              user.imageUrl = user.profile_picture;
            }
            else {
              user.image = false;
              user.eventColor = 'indigo';
            }
            user.id = user.user_uid;
            this.schedulerEmployees.push(user);
          });
          this.schedulerAssignments = _.uniqBy(this.schedulerAssignments, 'id');
          this._dispatchBoardService.setSchedulerRecords(this.schedulerJobs);
          this._dispatchBoardService.setJobTabEmployeeRecords(this.schedulerEmployees);

          this.suspendAllSchedulerEvents({ assignment: true });
          //Reset All Data
          this.schedulerProConfig.events = [];
          this.schedulerProConfig.assignments = [];
          if (updateResource) {
            this.schedulerProConfig.resources = [];
            if (this.schedulerInstance) {
              this.schedulerInstance.resourceStore.removeAll();
            }
          }
          if (this.schedulerInstance) {
            this.schedulerInstance.assignmentStore.removeAll();
            this.schedulerInstance.eventStore.removeAll();
            this.schedulerInstance.resourceTimeRangeStore.removeAll();
          }

          //Load Data
          if (updateResource) {
            this.schedulerProConfig.resources = this.schedulerEmployees;
          }
          this.schedulerProConfig.events.push(...this.schedulerJobs);
          this.schedulerProConfig.assignments.push(...this.schedulerAssignments);
          if (this.schedulerInstance) {
            if (updateResource) {
              this.schedulerInstance.resourceStore.add(this.schedulerEmployees);
            }
            else {
              const _schedulerEmployee = this.schedulerEmployees.reduce((acc, userDetails) => {
                acc[userDetails?.id] = userDetails;
                return acc;
              }, {});
              this.schedulerInstance.resourceStore.forEach((resource: any) => {
                const updatedUserDetails = _schedulerEmployee[resource?.id];
                if (updatedUserDetails) {
                  resource.set(updatedUserDetails, true);
                }
              })
            }
            this.schedulerInstance.eventStore.add(this.schedulerJobs);
            this.schedulerInstance.assignmentStore.add(this.schedulerAssignments);
          }
          this.resumeAllSchedulerEvents({ assignment: true });
          this.schedulerDateIncrementBtnState('enable');
          setTimeout(() => {
            const startDate = moment(this.schedulerParams?.from_date, 'YYYY-MM-DD').startOf('day');
            const endDate = moment(this.schedulerParams?.to_date, 'YYYY-MM-DD').endOf('day');
            this.customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsLocal(startDate, endDate, this.schedulerEmployees, this.schedulerJobs, this.schedulerNonJobEvents);
            this._dispatchBoardService.setResourceTimeoff(this.schedulerInstance, this.schedulerEmployees);
            this._dispatchBoardService.setResourceShift(this.schedulerInstance, this.schedulerEmployees, this.currentView);
            this.getEmployeeLocationData(users?.length);
            this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', this.metaData, this.schedulerJobs, false, false, true);
            if (!this.isSchedulerInitialLoad && (this.schedulerFocusData.jobUid || this.schedulerFocusData.userUid)) {
              this.removeSchedulerEventLisners();
            }
            if (this.isSchedulerInitialLoad) {
              this.isSchedulerInitialLoad = false;
            }
            if (!onlyJobData) {
              this.getNonJobEventData();
            }
            this.getMapRoutes();
            this.setDistanceBetweenJobs([], 100);
          }, 200);
        },
        error: (error: any) => {
          this.suspendAllSchedulerEvents({ assignment: true });
          //Reset All Data
          this.schedulerProConfig.events = [];
          this.schedulerProConfig.assignments = [];
          this.schedulerProConfig.resources = [];
          if (this.schedulerInstance) {
            this.schedulerInstance.eventStore.removeAll();
            this.schedulerInstance.assignmentStore.removeAll();
            this.schedulerInstance.resourceStore.removeAll();
          }
          this.resumeAllSchedulerEvents({ assignment: true });
          this.refreshSchedulerEvents(false);
          this.schedulerDateIncrementBtnState('enable');
          if (!onlyJobData) {
            this.getNonJobEventData();
          }
        }
      });
  }

  getNonJobEventData(): void {
    if (this.currentView === 'DAY') {
      this.nonJobEventParams['filter.from_date'] = this.schedulerFormGroup.get('schedulerDate')?.value.format('YYYY-MM-DD');
      this.nonJobEventParams['filter.to_date'] = this.schedulerFormGroup.get('schedulerDate')?.value.format('YYYY-MM-DD');
    }
    else if (this.currentView === 'WEEK' || this.currentView === 'MONTH') {
      this.nonJobEventParams['filter.from_date'] = this.schedulerFormGroup.get('scheduleStartDate')?.value.format('YYYY-MM-DD');
      this.nonJobEventParams['filter.to_date'] = this.schedulerFormGroup.get('scheduleEndDate')?.value.format('YYYY-MM-DD');
    }
    this.nonJobEventParams['timezone'] = this.selectedTimezone;
    this.nonJobEventParams['filter.assigned_to_team'] = this.selectedTeam;
    const params: any = _.cloneDeep(this.nonJobEventParams);
    this._dataCollectorService.getData(this._dispatchBoardService.nonJobEventDataUrl, params)
      .pipe(takeUntil(this.cancelNonJobEventRequest))
      .subscribe((response: any) => {
        const nonJobEvents: any[] = response?.data || [];
        this.schedulerNonJobEvents = [];
        this.schedulerNonJobAssignments = [];
        nonJobEvents.forEach((nonJobEvent: any) => {
          nonJobEvent.id = nonJobEvent?.event_uid;
          nonJobEvent.name = nonJobEvent?.event_name;
          nonJobEvent.detailsType = 'non_job_event';
          if (nonJobEvent?.start_time && nonJobEvent?.end_time) {
            nonJobEvent.startDate = moment(nonJobEvent.start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
            nonJobEvent.endDate = moment(nonJobEvent.end_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm:ss');
          }
          nonJobEvent.resizable = false;
          nonJobEvent.draggable = false;
          nonJobEvent.assigned_to.forEach((assignment: any) => {
            const assignmentRecord = {
              id: nonJobEvent?.event_uid + '_' + assignment?.user?.user_uid,
              eventId: nonJobEvent?.event_uid,
              resourceId: assignment?.user?.user_uid,
              detailsType: 'non_job_event'
            };
            this.schedulerNonJobAssignments.push(assignmentRecord);
          });
          this.schedulerNonJobEvents.push(nonJobEvent);
        });
        this.suspendAllSchedulerEvents({ assignment: true });
        if (this.schedulerInstance) {
          const oldNonJobEventModel: any[] = _.map(this.schedulerInstance.eventStore.findByField('detailsType', 'non_job_event'), 'data');
          const oldNonJobAssignmentModel: any[] = _.map(this.schedulerInstance.assignmentStore.findByField('detailsType', 'non_job_event'), 'data');
          if (oldNonJobEventModel?.length) {
            this.schedulerInstance.eventStore.remove(oldNonJobEventModel);
          }
          if (oldNonJobAssignmentModel?.length) {
            this.schedulerInstance.assignmentStore.remove(oldNonJobAssignmentModel);
          }
        }
        this.schedulerProConfig.events = this.schedulerProConfig.events.filter((event: any) => event?.detailsType !== 'non_job_event');
        this.schedulerProConfig.assignments = this.schedulerProConfig.assignments.filter((assignment: any) => assignment?.detailsType !== 'non_job_event');
        this.schedulerProConfig.events.push(...this.schedulerNonJobEvents);
        this.schedulerProConfig.assignments.push(...this.schedulerNonJobAssignments);
        if (this.schedulerInstance) {
          this.schedulerInstance.eventStore.add(this.schedulerNonJobEvents);
          this.schedulerInstance.assignmentStore.add(this.schedulerNonJobAssignments);
        }
        this.resumeAllSchedulerEvents({ assignment: true });
        const startDate = moment(this.schedulerParams?.from_date, 'YYYY-MM-DD').startOf('day');
        const endDate = moment(this.schedulerParams?.to_date, 'YYYY-MM-DD').endOf('day');
        this.customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsLocal(startDate, endDate, this.schedulerEmployees, this.schedulerJobs, this.schedulerNonJobEvents);
      }, (error: any) => {
      });

  }

  applyQueryParams(): void {
    const scrollOptions: any = {
      extendTimeAxis: false,
      animate: true,
      block: 'center',
    };
    try {
      if (this.schedulerFocusData.jobUid || this.schedulerFocusData.userUid) {
        let resourecRecord = this.schedulerInstance.resourceStore.getById(this.schedulerFocusData.userUid);
        const eventRecord = this.schedulerInstance.eventStore.getById(this.schedulerFocusData.jobUid);
        if (eventRecord && !resourecRecord) {
          if (eventRecord?.resourceIds?.length > 1) {
            resourecRecord = eventRecord.resource;
            this.schedulerInstance.scrollResourceEventIntoView(resourecRecord, eventRecord, scrollOptions).then(()=> {
              this.removeSchedulerEventLisners();
            });
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
          else {
            this.schedulerInstance.scrollEventIntoView(eventRecord, scrollOptions).then(() => {
              this.removeSchedulerEventLisners();
            });
            this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'event', eventRecord);
          }
        }
        else if (resourecRecord && !eventRecord) {
          this.schedulerInstance.scrollResourceIntoView(resourecRecord, scrollOptions).then(()=>{
            this.removeSchedulerEventLisners();
          });
          this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'resource', resourecRecord);
        }
        else if (resourecRecord && eventRecord) {
          this.schedulerInstance.scrollResourceEventIntoView(resourecRecord, eventRecord, scrollOptions).then(()=>{
            this.removeSchedulerEventLisners();
          });
          const assignmentRecord = this.schedulerInstance.assignmentStore.getById(eventRecord.id + '_' + resourecRecord.id);
          this._dispatchBoardService.highlightEventInScheduler(this.schedulerInstance, 'both', assignmentRecord);
        }
      }
      else {
        this.removeSchedulerEventLisners();
      }
    }
    finally {
    }
  }



  suspendAllSchedulerEvents(options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    this.setGridSchedulerInstance();
    this._dispatchBoardService.suspendAllSchedulerEvents(this.schedulerInstance, options);
  }

  resumeAllSchedulerEvents(options?: { resource?: boolean; event?: boolean; assignment?: boolean; timeRange?: boolean; resourceTimeRange?: boolean; preset?: boolean; timeAxis?: boolean }): void {
    this.setGridSchedulerInstance();
    this._dispatchBoardService.resumeAllSchedulerEvents(this.schedulerInstance, options);
  }

  suspendAllGridEvents(): void {
    if (this.gridViewInstance) {
      this.gridViewInstance.suspendEvents();
      this.gridViewInstance.store.beginBatch();
    }
  }

  resumeAllGridEvents(): void {
    if (this.gridViewInstance) {
      this.gridViewInstance.store.endBatch(true);
      this.gridViewInstance.resumeEvents();
    }
  }

  setSchedulerConfig(): void {
    this.schedulerProConfig = {
      multiEventSelect: true,
      resourceTimeRanges: [],
      zoomOnTimeAxisDoubleClick: false,
      zoomOnMouseWheel: false,
      createEventOnDblClick: false,
      autoAdjustTimeAxis : false,
      timeZone: this.selectedTimezone,
      fillTicks: this.currentView === 'DAY' ? false: true,
      viewPreset: this.currentView === 'DAY' ? 'customHourAndDay': 'dayAndWeek',
      resources: this.initiateGridShimmer(7),
      columns: [
        {
          text: 'Name',
          field: 'name',
          minWidth: 250,
          autoHeight: false,
          editor: false,
          enableHeaderContextMenu: false,
          enableCellContextMenu: false,
          sortable: false,
          htmlEncode : false,
          fitMode: 'value',
          cls: 'min-w-72',
          headerRenderer: (): string => { 
            this.addSchedulerEmpHeaderOnClickListener();
            return this._templateService.getSchedulerResourceHeader(this.filterCount.employee, 'JOBS');
          },
          summaries: [{
            sum: 'count',
            renderer: (resource: any): string => `<span class='text-medium font-medium'>${this._utilityService.getLocaleValue('text.total_users', 'Total Users')} : ${resource.sum}</span>`
          }],
          renderer: (event: any): string => {
            if (event.record?.originalData?.showShimmer) {
              return this._templateService.getUserCardShimmer();
            }
            else {
              event.size.height = _.max([this.schedulerEventRowHeight, this.schedulerResourceRowHeight]);
              const userUid = event.record?._data.user_uid;
              if (userUid) {
                const additionalParams = {
                  currentView: this.currentView,
                  currentDay: this.currentDay,
                  jobsCount: _.filter(this.schedulerAssignments, { resourceId: userUid }).length,
                  preferences: { display: this.metaData?.employee.more_information },
                  dateRange: { fromDate: this.schedulerParams['from_date'], toDate: this.schedulerParams['to_date'] }
                };
                return this._templateService.getJobRendererTemplate('jobs', 'employee', null, userUid, additionalParams);
              }
            }
          }
        }
      ],
      onEventClick: (event: any): void => {
        this._dispatchBoardService.trackEvent('scheduler_job_preview');
        const eventDetails: any = event?.eventRecord?.originalData;
        const eventType: 'job' | 'nonJobEvent' = eventDetails?.detailsType === 'non_job_event' ? 'nonJobEvent': 'job';
        if (eventType === 'job') {
          const jobUid: string = eventDetails?.job_uid;
          if (jobUid) {
            this._dispatchBoardService.jobPreview.next({ jobUid: jobUid, timezone: _this.selectedTimezone });
          }
        }
        else if (eventType === 'nonJobEvent') {
          const nonJobEventUid: string = eventDetails?.event_uid;
          if (nonJobEventUid) {
            this.openNonJobEventPreview(nonJobEventUid);
          }
        }
      },
      eventRenderer: ({ eventRecord, renderData }: any): string => {
        const eventType: 'job' | 'nonJobEvent' = eventRecord?.data?.detailsType === 'non_job_event' ? 'nonJobEvent' : 'job';
        if (eventType === 'job') {
          const jobDetails = eventRecord.data;
          const jobUid = jobDetails?.job_uid;
          const rowLength = _.max([this.schedulerEventRowHeight, this.schedulerResourceRowHeight]);
          let eventBorderColor = this._templateService.getCardColor(jobDetails, this.metaData?.scheduler.secondary_color);
          if (this.metaData?.scheduler.secondary_color === 'team') {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const team = _.find(this.allTeams, { 'team_uid': this.selectedTeam });
            eventBorderColor = team?.team_color;
          }
          renderData.eventStyle = 'border';
          if (this.schedulerInstance) {
            this.schedulerInstance.rowHeight = rowLength;
          }
          else {
            eventRecord.rowHeight = rowLength;
          }
          renderData.eventColor = `${this._utilityService.convertHexToRgba(this._templateService.getCardColor(jobDetails, this.metaData?.scheduler.primary_color) || '#887ECB')}`;
          renderData.style = `${this.metaData?.scheduler.primary_color === 'none' ? 'border-width: 2.5px; border-color: rgba(210 ,200,200, 0.3);' : ''} border-left-width: 5px; border-left-color: ${eventBorderColor || '#e67e22'}`;
          return this._templateService.getJobRendererTemplate('jobs', 'scheduler', jobUid, null, { showOnlyScheduledTime: true, currentView: this.currentView, schedulerZoomLevel: this.schedulerInstance?.zoomLevel });
        }
        else if (eventType === 'nonJobEvent') {
          const nonJobEventDetails = eventRecord?.data;
          renderData.eventStyle = 'plain';
          renderData.cls += ' tentative-event rounded-r-lg border border-gray-300 border-l-0';
          renderData.eventColor = this._utilityService.convertHexToRgba('#BAC7D5');
          return this._templateService.getNonJobEventRendererTemplate(nonJobEventDetails);
        }
      },
      eventStore: {
        listeners: {
          beforeAdd: (): void => {
            this.calculateSchedulerHeight();
          },
        }
      },
      resourceStore: {
        listeners: {
          beforeAdd: (): void => {
            this.calculateSchedulerHeight();
          }
        }
      },
      listeners: {
        beforeEventResizeFinalize: ({ context }): void => {
          context.async = true;
          const jobDetails = context.eventRecord.originalData;
          const userDetails = context.resourceRecord.data;
          const startDateTime = moment(moment(context.startDate).tz(_this.browserTimezone).format('YYYY-MM-DD HH:mm:ss'));
          const endDateTime = moment(moment(context.endDate).tz(_this.browserTimezone).format('YYYY-MM-DD HH:mm:ss'));
          this._dispatchBoardService.trackEvent('scheduler_resize_job_rescheudle');
          const warnings: any[] = this._dispatchBoardService.getScheduleWarningMsg('job', jobDetails, userDetails, moment.tz(startDateTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone), moment.tz(endDateTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone), this.customUserDetails, true);
          const sdkPayload: any = {
            oldValue: {
              startDate: context.originalStartDate,
              endDate: context.originalEndDate,
            },
            newValue: {
              startDate: context.startDate,
              endDate: context.endDate,
            },
            jobDetails: jobDetails
          };
          this.checkAndHandleForPreEventListenerFromSDK('job_schedule_change', sdkPayload).then((canProceed: boolean) => {
            if (canProceed) {
              const rescheduleRemarksDialogInstance = this._zuperDialogService.openCustom(RemarksComponent,
                {
                  data:
                  {
                    jobDetails: jobDetails,
                    warnings: warnings,
                    startDateTime:  moment.tz(startDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone).utc().toISOString(),
                    endDateTime:  moment.tz(endDateTime.format('YYYY-MM-DD HH:mm:ss'), _this.selectedTimezone).utc().toISOString(),
                    timeZone: this.selectedTimezone
                  },
                  extraClass: 'w-2/5'
                });
              rescheduleRemarksDialogInstance?.afterClosed()
                .subscribe((status: boolean) => {
                  if (status) {
                    const _startDateTime = moment.tz(startDateTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone);
                    const _endDateTime = moment.tz(endDateTime.format('YYYY-MM-DD HH:mm:ss'), this.selectedTimezone);
                    const updatedJob = this._dispatchBoardService.createSchedulerJobEvent(jobDetails, _startDateTime, _endDateTime);
                    this.schedulerProConfig.events = this._dispatchBoardService.updateJobEventsScheduleDateTime(this.schedulerProConfig.events, jobDetails?.job_uid, _startDateTime, _endDateTime);
                    this.updateLocalRecordsAfterChanges(updatedJob, 'update', true, false);
                    this.setDistanceBetweenJobs();
                    context.finalize(true);
                  }
                  else {
                    context.finalize(false);
                  }
                });
            } else {
              context.finalize(false);
            }
          });
        },
        beforeEventDropFinalize: ({ context }): void => {
          context.async = true;
          const oldUserDetails = context?.resourceRecord.data;
          const newUserDetails = context?.newResource.data;
          const oldStartTime = moment(context?.sourceDate);
          const newStartTime = moment(context?.startDate);
          const newEndTime = moment(context?.endDate);
          let jobDetails = context?.eventRecord.originalData;

          //Assign new user if scheduled time is not changed
          const jobUid = jobDetails?.job_uid;
          const oldUserUid = oldUserDetails?.user_uid;
          const newUserUid = newUserDetails?.user_uid;
          const newUserTeamUid = this.selectedTeam;
          const oldUserTeamUid: string = this.getUserTeamId(oldUserUid);
          let updatedJob = { ...jobDetails };
          const assignNewUserWithotReschedule = newStartTime.isSame(oldStartTime) && (oldUserUid !== newUserUid);
          if (assignNewUserWithotReschedule) {
            if (this.permissions.updateJobAssignment) {
              jobDetails = this.updateEventAssignment(jobDetails, oldUserDetails, 'UNASSIGN');
              const warnings = this._dispatchBoardService.getScheduleWarningMsg('job', jobDetails, newUserDetails, newStartTime, newEndTime, this.customUserDetails, true);
              const openAssignmentWarningDialog = Object.values(warnings).filter((warning: any) => warning.show).length > 0;
              if (openAssignmentWarningDialog) {
                this._dispatchBoardService.scheduleConfirmationDialog('job', jobDetails, warnings).afterClosed()
                  .subscribe((result: boolean) => {
                    if (result) {
                      this._dispatchBoardService.assignAndUnassignJob(jobUid, newUserUid, newUserTeamUid, oldUserUid, oldUserTeamUid, (status: boolean) => {
                        if (status) {
                          const _startDateTime = moment(jobDetails?.scheduled_start_time).tz(this.selectedTimezone);
                          const _endDateTime = moment(jobDetails?.scheduled_end_time).tz(this.selectedTimezone);
                          updatedJob = this._dispatchBoardService.createSchedulerJobEvent(jobDetails, _startDateTime, _endDateTime);
                          updatedJob = this.updateEventAssignment(updatedJob, oldUserDetails, 'UNASSIGN');
                          updatedJob = this.updateEventAssignment(updatedJob, newUserDetails, 'ASSIGN');
                          const allAssignments: Object[] = this._dispatchBoardService.updateAssignmentRecords(this.schedulerProConfig.assignments, updatedJob);
                          this.suspendAllSchedulerEvents({ assignment: true });
                          this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                          this.schedulerProConfig.assignments = allAssignments;
                          this.updateLocalRecordsAfterChanges(updatedJob, 'update', true);
                          this._dispatchBoardService.trackEvent(['scheduler_job_drop_user', 'scheduler_job_drop_rescheudle']);
                          this.updateSchedulerAssignement(updatedJob);
                          this.setDistanceBetweenJobs();
                          this.resumeAllSchedulerEvents({ assignment: true });
                        }
                        context.finalize(status);
                      });
                    }
                    else {
                      context.finalize(false);
                    }
                  });
              }
              else {
                this._dispatchBoardService.assignAndUnassignJob(jobUid, newUserUid, newUserTeamUid, oldUserUid, oldUserTeamUid, (status: boolean) => {
                  if (status) {
                    const _startDateTime = moment(jobDetails?.scheduled_start_time).tz(this.selectedTimezone);
                    const _endDateTime = moment(jobDetails?.scheduled_end_time).tz(this.selectedTimezone);
                    updatedJob = this._dispatchBoardService.createSchedulerJobEvent(jobDetails, _startDateTime, _endDateTime);
                    updatedJob = this.updateEventAssignment(updatedJob, oldUserDetails, 'UNASSIGN');
                    updatedJob = this.updateEventAssignment(updatedJob, newUserDetails, 'ASSIGN');
                    this.suspendAllSchedulerEvents({ assignment: true });
                    const allAssignments: Object[] = this._dispatchBoardService.updateAssignmentRecords(this.schedulerProConfig.assignments, updatedJob);
                    this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                    this.schedulerProConfig.assignments = allAssignments;
                    this._dispatchBoardService.trackEvent(['scheduler_job_drop_user', 'scheduler_job_drop_rescheudle']);
                    this.updateLocalRecordsAfterChanges(updatedJob, 'update', true);
                    this.updateSchedulerAssignement(updatedJob);
                    this.setDistanceBetweenJobs();
                    this.resumeAllSchedulerEvents({ assignment: true });
                  }
                  context.finalize(status);
                });
              }
            }
            else {
              context.finalize(false);
              this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
            }
          }
          else { //open Reschedule model if scheduled time is changed
            if (this.permissions.rescheduleJob) {
              if (oldUserUid !== newUserUid) {
                jobDetails = this.updateEventAssignment(jobDetails, oldUserDetails, 'UNASSIGN');
              }
              this._sdkEventService.openCustomWithPreEventListener(RescheduleJobComponent, {
                dialogId: 'dispatch_board.job_reschedule',
                data: {
                  holidays: this.holidays,
                  userDetails: newUserDetails,
                  jobDetails: jobDetails,
                  dropDateTime: newStartTime,
                  customUserDetails: this.customUserDetails,
                  teamUid: this.selectedTeam,
                  unAssignUser: oldUserUid !== newUserUid,
                  unAssignUserUid: oldUserUid,
                  unAssignUserTeamUid: oldUserTeamUid
                },
                extraClass: 'w-fit'
              }, jobDetails).then((rescheduleDialogInstance) => {
                if(!rescheduleDialogInstance && context) {
                  context.finalize(false)
                }
                rescheduleDialogInstance?.afterClosed()
                  .subscribe((dialogData: any) => {
                    if (!this._utilityService.isEmptyOrUndefined(dialogData)) {
                      const _startDateTime = dialogData?.scheduledStartTime;
                      const _endDateTime = dialogData?.scheduledEndTime;
                      updatedJob = this._dispatchBoardService.createSchedulerJobEvent(jobDetails, _startDateTime, _endDateTime);
                      this.suspendAllSchedulerEvents({ assignment: true });
                      if (oldUserUid !== newUserUid) {
                        updatedJob = this.updateEventAssignment(updatedJob, oldUserDetails, 'UNASSIGN');
                        updatedJob = this.updateEventAssignment(updatedJob, newUserDetails, 'ASSIGN');
                        const allAssignments: Object[] = this._dispatchBoardService.updateAssignmentRecords(this.schedulerProConfig.assignments, updatedJob);
                        this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                        this.schedulerProConfig.assignments = allAssignments;
                        this._dispatchBoardService.trackEvent(['scheduler_job_drop_user', 'scheduler_job_drop_rescheudle']);
                      }
                      else {
                        this._dispatchBoardService.trackEvent('scheduler_job_drop_rescheudle');
                      }
                      this.updateLocalRecordsAfterChanges(updatedJob, 'update', true);
                      this.setDistanceBetweenJobs();
                      this.resumeAllSchedulerEvents({ assignment: true });
                      context.finalize(true);
                    }
                    else {
                      context.finalize(false);
                    }
                  });
              });
            }
            else {
              context.finalize(false);
              this._toastService.error(this._utilityService.getLocaleValue('dispatchBoard.scheduler.permission.error', 'You don\'t have permission to perform this action'));
            }
          }
        },
        beforeDragCreateFinalize: (event: any): void => {
          event.context.async = true;
          const startDateTime = dayjs(event.context.startDate).tz(this.selectedTimezone, true);
          const endDateTime = dayjs(event.context.endDate).tz(this.selectedTimezone, true);
          const originalStartDateTime = dayjs(event.context.startDate).utc().toISOString();
          const originalEndDateTime = dayjs(event.context.endDate).utc().toISOString();
          const userDetails = event.resourceRecord.originalData;
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const teamDetails = _.find(this.allTeams, { 'team_uid': this.selectedTeam });
          const user = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            first_name: userDetails?.first_name, last_name: userDetails?.last_name, user_uid: userDetails?.user_uid, email: userDetails?.email, profile_picture: userDetails?.profile_picture, hasValidProfilePicture: this._utilityService.hasValidProfilePicture(userDetails?.profile_picture)
          };
          const team = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            team_name: teamDetails?.team_name, team_uid: this.selectedTeam
          };
          this._dispatchBoardService.trackEvent('scheduler_drag_create');
          const dragData = { startDate: startDateTime.toISOString(), startTime: startDateTime.format('HH:mm:ss'), endDate: endDateTime.toISOString(), endTime: endDateTime.format('HH:mm:ss'), user: user, team: team, timezone: this.selectedTimezone };
          const [isHoliday, holidayName, blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(originalStartDateTime, originalEndDateTime);
          this.schedulerNewEventDialogInstance = this.matDialog.open(this.schedulerNewEventDialogContent, {
            panelClass: ['min-w-96'],
            disableClose: true,
            data: { showNewJob: this.permissions.newJob, showNewTimeoff: this.permissions.timesheetTimeoff, showNewNonJobEvent: this.permissions.newJob, dragData: dragData, blockJobsOnHoliday: blockJobsOnHoliday, holidayName: holidayName }
          });
          this.schedulerNewEventDialogInstance.afterClosed()
            .subscribe(() => {
              event.context.finalize();
            });
        },
        beforeEventEdit: (): boolean => false,
        beforeEventDrag: (): boolean => this.permissions.rescheduleJob || this.permissions.updateJobAssignment,
        beforeEventResize: (): boolean => this.permissions.rescheduleJob,
        beforeDragCreate: (): boolean => this.permissions.newJob || this.permissions.timesheetTimeoff
      },
      features: {
        cellMenu: false,
        dependencies: false,
        timeAxisHeaderMenu: false,
        scheduleTooltip: {
          generateTipContent: ({ date }): any => {
            const hoveringDate = dayjs(date).format(this.dateTimeFormat);
            return `<div class='flex flex-col space-y-1.5'>
                      <div class='flex items-center space-x-1.5'>
                        <i class='ti ti-clock text-2xl'></i>
                        <span>${hoveringDate}</span>
                      </div>
                    </div>  `;
          }
        },
        eventTooltip: {
          template: ((data: any): any => {
            const eventRecord: any = data.eventRecord.originalData;
            const eventType: 'job' | 'nonJobEvent' = eventRecord?.detailsType === 'non_job_event' ? 'nonJobEvent': 'job';
            if (eventType === 'job') {
              if (data?.tip) {
                data.tip.bodyCls = 'm-0 p-0';
              }
              return this._templateService.getJobDetailsTemplate(data.eventRecord.originalData, this.currentView, this.metaData);
            }
            else if (eventType === 'nonJobEvent') {
              if (data?.tip) {
                data.tip.bodyCls = 'm-0 p-0';
                data.tip.cls = 'm-0 p-0 rounded-lg min-w-80';
              }
              return this._templateService.getNonJobEventTooltip(eventRecord);
            }
          })
        },
        resourceTimeRanges: {
          enableMouseEvents: true,
        },
        cellTooltip: {
          hoverDelay: 200,
          hideDelay: 100,
          allowOver: true,
          scrollAction: 'hide',
          anchorToTarget: false,
          maxWidth: 500,
          hideOnDelegateChange: true,
          style: 'min-width : 400px !important;overflow : hidden;max-height:98% !important;',
          loadingMsg: this._utilityService.getLocaleValue('dispatchBoard.scheduler.employee.loading_details', 'Loading Details'),
          tooltipRenderer: async (context: any): Promise<string> => {
            const userDetails = context.record.data;
            if (userDetails?.showShimmer) {
              return '';
            }
            const userUid = userDetails?.user_uid;
            const dateRange = { fromDate: _this.schedulerParams['from_date'], toDate: _this.schedulerParams['to_date'] };
            const preferences = { display: _this.metaData?.employee.more_information };
            const jobCount = _this._dispatchBoardService.getUserJobCount(_this.schedulerJobs, userUid);
            const viewMode = _this.currentView;
            return await _this._templateService.getEmployeePreviewTemplate('jobs', dateRange, userDetails, preferences, jobCount, viewMode);
            },
          onFocusIn: (event: any): any => {
            const schedulerResourceHeader = event?.toWidget?.currentElement ? (event?.toWidget?.currentElement as HTMLElement).querySelector('#employeeDetailsExternal'): null;
            const userUid = schedulerResourceHeader?.['dataset']?.useruid;
            if (schedulerResourceHeader && userUid) {
              schedulerResourceHeader.addEventListener('click', () => {
                this.openEmployeeDetailsDrawer(userUid);
              });
            }
          },
          onHide: (event: any): any => {
            const schedulerResourceHeader = event?.toWidget?.currentElement ? (event?.toWidget?.currentElement as HTMLElement).querySelector('#employeeDetailsExternal'): null;
            if (schedulerResourceHeader) {
              schedulerResourceHeader.removeEventListener('click', () => { });
            }
          }
          },
          scheduleMenu: false,
          eventMenu: {
            items: {
            copyEvent: false,
            cutEvent: false,
            editEvent: false,
            deleteEvent: false,
            unassignEvent: false,
            splitEvent: false,
            rescheduleJob: {
              text: this._utilityService.getLocaleValue('text.reschedule_job', 'Reschedule Job'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-clock-edit text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const jobUid = jobDetails?.job_uid;
                const userDetails = event.resourceRecord.originalData;
                const dropDateTime = event.eventRecord.startDate;
                _this._dispatchBoardService.trackEvent('scheduler_job_reschedule');
                _this._sdkEventService.openCustomWithPreEventListener(RescheduleJobComponent, {
                  dialogId: 'dispatch_board.job_reschedule',
                  data: {
                    holidays: _this.holidays,
                    userDetails: userDetails,
                    jobDetails: jobDetails,
                    dropDateTime: dropDateTime,
                    customUserDetails: _this.customUserDetails,
                    teamUid: _this.selectedTeam,
                    enableClearSchedule: true
                  },
                  extraClass: 'w-fit'
                }, jobDetails).then((rescheduleDialogInstance)=>{
                rescheduleDialogInstance?.afterClosed()
                  .subscribe((data: any) => {
                    if (data) {
                      if (data?.type === 'clearSchedule') {
                        _this.schedulerInstance?.eventStore.remove(jobUid);
                        _this.gridViewInstance?.store.remove(jobUid);
                        _this.updateLocalRecordsAfterChanges(jobDetails, 'delete');
                        _this.setDistanceBetweenJobs();
                        _this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', _this.metaData, _this.schedulerJobs);
                      }
                      else {
                        const scheduledStartTime = data?.scheduledStartTime;
                        const scheduledEndTime = data?.scheduledEndTime;
                        _this.schedulerProConfig.events = _this._dispatchBoardService.updateJobEventsScheduleDateTime(_this.schedulerProConfig.events, jobDetails?.job_uid, scheduledStartTime, scheduledEndTime);
                        const updatedJob = _this._dispatchBoardService.createSchedulerJobEvent(jobDetails, scheduledStartTime, scheduledEndTime);
                        _this.updateLocalRecordsAfterChanges(updatedJob, 'update', true);
                        _this.setDistanceBetweenJobs();
                      }
                    }
                  });
                });
              }
            },
            clearSchedule: {
              text: this._utilityService.getLocaleValue('text.clear_schedule', 'Clear Schedule'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-eraser text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const jobUid = jobDetails?.job_uid;
                _this._dispatchBoardService.trackEvent('clear_job_schdedule');
                if(jobDetails?.due_date){
                  const clearScheduleConfirmationDialogRef = _this._dispatchBoardService.jobDetailsChangeConfirmationDialog(jobDetails, 'clearSchedule');
                  clearScheduleConfirmationDialogRef.afterClosed()
                  .subscribe((result: boolean) => {
                    if (result) {
                      _this._dispatchBoardService.clearScheduleJob(jobDetails, (status: true) => {
                        if (status) {
                          _this.schedulerInstance?.eventStore.remove(jobUid);
                          _this.gridViewInstance?.store.remove(jobUid);
                          _this.updateLocalRecordsAfterChanges(jobDetails, 'delete');
                          _this.setDistanceBetweenJobs();
                          _this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', _this.metaData, _this.schedulerJobs);
                        }
                      });
                    }
                  });
                }
                else {
                  const dueDateDialog = _this._zuperDialogService.openCustom(UpdateDueDateComponent,{
                    data: jobDetails,
                    extraClass:'w-2/5',
                    clearSchedule: true, //prefill checkbox based in the value
                    updateDueDateAndClearSchedule: true //change primary button text and add note on top
                   });

                   dueDateDialog.afterClosed().subscribe((result: any)=>{
                    if(result){
                      if(jobDetails?.route?.route_uid) {
                        _this._dispatchBoardService.clearScheduleJobFromRoute(jobDetails, (status: true) => {
                          if (status) {
                            _this.schedulerInstance?.eventStore.remove(jobUid);
                            _this.gridViewInstance?.store.remove(jobUid);
                            _this.updateLocalRecordsAfterChanges(jobDetails, 'delete');
                            _this.setDistanceBetweenJobs();
                            _this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', _this.metaData, _this.schedulerJobs);
                          }
                        });
                      }
                      else{
                        _this.schedulerInstance?.eventStore.remove(jobUid);
                        _this.gridViewInstance?.store.remove(jobUid);
                        _this.updateLocalRecordsAfterChanges(jobDetails, 'delete');
                        _this.setDistanceBetweenJobs();
                        _this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', _this.metaData, _this.schedulerJobs);
                      }
                    }
                  });
                }
              }
            },
            unassign: {
              text: this._utilityService.getLocaleValue('text.unassign_job', 'Unassign Job'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-user-minus text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const userDetails = event.resourceRecord.originalData;
                const jobUid = jobDetails?.job_uid;
                const userUid = userDetails?.user_uid;
                const teamId = _this.getUserTeamId(userUid);
                _this._dispatchBoardService.trackEvent('scheduler_job_unassign');
                const unassignConfirmationDialogRef = _this._dispatchBoardService.jobDetailsChangeConfirmationDialog(jobDetails, 'unassign', { userName: userDetails?.name });
                unassignConfirmationDialogRef.afterClosed()
                  .subscribe((result: boolean) => {
                    if (result) {
                      const updatedJob = _this.updateEventAssignment(jobDetails, userDetails, 'UNASSIGN');
                      _this._dispatchBoardService.unassignJob(jobUid, userUid, teamId, (status: boolean) => {
                        if (status) {
                          _this.suspendAllSchedulerEvents({ assignment: true });
                          const allAssignments: Object[] = _this._dispatchBoardService.updateAssignmentRecords(_this.schedulerProConfig.assignments, updatedJob);
                          _this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                          _this.schedulerProConfig.assignments = allAssignments;
                          _this.updateLocalRecordsAfterChanges(updatedJob, 'update', true);
                          _this.updateSchedulerAssignement(updatedJob);
                          _this.setDistanceBetweenJobs([userUid]);
                          if (['UNASSIGNED'].includes(_this.getGridJobType())) {
                            _this.getGridData(_this.gridParam).then((jobs: any) => {
                              _this.updateGridViewData(jobs);
                            });
                          }
                          _this.resumeAllSchedulerEvents({ assignment: true });
                        }
                      });
                    }
                  });
              }
            },
            newNote: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.event_menu.options.note', 'New Note'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-notes text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const jobUid = jobDetails?.job_uid;
                _this._dispatchBoardService.setMultiModulePickerTabs(jobUid);
                _this._dispatchBoardService.trackEvent('scheduler_job_new_note');
                const editNoteDialog = _this._zuperDialogService.openCustom(NoteDialogComponent,
                  {
                    extraClass: 'note-dialog-file-uploader',
                    data: {
                      header: {
                        titleDisplayKey: 'add.note.text',
                        titleDisplayName: 'Add Note'
                      },
                      footer: {
                        submitDisplayKey: 'add.note.text',
                        submitDisplayName: 'Add Note',
                        closeDisplayKey: 'close.text',
                        closeDisplayName: 'Close',
                        enablePrivacy: true
                      },
                      defaultAssociatedModule: 'JOB',
                      defaultAssociatedModuleDetails: jobDetails,
                      config: {
                        editorOptions: {
                          isEnabled: true,
                          options: {
                            imageUpload: false,
                            allowMentions: true,
                            showTemplate: false,
                            editorId: 'note_text_editor',
                            module: 'JOB',
                            placeholder: _this._utilityService.getLocaleValue('notes.panel.editor.placeholder'),
                            initUponFocus: null,
                            addAttachmentsInBody: false
                            , ...{ editorId: 'edit_note_text_editor' }
                          }
                        },
                        uploaderOptions: {
                          isEnabled: true,
                          options: {
                            uploadFileFor:'NOTE',
                            multiple: true,
                            setMaxLimit: true,
                            attachmentType: 'JOB_NOTE',
                            showProgress: false,
                            showPreview: false,
                            allowFileTypes: _this._utilityService.notesSupportedFileTypes,
                            description: {
                              descriptionKey: 'notes.panel.description',
                              descriptionName: 'Supported Files: Image, Video, Audio, PDF, DOC, XLS, MSG, EML, Zip'
                            }
                          }
                        }
                      }
                    }
                  });

                editNoteDialog.disableClose = true;
                const onSubmitClicked = _this._noteDialogService.onSubmitClicked.subscribe((response: any) => {
                  editNoteDialog.close(response);
                });
                editNoteDialog.afterClosed().subscribe((result: any) => {
                  if (!_this._utilityService.isEmptyOrUndefined(result)) {
                    const payload = { ...result, jobUid: jobUid };
                    _this._dispatchBoardService.createNewNote(payload);
                    onSubmitClicked.unsubscribe();
                  }

                });
              }
            },
            showOnMap: {
              text: this._utilityService.getLocaleValue('dispatchBoard.scheduler.event_menu.options.show_on_map', 'Show on Map'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-map-pin text-xl',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const customerLocation = _.get(jobDetails, 'customer_address.geo_cordinates');
                _this._dispatchBoardService.trackEvent('scheduler_job_show_on_map');
                if (!_this._utilityService.isEmptyOrUndefined(customerLocation)) {
                  _this._mapService.showOnMap.next({ module: 'JOBS', eventUid: jobDetails?.job_uid });
                }
              }
            },
            delete: {
              text: this._utilityService.getLocaleValue('delete.text', 'Delete'),
              cls: 'text-red-600 primary-font leading-normal text-base',
              weight: 300,
              icon: 'ti ti-trash text-xl text-red-600',
              onItem(event: any): any {
                const jobDetails = event.eventRecord.originalData;
                const jobUid = jobDetails?.job_uid;
                _this._dispatchBoardService.trackEvent('scheduler_job_delete');
                const deleteConfirmationDialogRef = _this._dispatchBoardService.jobDetailsChangeConfirmationDialog(jobDetails, 'delete');
                deleteConfirmationDialogRef.afterClosed()
                  .subscribe((result: boolean) => {
                    if (result) {
                      _this._dispatchBoardService.deleteJob(jobUid, (status: true) => {
                        if (status) {
                          _this.schedulerInstance?.eventStore.remove(jobUid);
                          _this.gridViewInstance?.store.remove(jobUid);
                          _this.updateLocalRecordsAfterChanges(jobDetails, 'delete');
                          _this.setDistanceBetweenJobs();
                          _this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', _this.metaData, _this.schedulerJobs);
                        }
                      });
                    }
                  });
              }
            },
            editNonJobEvent: {
              text: this._utilityService.getLocaleValue('edit', 'Edit'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-edit text-xl',
              onItem: (event: any): any => {
                const eventDetails = event.eventRecord.originalData;
                this.nonJobEventCreateDrawerData.source = null;
                this.editNonJobEvent(eventDetails);
              }
            },
            unassignNonJobEvent: {
              text: this._utilityService.getLocaleValue('text.unassign', 'Unassign'),
              weight: 300,
              cls: 'primary-font leading-normal text-base text-gray-700',
              icon: 'ti ti-user-minus text-xl',
              onItem: (event: any): any => {
                const nonJobEventDetails = event.eventRecord.originalData;
                const userDetails = event.resourceRecord.originalData;
                const nonJobEventUid = nonJobEventDetails?.event_uid;
                const userUid = userDetails?.user_uid;
                const teamUid = this.getUserTeamId(userUid);
                const startDateTime = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, false, false, this.selectedTimezone);
                let recurrenceType: string;
                if (nonJobEventDetails?.is_recurrence) {
                  const actionSelectorOption: ActionSelectorOption = {
                    title: `${this._utilityService.getLocaleValue('non_job_event.recurrence.edit.title', 'Edit Recurring Non Job Event')}`,
                    options: [
                      {
                        key: 'SINGLE_EVENT',
                        optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.unassign.event_only_title', 'Unassign from this event only'),
                        optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.event_only_message', 'Applies to this event only')} (${startDateTime[0]})`
                      },
                      {
                        key: 'ALL_FUTURE_EVENTS',
                        optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.unassign.upcoming_event_title', 'Unassign from this and upcoming events'),
                        optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.upcoming_event_message', 'Applies to this and upcoming events in the series.')}`
                      }
                    ],
                    primaryActionButtonText: this._utilityService.getLocaleValue('text.unassign', 'Unassign'),
                    primaryActionButtonType: 'primary'
                  };
                  const actionSelectorDialogRef = this._zuperDialogService.openCustom(ActionSelectorComponent, { data: actionSelectorOption, extraClass: 'non-job-delete-recurrence-dialog' });
                  actionSelectorDialogRef.afterClosed().subscribe((response: any) => {
                    if (response?.isSelected) {
                      if (response?.selectedType) {
                        recurrenceType = response?.selectedType;
                      }
                      else {
                        recurrenceType = null;
                      }
                      this._dispatchBoardService.unassignNonJobEvent(nonJobEventUid, { userUid: userUid, teamUid: teamUid }, nonJobEventDetails?.assigned_to || [], recurrenceType, (unassignStatus: boolean) => {
                        if (unassignStatus) {
                          this.suspendAllSchedulerEvents({ assignment: true });
                          if (recurrenceType === 'SINGLE_EVENT') {
                            const updatedNonJobEventDetails = this.updateEventAssignment(nonJobEventDetails, userDetails, 'UNASSIGN');
                            const allAssignments: Object[] = this._dispatchBoardService.updateNonJobAssignmentRecords(this.schedulerProConfig.assignments, updatedNonJobEventDetails);
                            this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                            this.schedulerProConfig.assignments = allAssignments;
                            this.updateLocalRecordsAfterNonJobEventChanges(updatedNonJobEventDetails, 'update', false);
                            this.updateNonJobEventSchedulerAssignement(updatedNonJobEventDetails);
                          }
                          else if (recurrenceType === 'ALL_FUTURE_EVENTS') {
                            this.getNonJobEventData();
                          }
                          this.resumeAllSchedulerEvents({ assignment: true });
                        }
                      });
                    }
                  });
                }
                else {
                  const unassignConfirmationDialogRef = this._dispatchBoardService.nonJobEventDetailsChangeConfirmationDialog(nonJobEventDetails, 'unassign', { userName: `${userDetails?.first_name || ''} ${userDetails?.last_name || ''}` });
                  unassignConfirmationDialogRef.afterClosed().subscribe((status: boolean) => {
                    if (status) {
                      this._dispatchBoardService.unassignNonJobEvent(nonJobEventUid, { userUid: userUid, teamUid: teamUid }, nonJobEventDetails?.assigned_to || [], null, (unassignStatus: boolean) => {
                        if (unassignStatus) {
                          this.suspendAllSchedulerEvents({ assignment: true });
                          const updatedNonJobEventDetails = this.updateEventAssignment(nonJobEventDetails, userDetails, 'UNASSIGN');
                          const allAssignments: Object[] = this._dispatchBoardService.updateNonJobAssignmentRecords(this.schedulerProConfig.assignments, updatedNonJobEventDetails);
                          this.schedulerInstance.assignmentStore.loadDataAsync(allAssignments);
                          this.schedulerProConfig.assignments = allAssignments;
                          this.updateLocalRecordsAfterNonJobEventChanges(updatedNonJobEventDetails, 'update', false);
                          this.updateNonJobEventSchedulerAssignement(updatedNonJobEventDetails);
                          this.resumeAllSchedulerEvents({ assignment: true });
                        }
                      });
                    }
                  });
                }
              }
            },
            deleteNonJobEvent: {
              text: this._utilityService.getLocaleValue('delete.text', 'Delete'),
              cls: 'text-red-600 primary-font leading-normal text-base',
              weight: 300,
              icon: 'ti ti-trash text-xl text-red-600',
              onItem: (event: any): any => {
                const nonJobEventDetails = event.eventRecord.originalData;
                const nonJobEventUid = nonJobEventDetails?.event_uid;
                nonJobEventDetails['startEndDateTime'] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, false, false, this.selectedTimezone);
                if (nonJobEventUid && nonJobEventDetails) {
                  let deleteParam: any = {};
                  if (nonJobEventDetails?.is_recurrence) {
                    const actionSelectorOption: ActionSelectorOption = {
                      title: `${this._utilityService.getLocaleValue('non_job_event.recurrence.delete.title', 'Delete Recurring Non Job Event')}`,
                      options: [
                        {
                          key: 'SINGLE_EVENT',
                          optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.delete.event_only_title', 'Delete this event only'),
                          optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.event_only_message', 'Applies to this event only')} (${nonJobEventDetails?.startEndDateTime[0]})`
                        },
                        {
                          key: 'ALL_FUTURE_EVENTS',
                          optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.delete.upcoming_event_title', 'Delete this and upcoming events'),
                          optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.upcoming_event_message', 'Applies to this and upcoming events in the series.')}`
                        }
                      ],
                      primaryActionButtonText: this._utilityService.getLocaleValue('delete.text', 'Delete'),
                      primaryActionButtonType: 'error'
                    };
                    const actionSelectorDialogRef = this._zuperDialogService.openCustom(ActionSelectorComponent, { data: actionSelectorOption, extraClass: 'non-job-delete-recurrence-dialog' });
                    actionSelectorDialogRef.afterClosed().subscribe((response: any) => {
                      if (response?.isSelected) {
                        if (response?.selectedType) {
                          deleteParam['delete_recurrence_type'] = response?.selectedType;
                        }
                        else {
                          deleteParam = {};
                        }
                        this._dispatchBoardService.deleteNonJobEvent(nonJobEventUid, deleteParam, (deleteStatus: boolean) => {
                          if (deleteStatus) {
                            this.schedulerInstance?.eventStore.remove(nonJobEventUid);
                            this._dispatchBoardService.trackMixPanelEvent('non_job_event_deleted');
                            this.getNonJobEventData();
                          }
                        });
                      }
                    });
                  } else {
                    const deleteDialogRef = this._dispatchBoardService.nonJobEventDetailsChangeConfirmationDialog(nonJobEventDetails, 'delete');
                    deleteDialogRef.afterClosed().subscribe((status: boolean) => {
                      if (status) {
                        this._dispatchBoardService.deleteNonJobEvent(nonJobEventUid, deleteParam, (deleteStatus: boolean) => {
                          if (deleteStatus) {
                            this.schedulerInstance?.eventStore.remove(nonJobEventUid);
                            this._dispatchBoardService.trackMixPanelEvent('non_job_event_deleted');
                            this.updateLocalRecordsAfterNonJobEventChanges(nonJobEventDetails, 'delete');
                          }
                        });
                      }
                    });
                  }
                }
              }
            },
          },
          processItems: (event: any): any => {
            const items: any = event.items;
            const eventDetails: any = event?.eventRecord?.data;
            const eventType: 'job' | 'nonJobEvent' = eventDetails?.detailsType === 'non_job_event' ? 'nonJobEvent': 'job';
            if (eventType === 'nonJobEvent') {
              const nonJobEventAccess:  { view: boolean; edit: boolean; delete: boolean } = this._dispatchBoardService.checkNonJobEventAccess(eventDetails);
              items.clearSchedule.hidden = true;
              items.unassign.hidden = true;
              items.rescheduleJob.hidden = true;
              items.newNote.hidden = true;
              items.showOnMap.hidden = true;
              items.delete.hidden = true;
              items.editNonJobEvent.hidden = !nonJobEventAccess?.edit;
              items.unassignNonJobEvent.hidden = !nonJobEventAccess?.edit;
              items.deleteNonJobEvent.hidden = !nonJobEventAccess?.delete;
            }
            else if (eventType === 'job') {
              items.clearSchedule.hidden = false;
              items.unassign.hidden = !this.permissions.updateJobAssignment;;
              items.rescheduleJob.hidden = !this.permissions.rescheduleJob;;
              items.newNote.hidden = !this.permissions.newNote;;
              items.showOnMap.hidden = !this.isMapViewEnabled || !this.metaData?.map?.layers?.jobs || !this.moduleAccess.map || !this._dispatchBoardService.isJobHasGeoCords(eventDetails);
              items.delete.hidden = !this.permissions.deleteJob;;
              items.editNonJobEvent.hidden = true;
              items.unassignNonJobEvent.hidden = true;
              items.deleteNonJobEvent.hidden = true;
            }

          }
        },
        eventDrag: {
          constrainDragToResource: !this.permissions.updateJobAssignment
        },
        summary: {
          disabled: true,
          renderer: (event: any): string => {
            let eventIds = [];
            event?.events.forEach((eventModel: any) => {
              eventIds.push(eventModel._data.id);
            });
            eventIds = _.uniq(eventIds);
            return `<div class='cursor-default' eventIds=${eventIds.join(',')}>${eventIds.length}</div>`;
          }
        },
        timeRanges: {
          showHeaderElements: true,
          showCurrentTimeLine: true
        },
        eventBuffer : {
          showDuration: true,
          renderer: ({ eventRecord, postambleConfig }: any): any => {
            const travelDistanceData = eventRecord.data.travelDistanceData;
            if (travelDistanceData) {
              const modeOfTransport: string = this.metaData?.scheduler?.mode_of_transport || 'CAR';
              const travelTime: number = travelDistanceData.leg_time / 1000;
              const travelDistance: number = travelDistanceData.leg_distance;
              const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this._utilityService.getLocaleValue('route.distance.metric.miles') : this._utilityService.getLocaleValue('route.distance.metric.kilo_meters');
              postambleConfig.icon = `text-gray-400 b-icon b-fa-${this._dispatchBoardService.modeOfTransportIcons[modeOfTransport]}`;
              postambleConfig.text = travelTime !== 0 ? `${this._utilityService.convertSecondsToHours(travelTime, true)}` : `- ${this._utilityService.getLocaleValue('users.preview.work_hours.mins.label')}`;;
            }
          },
          tooltipTemplate: (event: any): any => {
            const travelDistanceData = event.eventRecord.data.travelDistanceData;
            const modeOfTransport = this.metaData?.scheduler?.mode_of_transport || 'CAR';
            const travelTime: number = travelDistanceData.leg_time / 1000; //milliseconds to seconds
            const travelDistance: number = travelDistanceData.leg_distance;
            this.schedulerInstance?.features.eventTooltip.tooltip?.close();
            return this._templateService.getRouteTravelDistanceTooltipTemplate(travelTime, travelDistance, modeOfTransport);
          }
        }
      }
    };
    this.setSchedulerPreset(this.currentView);
    const _this = this;
    this.outOfShiftHoursTooltipInstance = new Tooltip({
      hoverDelay: 0,
      hideDelay: 0,
      forSelector: '.b-sch-resourcetimerange.out-of-shift-hours',
      cls: 'h-auto max-h-96',
      bodyCls: 'zuper-scrollbar',
      allowOver: true,
      getHtml(event: any): string {
        const shiftDetails = event.activeTarget.elementData.eventRecord.data.customShiftDetails;
        return _this._templateService.getOutOfShiftHoursTooltip(shiftDetails);
      }
    });
    this.initiateTooltipInstances();
  }

  calculateSchedulerHeight(): void {
    const calculateRowHeight = (view: any): number => {
      const rowLength = Object.keys(view || {}).length || 1;
      return rowLength === 1 ? 60 : rowLength * 30;
    };

    this.schedulerEventRowHeight = calculateRowHeight(this.metaData?.scheduler?.card_view);
    this.schedulerResourceRowHeight = calculateRowHeight(this.metaData?.employee?.card_view);
  }

  initiateTooltipInstances(): void {
    this.timeoffTooltipInstance = new Tooltip({
      hoverDelay: 0,
      hideDelay: 250,
      forSelector: '#schedulerpro .b-sch-resourcetimerange.timeoff',
      cls: 'h-auto w-96 ',
      allowOver: true,
      autoClose: false,
      listeners: {
        show: (event: any): any => {
          if (this.tooltipTimeoffEvent) {
            this.timeoffEditElement = event.source.currentElement.querySelector('#timeoff_edit');
            this.timeoffDeleteElement = event.source.currentElement.querySelector('#timeoff_delete');

            if (this.timeoffEditElement) {
              if (this.timeoffEditHandler) {
                this.timeoffEditElement.removeEventListener('click', this.timeoffEditHandler);
              }
              this.timeoffEditHandler = this.editResourceTimeRangeEvent.bind(this, this.tooltipTimeoffEvent);
              this.timeoffEditElement.addEventListener('click', this.timeoffEditHandler);
            }

            if (this.timeoffDeleteElement) {
              if (this.timeoffDeleteHandler) {
                this.timeoffDeleteElement.removeEventListener('click', this.timeoffDeleteHandler);
              }
              this.timeoffDeleteHandler = this.deleteResourceTimeRangeEvent.bind(this, this.tooltipTimeoffEvent);
              this.timeoffDeleteElement.addEventListener('click', this.timeoffDeleteHandler);
            }
          }
        },
        hide: (event: any): any => {
          if (this.timeoffEditElement) {
            this.timeoffEditElement.removeEventListener('click', this.timeoffEditHandler);
          }
          if (this.timeoffDeleteElement) {
            this.timeoffDeleteElement.removeEventListener('click', this.timeoffDeleteHandler);
          }
          this.timeoffEditElement = null;
          this.timeoffDeleteElement = null;
          this.timeoffEditHandler = null;
          this.timeoffDeleteHandler = null;
        }
      },
      getHtml: (event: any): string => {
        const timeoff = event.activeTarget.elementData.eventRecord.data;
        const userDetails = event.activeTarget.elementData.resourceRecord.originalData;
        this.tooltipTimeoffEvent = timeoff;
        this.tooltipTimeoffEvent['userDetails'] = userDetails;
        return this._templateService.getTimeoffTooltipTemplate(userDetails, timeoff);
      }
    });

    this.schedulerSummaryTooltipInstance = new Tooltip({
      hoverDelay: 0,
      hideDelay: 0,
      autoClose: false,
      forSelector: '#schedulerpro .b-timeaxis-summary-value',
      cls: 'h-auto max-w-96 max-h-96',
      bodyCls: 'zuper-scrollbar',
      allowOver: true,
      getHtml: (event: any): string => {
        const eventIdsString: string = event.activeTarget.firstElementChild.attributes.eventIds.nodeValue;
        const eventIds: any[] = _.uniq(eventIdsString.split(','));
        let jobCount = eventIds.length;
        if (!eventIdsString) {
          jobCount = 0;
        }
        const resoureAssignments = this.constructResoureAssignmentObject(eventIds);
        return this._templateService.getSchedulerSummaryTooltip('job', resoureAssignments, jobCount);
      }
    });
  }

  destroyTooltipInstances(): void {
    this.timeoffTooltipInstance?.destroy();
    this.schedulerSummaryTooltipInstance?.destroy();
    this.timeoffTooltipInstance = null;
  }

  openEmployeeDetailsDrawer(userUid: any): void {
    this.schedulerInstance.features.cellTooltip.tip.hide();
    this.empDetailsDrawer.drawerOpen = true;
    this.empDetailsDrawer.moduleUID = userUid;
    this.empDetailsDrawer.module = 'USER';
    this._dispatchBoardService.trackEvent('user_details_preview');
  }

  closeEmployeeDetailsDrawer(): void {
    this.empDetailsDrawer.drawerOpen = false;
    this.empDetailsDrawer.moduleUID = '';
  }

  empDetailsDrawerEventHandler(event: any): any {
    if (event.drawerClosed) {
      this.closeEmployeeDetailsDrawer();
    }
  }

  constructResoureAssignmentObject(eventIds: any[]): Object {
    const resourceAssignemennt: Object = {};
    eventIds.forEach((eventId: any) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const jobDetails = _.find(this.schedulerJobs, { 'job_uid': eventId });
      const assignedTo = jobDetails?.assigned_to;
      assignedTo?.forEach((assignee: any) => {
        const userUid = assignee?.user.user_uid;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const userDetails = _.find(this.schedulerEmployees, { 'user_uid': userUid });
        if (userDetails) {
          if (resourceAssignemennt.hasOwnProperty(userDetails.name)) {
            resourceAssignemennt[userDetails.name] += 1;
          }
          else {
            resourceAssignemennt[userDetails.name] = 1;
          }
        }
      });
    });
    return resourceAssignemennt;
  }

  buildBusinessHoursTimeRange(type?: 'add' | 'remove'): void {
    let action: any = type;
    if (!type) {
      action = this.metaData?.scheduler.display?.business_hours_only ? 'remove' : 'add';
    }
    this._dispatchBoardService.buildBusinessHoursTimeRange(action, this.schedulerInstance, this.currentView, this.metaData);
  }

  buildHolidaysTimeRange(): void {
    this._dispatchBoardService.buildHolidaysTimeRange('JOBS', this.schedulerInstance, this.holidays);
  }

  updateSchedulerWeekends(enable: boolean): void {
    if (this.schedulerInstance) {
      if (!enable && this.currentView !== 'DAY') {
        this.schedulerInstance.timeAxis.filter({
          id: 'weekends',
          filterBy: ((tick: any) => tick.startDate.getDay() !== 6 && tick.startDate.getDay() !== 0)
        });
      }
      else {
        this.schedulerInstance.timeAxis.removeFilter('weekends');
      }
    }
  }

  updateSchedulerWeekNumber(enable: boolean): void {
    if (this.schedulerInstance) {
      this.suspendAllSchedulerEvents({ preset: true });
      const headers = this.schedulerInstance.timeAxis.headers;
      this.schedulerInstance.timeAxis.headers = headers.filter(header => header.unit !== 'week');
      if (enable) {
        this.schedulerInstance.timeAxis.headers.splice(0, 0, {
          unit: 'week',
          renderer: (date: any) => 'Week ' + moment(date).week()
        });
      }
      this.schedulerInstance.timeAxisViewModel.update();
      this.resumeAllSchedulerEvents({ preset: true });
    }
  }

  updateSchedulerSettings(schedulerSettings: any, skipSchedulerStartEndDate: boolean = false): void {
    if (!schedulerSettings) {return;}
    const preference = schedulerSettings?.display;
    this.updateSchedulerWeekNumber(preference.week_numbers);
    this.updateSchedulerWeekends(preference.weekends);
    this.toggleSchedulerSummary(preference.job_summary);
    if (!skipSchedulerStartEndDate) {
      this.setSchedulerStartEndDate(this.currentView);
    }
  }

  toggleSchedulerSummary(enable: boolean): void {
    if (!this.schedulerInstance) { return; }
    this.schedulerInstance.features.summary.disabled = !enable;
  }

  updateEventAssignment(eventDetails: any, userDetails: any, type: 'ASSIGN' | 'UNASSIGN'): Object {
    let assignedTo: any[] = eventDetails?.assigned_to || [];
    if (type === 'UNASSIGN') {
      assignedTo = assignedTo.filter((assignee: any) => assignee.user.user_uid !== userDetails?.user_uid);
    }
    else if (type === 'ASSIGN') {
      const newUser = {
        user: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          user_uid: userDetails?.user_uid, first_name: userDetails?.first_name, last_name: userDetails?.last_name,
        },
        team: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          team_uid: this.selectedTeam
        }
      };
      assignedTo.push(newUser);
    }
    eventDetails.assigned_to = assignedTo;
    return eventDetails;
  }

  getHolidays(): void {
    const params = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      limit: 100, sort: 'DESC', sort_by: 'created_at'
    };
    this._dataCollectorService.getData(this._dispatchBoardService.holidayUrl, params)
      .subscribe((response: any) => {
        this.holidays = response.data;
        this._dispatchBoardService.holidays = this.holidays;
        this._dispatchBoardService.holidayObj = this.holidays.reduce((acc: any, holiday: any) => {
          const formattedDate = moment(holiday?.date).format('YYYY-MM-DD');
          acc[formattedDate] = holiday;
          return acc;
        }, {});
        this.buildHolidaysTimeRange();
        this._dispatchBoardService.jobRouteTransferEmitter.next({ additionalParams: {updateHoliday: true, holidays: this.holidays} });
      });
  }

  getGridData(params: any): Promise<any> {
    if (this.gridViewType === 'listView') {
      this.cardData = this.initiateGridShimmer(7);
    } else if (this.gridViewType === 'tableView') {
      this.tableGridData = this.initiateGridShimmer(7);
    }
    this.loadingGridData = true;
    params['filter_rules'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', params?.filter_rules || []);
    if (this.enableServiceTerritory) {
      if (this.selectedServiceTerritory !== 'ALL') {
        const serviceTerritoryFilterRules = this._dispatchBoardService.getServiceTerritoryFilterRule([this.selectedServiceTerritory], [this.selectedServiceTerritoryDetails.name], 'dispatch_board_global');
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
        params['filter_rules'].push(serviceTerritoryFilterRules);
      }
      else {
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
      }
    }
    else {
      const existingServiceTerritoryFilterRule = this._dispatchBoardService.getFilterRuleByKey('territory_uid', params['filter_rules']);
      if (existingServiceTerritoryFilterRule?.source === 'dispatch_board_global') {
        params['filter_rules'] = this._dispatchBoardService.removeFilterKey('territory_uid', params['filter_rules']) || [];
      }
    }
    params['populate_route'] = true;
    params['use_color_profile'] = true;
    params['timezone'] = this.selectedTimezone;
    return new Promise((resolve, reject) => {
      this._dataCollectorService.postData(this._dispatchBoardService.gridDataUrl, params)
        .subscribe((response: any) => {
          this.gridData = response.data?.[this.gridJobTypeMap[params?.type]].map((ele: any) => ({ ...ele, id: ele.job_uid }));
          this._dispatchBoardService.setGridRecords(this.gridData);
          this._dispatchBoardService.injectJobLocationMapData('JOBS', 'gridJob', this.metaData, this.gridData);
          this.totalGridPage = response.total_pages;
          this.totalGridRecords = response.total_records;
          this._configurationService.saveGridPreference(params, 'job');

          //set Grid sort and Tbar values
          this.sortOptions.grid.sort = params?.sort;
          this.sortOptions.grid.sort_by = params?.sort_by;
          this.gridTbar.jobType = params?.type;
          this.gridSearchKeyword = this._dispatchBoardService.getFilterValue('keyword', params?.filter_rules) || '';
          this.updateSearchFilterValue('grid');
          this.loadingGridData = false;
          if (!this.hasGridInstanceMounted) {
            this.setGridSchedulerInstance();
          }
          resolve(this.gridData);

        }, (error: any) => {
          this.loadingGridData = false;
          if (this.gridViewType === 'listView') {
            this.cardData = [];
          } else if (this.gridViewType === 'tableView') {
            this.tableGridData = [];
          }
          reject(error);
        });

    });

  }

  setCardConfig(): void {
    this.gridFeatures = {
      eventEdit: false,
    };
    const _this = this;
    this.cardConfig = {
      autoHeight: false,
      useRawData: true,
      sortOnLoad: false,
      filterOnLoad: false,
      height: '100%',
      columns: [{
        type: 'template',
        readOnly: true,
        autoHeight: true,
        template: (event: any): string => {
          if (event.record.data?.showShimmer) {
            return this._templateService.getCardShimmer();;
          }
          else {
            const jobUid = event.record.data?.job_uid;
            return _this._templateService.getJobRendererTemplate('jobs', 'jobGridCard', jobUid,);
          }
        }
      }],
      onCellClick: (row: any): void => {
        if (!this.metaData?.map?.layers?.jobs) {
          return;
        }
        this.geoCordsNotFoundToastRef?.close();
        const jobDetails = row?.record?.data;
        const jobUid = jobDetails?.job_uid;
        if (jobUid) {
          if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
            if (this._utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates)) {
              _this._mapService.showOnMap.next({ module: 'JOBS', eventUid: jobUid });
            }
            else {
              this.geoCordsNotFoundToastRef = this._toastService.error(this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job'));
            }
          }
          else {
            this._dispatchBoardService.jobPreview.next({ jobUid: jobDetails?.job_uid, timezone: this.selectedTimezone });
            this._dispatchBoardService.trackEvent('grid_job_preview');
          }
        }
      },
      features: {
        cellMenu: {
          items: {
            copy: false,
            cut: false,
            edit: false,
            paste: false,
            removeRow: false,
            viewDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem(event: any): any {
                const jobDetails = event?.record?.originalData;
                if (jobDetails?.job_uid) {
                  _this._dispatchBoardService.jobPreview.next({ jobUid: jobDetails?.job_uid, timezone: _this.selectedTimezone });
                  _this._dispatchBoardService.trackEvent('grid_job_preview');
                }
              }
            }
          },
          processItems(context) {
            const jobDetails = context.record?.['originalData'];
            if (!jobDetails?.job_uid) {
              return false;
            }
          },
        },
        headerMenu: false
      }
    };
  }

  setTableConfig(): void {
    this.tableConfig = {
      autoHeight: false,
      height: '100%',
      features: {
        cellMenu: {
          items: {
            copy: false,
            cut: false,
            edit: false,
            paste: false,
            removeRow: false,
            viewDetails: {
              text: this._utilityService.getLocaleValue('text.view_details', 'View Details'),
              weight: 300,
              cls: 'primary-font leading-normal font-normal text-base text-gray-700',
              icon: 'ti ti-file-description text-xl',
              onItem: (event: any): any => {
                const jobDetails = event?.record?.originalData;
                if (jobDetails?.id) {
                  this._dispatchBoardService.jobPreview.next({ jobUid: jobDetails?.id, timezone: this.selectedTimezone });
                  this._dispatchBoardService.trackEvent('grid_job_preview');
                }
              }
            }
          }
          ,
          processItems: (context: any): boolean => {
            const jobDetails = context.record?.['originalData'];
            if (!jobDetails?.id) {
              return false;
            }
          }
        }
      },
      onCellClick: (row: any): void => {
        if (!this.metaData?.map.layers.jobs) {
          return;
        }
        this.geoCordsNotFoundToastRef?.close();
        const jobDetails = row?.record?.data;
        const jobUid = jobDetails?.id;
        if (jobUid) {
          if (this.moduleAccess?.map && this.metaData?.map?.enable_map_view) {
            if (this._utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates)) {
              this._mapService.showOnMap.next({ module: 'JOBS', eventUid: jobUid });
            }
            else {
              this.geoCordsNotFoundToastRef = this._toastService.error(this._utilityService.getLocaleValue('dataPicker.job.geo_coordinates.alert_text', 'Geo Co-ordinates not found for this job'));
            }
          }
          else {
            this._dispatchBoardService.jobPreview.next({ jobUid: jobUid, timezone: this.selectedTimezone });
            this._dispatchBoardService.trackEvent('grid_job_preview');
          }
        }
      }
    };
    this.updateTableColumns();
  }

  tableViewRendererMap(column: any): any {
    const key = column?.group_uid;
    const isDefaultField = column?.isDefaultField;
    if (isDefaultField) {
      return this._templateService.getTableDefaultFieldColumn('jobs', key, column);
    }
    else {
      const fieldType = column?.field_type;
      return this._templateService.getTableCustomFieldColumn(fieldType, column);
    }
  }

  updateTableContent(jobs: any[]): void {
    this.suspendAllGridEvents();
    let tableGridData = [];
    if (this.metaData) {
      const tableView = this.metaData?.grid.table_view;
      let customRow = {};
      if (!jobs?.[0]?.showShimmer) {
        jobs?.forEach((job: any) => {
          customRow = this._dispatchBoardService.formatEventDetails(tableView, job);
          tableGridData.push(customRow);
        });
      }
      else {
        tableGridData = jobs;
      }
      this.tableGridData = tableGridData;
    }
    this.resumeAllGridEvents();
  }

  updateTableColumns(): void {
     this.suspendAllGridEvents();
    if (this.metaData) {
      const tableView = this.metaData?.grid.table_view;
      this.tableConfig.columns = [];
      this.tableConfig.columns = tableView.map((column): Partial<GridColumnConfig> => (
        {
          field: column.key,
          text: column?.displayKeyValue || column.label,
          htmlEncode: false,
          sortable: Object.keys(this.gridSortableColumns).includes(column.key),
          editor: false,
          draggable: false,
          width: 200,
          renderer: (record): string => {
            if (record.record.data?.showShimmer) {
              return this._templateService.getTableShimmer();
            }
            else {
              return this.tableViewRendererMap(column)(record);
            }
          }
        }
      ));
    }
    if (this.tableViewInstance?.columns) {
      this.tableViewInstance.columns.removeAll();
      this.tableViewInstance.columns = this.tableConfig.columns;
    }
    this.resumeAllGridEvents();

  }

  saveSchedulerPreference(prefrence: any): void {
    const schedulerPreference: object = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    schedulerPreference['job']['from_date'] = prefrence?.from_date;
    schedulerPreference['job']['to_date'] = prefrence?.to_date;
    schedulerPreference['job']['team_uid'] = prefrence['filter.team_uid'];
    schedulerPreference['job']['currentView'] = prefrence?.currentView;
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }

  saveTimezoneSchedulerPreference(timezone: string): void {
    const schedulerPreference: any = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences');
    schedulerPreference['timezone'].JOBS = timezone;
    if(this._dispatchBoardService?.companyConfig?.multipleTimezone) {
      schedulerPreference['timezone'].ROUTES = timezone;
    }
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }
   
  saveServiceTerritorySchedulerPreference(serviceTerritoryUid: string, serviceTerritoryName: string, geoCords: number[] = [], type: string, radius: number = 0): void {
    const schedulerPreference: any = this._localStorageService.getLocalStorage('dispatch_board_scheduler_preferences') || this.defaultSchedulerPreference;
    if (!schedulerPreference['service_territory']) {
      schedulerPreference['service_territory'] = {};
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    schedulerPreference['service_territory']['JOBS'] = { serviceTerritoryUid: serviceTerritoryUid, serviceTerritoryName: serviceTerritoryName, geoCords: geoCords, type: type, radius: radius };
    this._localStorageService.setLocalStorage('dispatch_board_scheduler_preferences', schedulerPreference);
  }

  updateMetaData(metaData?: any): void {
    if (!metaData) {
      metaData = this._dispatchBoardService.getLocalMetaData();
    }
    if (this._dispatchBoardService.activeDispatchTab === 'ROUTES' && this._dispatchBoardService.enableMapViewByDefault) {
      metaData.map.enable_map_view = true;
    }
    if (this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (this._dispatchBoardService.enableMapLayerByDefault.jobs) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }
    }
    else if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if (this._dispatchBoardService.enableMapLayerByDefault.routes) {
        metaData.map.layers.routes = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.routesJob) {
        metaData.map.layers.jobs = true;
      }
    }
    this._templateService.metaData = metaData;
    this.metaData = metaData;
  }

  setGridSort(key: string, value: string): void {
    this.sortOptions.grid[key] = value;
  }

  previewDataEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openDrawer = false;
    }
    if (event.action === 'DELETE' && event.uid) {
      this.schedulerInstance?.eventStore?.remove(event.uid);
      this.gridViewInstance?.store?.remove(event.uid);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this.updateLocalRecordsAfterChanges({job_uid: event.uid}, 'delete');
      this._dispatchBoardService.injectJobLocationMapData('JOBS', 'schedulerJob', this.metaData, this.schedulerJobs);
    } else if (event.action === 'UPDATE' && event?.job?.job_uid) {
      this.updateNewJobData(event?.job?.job_uid);
      this.setDistanceBetweenJobs();
    } else if (event.action === 'CLONE' && event.uid) {
      this.validateCloneJob(event.uid, event?.isRecurrence ? true : false);
    }
  }

  validateCloneJob(jobUid: string, isRecurrence: boolean): void {
    if (isRecurrence) {
      const cloneJob = this._zuperDialogService.open({
        'title': `${this._utilityService.getLocaleValue('text.clone_job')}`,
        'type': 'error',
        'message': `${this._utilityService.getLocaleValue('clone.job.recurring.alert_message')} ?`,
        'actions': {
          'confirm': {
            'show': true,
            'label': 'Yes',
            'color': 'error',
            'confirmDisplayKey': 'yes',
          },
          'cancel': {
            'show': true,
            'label': 'No',
            'cancelDisplayKey': 'no'
          }
        },
        'dismissible': false,
      });
      cloneJob.afterClosed().subscribe((result) => {
        let disableRecurrence: boolean = true;
        if (result) {
          disableRecurrence = false;
        }
        this.cloneJob(jobUid, disableRecurrence);
      });
    } else {
      this.cloneJob(jobUid);
    }
  }

  cloneJob(jobUid: string, disableRecurrence?: boolean): void {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const job: dataObj = { job_uid: jobUid, action: 'clone', isDialog: true };
    if (disableRecurrence) {
      job['disableRecurrence'] = disableRecurrence;
    }
    this._dispatchBoardService.trackEvent('clone_job');
    const advancedJobService = this._zuperDialogService.openCustom(JobFormComponent, {
      data: job,
      extraClass: 'advanced-job-dialog'
    });
    advancedJobService.afterClosed()
      .subscribe((dialogData: any) => {
        if (dialogData?.job_uid) {
          this.updateNewJobData(dialogData.job_uid);
        }
      });
  }

  applyGridSort(): void {
    this.ngxTippyService.hide('gridJobSortTippy');
    const rollBackParams = { ...this.gridParam };
    rollBackParams['page'] = this.gridPageNumber;
    this.gridParam['sort_by'] = this.sortOptions.grid.sort_by;
    this.gridParam['sort'] = this.sortOptions.grid.sort;
    this.gridParam['page'] = 1;
    this.getGridData(this.gridParam).then((job: any) => {
      this.updateGridViewData(job);
      this.updateTableSort();
      this.gridPageNumber = '1';
    }, (err) => {
      this.updateGridViewData(this.gridData);
      this.gridParam = rollBackParams;
      this.sortOptions.grid.sort = rollBackParams?.sort;
      this.sortOptions.grid.sort_by = rollBackParams?.sort_by;
      this.gridViewInstance.widgetMap.page['value'] = rollBackParams?.page;
    });
  }

  updateTableSort(): void {
    if (this.gridViewType === 'tableView' && this, this.tableViewInstance) {
      this.tableViewInstance.store.sorters = [];
      const sortableColumn = _.findKey(this.gridSortableColumns, value => value === this.sortOptions.grid.sort_by);
      if (sortableColumn) {
        const sorters = {
          'ascending': this.sortOptions.grid.sort === 'ASC' ? true : false,
          'columnOwned': true,
          'field': sortableColumn
        };
        this.tableViewInstance?.store.sorters.push(sorters);
      }
      this.tableViewInstance.renderHeader();
    }
  }

  hideScheduerSearchTippy(): void {
    this.ngxTippyService.hide('tippyschedulerSearch');
  }

  onTeamChange(init?: boolean): void {
    // TODO: check if config has multi-team enabled amd join the array of uids
    this.selectedTeam = this.schedulerFormGroup.get('selectedTeam')?.value;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.schedulerParams = { ...this.schedulerParams, 'filter.team_uid': this.selectedTeam };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const selecetdTeam = _.find(this.allTeams, { 'team_uid': this.schedulerFormGroup.get('selectedTeam')?.value });
    this.selectedTeamTimezone = selecetdTeam?.team_timezone;
    this.selectedTimezone = this._dispatchBoardService.getTimezonePrecedence(this.selectedTeamTimezone);
    if (!init) {
      this.getSchedulerData();
    }
    this.refreshSchedulerTimezone();
    this.resetEmployeeSearch();
    this.updateTeamInUserFilter();
  }

  updateTeamInUserFilter(): void {
    const teamName: string = this.getTeamName(this.selectedTeam)
    this.dispatchFilterDrawerData.additionalFilters = {
      key: 'assigned_to.user_uid',
      filter: {
        'filter.team_uid': this.selectedTeam
      },
      appendToDisplayKey: teamName ? `${this._utilityService.getLocaleValue('text.users_team')} : ${teamName}`: ''
    };
  }

  onCustomTimezoneChange(): void {
    this.selectedTimezone = this._dispatchBoardService.customTimezone;
    this.refreshSchedulerTimezone();
  }

  refreshSchedulerTimezone(setSchedulerDate: boolean = true): void {
    this.setGridSchedulerInstance();
    this.buildBusinessHoursTimeRange('remove');
    this.buildHolidaysTimeRange();
    this._dispatchBoardService.selectedTimezone.JOBS = this.selectedTimezone;
    this.schedulerProConfig.timeZone = this.selectedTimezone;
    this.previewDataOptions.timeZone = this.selectedTimezone;
    this.saveTimezoneSchedulerPreference(this.selectedTimezone);
    this._dispatchBoardService.updateSchedulerTimeoffTimezone(this.schedulerInstance);
    //Workaround - set schduler start/end date after a delay to avoid timezone related issue.
    if (this.schedulerInstance) {
      this.schedulerInstance.timeAxis.reconfigure({
        timeZone: this.selectedTimezone
      });
    }
    setTimeout(() => {
      if (this.schedulerInstance) {
        this.schedulerInstance.timeZone = this.selectedTimezone;
        this.schedulerInstance.eventStore.refreshData();
      }
      this.reRenderGridData();
    }, 100);

    setTimeout(() => {
      if (setSchedulerDate) {
        const hasSchedulerFocusEvent: boolean = !!this.schedulerFocusData.jobUid;
        this.setSchedulerStartEndDate(this.currentView, hasSchedulerFocusEvent);
      }
    }, 300);
  }

  refreshSchedulerEvents(setStartEndTime: boolean, skipSchedulerScroll: boolean = false): void {
    requestAnimationFrame(() => {
      if (this.schedulerInstance) {
        this.schedulerInstance.eventStore.refreshData();
        this.schedulerInstance.resourceStore.refreshData();
        this.setSchedulerFillTricks();
        if (setStartEndTime) {
          this.setSchedulerStartEndDate(this.currentView, skipSchedulerScroll, true);
        }
      }
    });
  }

  onSchedulerDateChange(): void {
    const date = this.schedulerFormGroup?.get('schedulerDate')?.value;
    this.currentDay = date.format('dddd');
    this.schedulerParams = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      ...this.schedulerParams, from_date: moment(date).format('YYYY-MM-DD'), to_date: moment(date).format('YYYY-MM-DD')
    };
    this.setSchedulerStartEndDate(this.currentView);
    this.getSchedulerData(false);
  }

  onSchedulerDateRangeChange(): void {
    const startDate = this.schedulerFormGroup?.get('scheduleStartDate')?.value;
    const endDate = this.schedulerFormGroup?.get('scheduleEndDate')?.value;
    const currentStartDate = startDate.format('YYYY-MM-DD');
    const currentEndDate = endDate.format('YYYY-MM-DD');
    const previousStartDate = this.schedulerParams?.from_date;
    const previousEndDate = this.schedulerParams?.to_date;
    if ((currentStartDate !== previousStartDate) || (currentEndDate !== previousEndDate)) {
      this.schedulerParams = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ...this.schedulerParams, from_date: moment(currentStartDate).format('YYYY-MM-DD'), to_date: moment(currentEndDate).format('YYYY-MM-DD')
      };
      this.setSchedulerStartEndDate(this.currentView);
      this.getSchedulerData(false);
    }
  }

  onSchedulerViewChange(setToday: boolean = false): void {
    const previousView = this.currentView;
    this.schedulerViewportCenterDate = this.schedulerInstance?.viewportCenterDate || null;
    let date: any;
    this.currentView = this.schedulerFormGroup.get('schedulerView').value;
    if (setToday) {
      this.schedulerViewportCenterDate = null;
      date = moment();
      this.currentView = 'DAY';
      this.schedulerFormGroup.get('schedulerView').setValue(this.currentView);
    }
    else {
      if (previousView === 'DAY') {
        this.buildBusinessHoursTimeRange('remove');
        date = this.schedulerFormGroup?.get('schedulerDate')?.value;
      }
      else if (previousView === 'WEEK' || previousView === 'MONTH') {
        date = this.schedulerFormGroup?.get('scheduleStartDate')?.value;
      }
    }
    let startDate: any;
    let endDate: any;
    if (this.currentView === 'DAY') {
      startDate = moment(date).startOf('day');
      endDate = moment(date).endOf('day');
      this.schedulerFormGroup.get('schedulerDate').setValue(date);
    }
    else if (this.currentView === 'WEEK') {
      setTimeout(() => { this.disableSchedulerEventBuffer(); }, 100);
      startDate = moment(date).startOf('week');
      endDate = moment(date).endOf('week');
      this.schedulerFormGroup.get('scheduleStartDate').setValue(startDate);
      this.schedulerFormGroup.get('scheduleEndDate').setValue(endDate);
      this.toggleDatePickerStrategy(this.currentView);
    }
    else if (this.currentView === 'MONTH') {
      setTimeout(() => { this.disableSchedulerEventBuffer(); }, 100);
      startDate = moment(date).startOf('month');
      endDate = moment(date).endOf('month');
      this.schedulerFormGroup.get('scheduleStartDate').setValue(startDate);
      this.schedulerFormGroup.get('scheduleEndDate').setValue(endDate);
      this.toggleDatePickerStrategy(this.currentView);
    }
    //Added setTimeout to defer execution, after current stack is cleared
    setTimeout(() => {
      this.setSchedulerPreset(this.currentView);
      this.getSchedulerData(false);
      this._dispatchBoardService.trackEvent('scheduler_view_' + this.currentView);
    }, 100);
  }

  toggleDatePickerStrategy(viewType: string): void {
    this.customDatePicker.enableWeekRange = viewType === 'WEEK';
    this.customDatePicker.enableMonthRange = viewType === 'MONTH';
  }

  updateFilterValuesLocal(values: any): void {
    const dispatchBoardFilters = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultFilterOptions;
    dispatchBoardFilters.job = values;
    this._localStorageService.setLocalStorage('dispatch_board_advance_filter', dispatchBoardFilters);
  }

   updateSelectedQuickFilterValue(filterUid: any, filterCount?: any): void {
    const quickFilterOptions = this.getDispatchFilterValues();
    quickFilterOptions['filterUid'] = filterUid;
    quickFilterOptions['filterCount'] = filterCount || this.filterCount;
    this.updateFilterValuesLocal(quickFilterOptions);
  }

  updateSearchFilterValue(filterOption: 'grid' | 'scheduler'): void {
    const quickFilterOptions = this.getDispatchFilterValues();
    if (filterOption === 'grid') {
      quickFilterOptions.filterOptions.grid = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridSearchKeyword, quickFilterOptions.filterOptions?.grid);
    }
    else if (filterOption === 'scheduler') {
      quickFilterOptions.filterOptions.scheduler = this._dispatchBoardService.addSearchKeywordFilterRule(this.schedulerSearchKeyword, quickFilterOptions.filterOptions?.scheduler);
      quickFilterOptions.filterOptions.employee = this._dispatchBoardService.addSearchKeywordFilterRule(this.employeeSearchKeyword, quickFilterOptions.filterOptions?.employee);
    }
    this.filterCount = this._dispatchFilterService.getFilterCount(quickFilterOptions?.filterOptions, this.selectedDispatchTab);
    quickFilterOptions['filterCount'] = this.filterCount;
    this.updateFilterValuesLocal(quickFilterOptions);
    this.updateFilterCount();
  }

  onQuickFilterChange(filterUid: any, skipComparison: boolean, init: boolean = false): any {
    this.closeDispatchFilter();
    if (filterUid === 'ADD') {
      this.addNewDispatchFilter();
      return;
    }
    else if (filterUid === 'MANAGE') {
      this.manageQuickFilters();
      return;
    }
    const dispatchFilterValues = this.getDispatchFilterValues();
    this.selectedQuickFilter = filterUid;
    this.fallbackSelectedQuickFilter = filterUid;
    this.gridParam['page'] = 1;
    this.gridPageNumber = '1';


    //Save to local
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const filter = _.find(this.quickFilters, { 'filter_uid': filterUid });
    let quickFilterData = filter?.filter_options;
    let filterOptions = filter?.filter_options?.filterOptions;
    let sortOptions = filter?.filter_options?.sortOptions;

    if (filterUid === 'ALL') {
      const isFilterApplied = Object.keys(this.filterCount).filter((module: any) => this.filterCount[module] === 0).length !== 0;
      if (isFilterApplied && init) {
        filterOptions = dispatchFilterValues?.filterOptions;
        quickFilterData = dispatchFilterValues;
        sortOptions = dispatchFilterValues?.sortOptions;
      }
      else {
        filterOptions = this.defaultFilterOptions?.job.filterOptions;
        quickFilterData = this.defaultFilterOptions?.job;
        sortOptions =  this.defaultFilterOptions?.job?.sortOptions;
      }
    }
    this.updateFilterValuesLocal(quickFilterData);
    this.dispatchFilterDrawerData.dispatchFilterValues = quickFilterData;

    if (filterOptions) {
      this.filterCount = quickFilterData.filterCount;
      this.updateFilterCount();
      this.updateSelectedQuickFilterValue(filterUid, this.filterCount);
      this.applyQuickFilter(filterOptions, sortOptions, skipComparison);
    }
  }

  getPreviewDataOptions(): void {
    this.previewDataOptions = {
      position: 'right',
      type: 'summary',
      mode: 'over',
      hasBackDrop: false,
      allowToEdit: this.permissions.updateJob,
      disableClose: true,
      menuOptions: {
        viewDetails: true,
        clone: this.permissions.cloneJob,
        delete: this.permissions.deleteJob
      }
    };
  }

  //Color profile
  openColorProfileDrawer(): void {
    this.colorProfiletCreateDrawerData.openDrawer = true;
    this.toggleMapLegendBar(false, null, true);
  }

  closeColorProfileDrawer(): void {
    this.colorProfiletCreateDrawerData.openDrawer = false;
  }

  colorProfileEventEmitter(event: any): void {
    if (event?.isClosed) {
      this.closeColorProfileDrawer();
    }
    if (event?.isUpdated) {
      this.getGridData(this.gridParam).then((jobs: any) => {
        this.updateGridViewData(jobs);
      });
      this.getSchedulerData(true);
      this.updateMapLayersData();
    }
  }

  //#region Dispatch Filter
  openDispatchFilter(moduleName: string): void {
    if (!this.dispatchFilterDrawerData.openFilter) {
      this._dispatchBoardService.trackEvent('filter_' + moduleName.toLowerCase());
    }
    this.updateTeamInUserFilter();
    this.dispatchFilterDrawerData.addNewFilter = false;
    this.dispatchFilterDrawerData.saveFilterByDefault = false;
    this.dispatchFilterDrawerData.dispatchFilterValues = this.getDispatchFilterValues();
    this.dispatchFilterDrawerData.selectedModule = moduleName;
    this.dispatchFilterDrawerData.filterOptionalValues = { map: this.mapRouteData?.data };
    this.dispatchFilterDrawerData.openFilter = true;
  }

  addNewDispatchFilter(): void {
    const teamName: string = this.getTeamName(this.selectedTeam)
    this.updateTeamInUserFilter();
    this.dispatchFilterDrawerData.addNewFilter = true;
    this.dispatchFilterDrawerData.openFilter = true;
    this.dispatchFilterDrawerData.saveFilterByDefault = true;
    this.dispatchFilterDrawerData.dispatchFilterValues = this.getDispatchFilterValues(true);
  }

  closeDispatchFilter(): void {
    this.dispatchFilterDrawerData.openFilter = false;
  }

  getDispatchFilterValues(emptyValues: boolean = false): any {
    const dispatchFilterValues = this._localStorageService.getLocalStorage('dispatch_board_advance_filter') || this.defaultFilterOptions;
    if (emptyValues) {
      dispatchFilterValues.job['filterOptions']['grid'] = [];
      dispatchFilterValues.job['filterOptions']['employee'] = [];
      dispatchFilterValues.job['filterOptions']['scheduler'] = [];
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dispatchFilterValues.job['filterOptions']['map'] = { 'filter.route_uid': [] };
    }
    dispatchFilterValues.job['sortOptions']['grid'] = { ...this.sortOptions.grid };
    dispatchFilterValues.job['filterOptions']['grid'] = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', dispatchFilterValues.job?.['filterOptions']['grid']);
    return dispatchFilterValues.job;
  }

  applyQuickFilter(filterOptions: any, sortOptions: any, init: boolean = false): void {
    if (filterOptions) {
      filterOptions = this._dispatchBoardService.sanitizeFilterOptions(filterOptions);
      const oldGridParam = this._configurationService.getGridPreference('job');
      const newGridParam = filterOptions?.grid;
      const newMapParam = filterOptions?.map;
      this.mapParams = this._sharedService.addMissingKey(this.mapParams, newMapParam);

      //Grid
      const oldGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.gridParam?.filter_rules) || [];
      const newGridFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  filterOptions?.grid) || [];
      const isGridFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldGridFilter, newGridFilter);

      //Scheduler
      const oldSchedulerFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.filter_rules) || [];
      const newSchedulerFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  filterOptions?.scheduler) || [];
      let isSchedulerFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldSchedulerFilter, newSchedulerFilter);

      //Employee
      const oldEmployeeFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '', this.schedulerParams?.employee_filter_rules) || [];
      const newEmployeeFilter = this._dispatchBoardService.removeFilterKeyWithValue('keyword', '',  filterOptions?.employee) || [];
      const isEmployeeFilterRuleChanged = !this._dispatchBoardService.isSameFilterRule(oldEmployeeFilter, newEmployeeFilter);

      //Map
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const isMapFilterChanged = !_.isEqual(filterOptions?.map, this.dispatchFilterDrawerData.dispatchFilterValues?.['filterOptions']['grid']);
      this.schedulerParams = _.merge(this.schedulerParams, sortOptions?.scheduler);

      if (isGridFilterRuleChanged || init) {
        this.gridParam = _.merge(this.gridParam, sortOptions?.grid);
        this.gridParam['filter_rules'] = newGridParam;
        this.gridFilterOptions = filterOptions?.grid;
        this.gridParam.page = 1;
        this.gridPageNumber = '1';
        this.getGridData(this.gridParam).then((jobs: any) => {
          //Update card data
          this.cardData = jobs;

          //Update table data
          this.updateTableContent(jobs);
        });
      }

      if ((isSchedulerFilterRuleChanged || isEmployeeFilterRuleChanged) &&  !init) {
        this.schedulerParams['filter_rules'] = newSchedulerFilter;
        this.schedulerParams['employee_filter_rules'] = newEmployeeFilter;
        this.getSchedulerData(isEmployeeFilterRuleChanged || init);
      }

      if (isMapFilterChanged) {
        this.updateMapRouteFilter();
      }
    }
  }

  filterDrawerEmitter(event: any): void {
    if (event?.isClosed) {
      this.dispatchFilterDrawerData.openFilter = false;
      if (event?.type !== 'save' || !event?.filterUid) {
        this.selectedQuickFilter = this.fallbackSelectedQuickFilter;
      }
    }
    if (event?.type === 'reset') {
      this.sortOptions.grid.sort = this.gridParam['sort'] = this.defaultFilterOptions.job.sortOptions.grid.sort;
      this.sortOptions.grid.sort_by = this.gridParam['sort_by'] = this.defaultFilterOptions.job.sortOptions.grid.sort_by;
      this.selectedQuickFilter = 'ALL';
      this.onQuickFilterChange('ALL', false);
    }
    else if (event?.filterUid) {
      const newFilterUid = event?.filterUid;
      this.updateSelectedQuickFilterValue(newFilterUid);
      this.getQuickFilters(false, newFilterUid).pipe(take(1)).subscribe();
    }
    else if (event?.filter) {
      let filter = event?.filter;
      filter = this.filterCleanUp(filter);
      this.updateFilterValuesLocal(filter);
      this.applyQuickFilter(filter?.filterOptions, filter?.sortOptions);
    }
    this.updateFilterCount();
  }

  filterCleanUp(filter: any): any{
    filter.filterOptions['grid'] = this._dispatchBoardService.addSearchKeywordFilterRule(this.gridSearchKeyword, filter.filterOptions['grid']);
    return filter;
  }

  getDateRange(): { fromDate: string; toDate: string } {
    return this.schedulerParams ? { fromDate: this.schedulerParams['from_date'], toDate: this.schedulerParams['to_date'] } : null;
  }

  getDispatchFilterTabs(): any {
    return {
      grid: {
        show: true
      },
      employee: {
        show: true
      },
      scheduler: {
        show: true
      },
      map: {
        show: this.isMapViewEnabled
      }
    };
  }

  manageQuickFilters(): void {
    const teamName: string = this.getTeamName(this.selectedTeam)
    const manageFilter: any = this._zuperDialogService.openCustom(ManageDispatchFilterComponent,
      {
        extraClass: 'manage-dispatch-filters-container',
        data: {
          isMapViewEnabled: this.isMapViewEnabled,
          dateRange: this.getDateRange(),
          moduleAccess: this.moduleAccess,
          currentTab: this.selectedDispatchTab,
          filterTabs: this.getDispatchFilterTabs(),
          additionalFilters: {
            key: 'assigned_to.user_uid',
            filter: {
              'filter.team_uid': this.selectedTeam
            },
            appendToDisplayKey: teamName ? `${this._utilityService.getLocaleValue('text.users_team')} : ${teamName}`: ''
          },
        }
      });
    manageFilter.afterClosed().subscribe((response: any) => {
      this.selectedQuickFilter = this.fallbackSelectedQuickFilter;
      if (response?.createNewFilter) {
        const dispatchFilterValues: any = {
          filterOptions: this.defaultFilterOptions.job.filterOptions,
          sortOptions: {
            grid: { ...this.sortOptions.grid }
          },
          filterUid: 'ALL'
        };
        this.updateTeamInUserFilter();
        this.dispatchFilterDrawerData.dispatchFilterValues = dispatchFilterValues;
        this.dispatchFilterDrawerData.addNewFilter = true;
        this.dispatchFilterDrawerData.openFilter = true;
      }

      if (response?.isFilterUpdated) {
        this.getQuickFilters(false).pipe(take(1)).subscribe();
      }
    });
  }

  closeSchedulerEventDialog(): void {
    this.schedulerNewEventDialogInstance?.close();
  }

  createNewTimeoffEvent(timeoffData: any): void {
    this.schedulerNewEventDialogInstance?.close();
    this._dispatchBoardService.trackEvent('scheduler_drag_create_new_timeoff');
    const newTimeoffDialogInstance = this._zuperDialogService.openCustom(NewTimeOffComponent,
      { disableClose: true, extraClass: 'new-timeoff', timeoffData: timeoffData, action: timeoffData ? 'prefill': 'create' }
    );

    newTimeoffDialogInstance.afterClosed()
      .subscribe((result) => {
        if (result.status) {
          const requestUid = result.request_uid;
          const timeoffRequestUrl = `${this._dispatchBoardService.timeoffDetailsUrl}/${requestUid}`;
          this._dataCollectorService.getData(timeoffRequestUrl)
            .subscribe((response) => {
              const timeoff = response?.data;
              const requestedBy = timeoff.requested_by;
              const userUid = requestedBy.user_uid;
              this.updateTimeOffInLocalRecords('add', userUid, timeoff);
              if (!this._utilityService.isEmptyOrUndefined(timeoff)) {
                const idPrefix = this._dispatchBoardService.getUserTimeoffCount(this.schedulerInstance, userUid);
                const timeoffChunks = this._dispatchBoardService.timeoffListBuilder(timeoff);
                const timeOffRequests = [...timeoffChunks];
                // eslint-disable-next-line @typescript-eslint/naming-convention
                const user = { user_uid: userUid };
                this._dispatchBoardService.injectSchedulerTimeoff(this.schedulerInstance, this.schedulerEmployees, timeOffRequests, requestedBy, idPrefix);
              }
            });
        }
      });
  }

  editResourceTimeRangeEvent(timeoffDetails: any): void {
    this.timeoffTooltipInstance.close();
    this._dispatchBoardService.editTimeOffEvent(this.schedulerInstance, timeoffDetails, this.schedulerEmployees, this.allTeams, this.selectedTeam, this.selectedTimezone, (status: boolean, userUid: string, timeoff: any ) => {
      if(status) {
        this.updateTimeOffInLocalRecords('add', userUid, timeoff);
      }
    });
  }

  deleteResourceTimeRangeEvent(timeoffDetails: any): void {
    this.timeoffTooltipInstance.close();
    this._dispatchBoardService.deleteTimeOffEvent(this.schedulerInstance, timeoffDetails, (status: boolean) => {
      if (status) {
        this.updateTimeOffInLocalRecords('delete', timeoffDetails['userDetails']?.user_uid, timeoffDetails);
      }
    });
  }

  createNewJobEvent(dragData: any): void {
    this.schedulerNewEventDialogInstance?.close();
    this.createNewJob(dragData);
  }

  createNewJob(dragData: any): void {
    if (this._utilityService.isEmptyOrUndefined(dragData)) {
      this.newJobPrefillData = {};
      this._dispatchBoardService.trackEvent('create_job');
    }
    else {
      this.newJobPrefillData = dragData;
      this._dispatchBoardService.trackEvent('scheduler_drag_create_new_job');
    }
    this.openNewJobDrawer = true;
  }

  jobFormEmitHandler(event: any): void {
    if (event?.isDrawerClosed) {
      this.openNewJobDrawer = false;
      this.cloneJobData = null;
      this.newJobPrefillData = null;
    }
    if (event.isCreatedJob) {
      this.updateNewJobData(event.job_uid);
    } else if (event?.action === 'ADVANCED_JOB' && event?.job) {
      const job: dataObj = { ...event?.job, action: 'clone', isDialog: true };
      if (this.selectedTimezone) {
        job['timeZone'] = this.selectedTimezone;
      }
      this._dispatchBoardService.trackEvent('create_detailed_job');
      const advancedJobService = this._zuperDialogService.openCustom(JobFormComponent, {
        data: job,
        extraClass: 'advanced-job-dialog'
      });
      advancedJobService.afterClosed()
        .subscribe((dialogData: any) => {
          if (dialogData?.job_uid) {
            this.updateNewJobData(dialogData.job_uid);
          }
        });
    }
  }

  updateNewJobData(jobUid: string): void {
    if (!this._utilityService.isEmptyOrUndefined(jobUid)) {
      const jobUrl = `${this._dispatchBoardService.jobDetailsUrl}/${jobUid}`;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this._dataCollectorService.getData(jobUrl, { use_color_profile: true })
        .subscribe((response: any) => {
          this.updateNewJobInScheduler(response?.data);
          this.updateNewJobInGrid(response?.data);
        });
    }
  }

  updateNewNonJobEventData(nonJobEventUid: string): void {
    if (nonJobEventUid) {
      const nonJobUrl = `${this._dataCollectorService.baseurl()}/non_job_events/${nonJobEventUid}`;
      this._dataCollectorService.getData(nonJobUrl)
        .subscribe((response: any) => {
          this.updateNewNonJobEventInScheduler(response?.data);
        });
    }
  }

  updateNewJobInGrid(jobDetails: any): void {
    const gridData = _.cloneDeep(this.gridData);
    const jobUid = jobDetails?.job_uid;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const gridDataIndex = _.findIndex(gridData, { 'job_uid': jobUid });
    if (gridDataIndex !== -1) {
      gridData.splice(gridDataIndex, 1);
      gridData.splice(gridDataIndex, 0, jobDetails);
      this._dispatchBoardService.setGridRecords(gridData);
      this.updateGridViewData(gridData);
      this._dispatchBoardService.injectJobLocationMapData('JOBS', 'gridJob', this.metaData, gridData);
      this.gridData = gridData;
    }
    this.cardData = this.gridData;
  }

  updateNewJobInScheduler(jobDetails: any): void {
    this.suspendAllSchedulerEvents({ event: true, assignment: true });
    const assignedTo = jobDetails?.assigned_to;
    const scheduledStartTime = dayjs(jobDetails?.scheduled_start_time);
    const scheduledEndTime = dayjs(jobDetails?.scheduled_end_time);
    if (assignedTo?.length === 0) {
      const allAssignments: Object[] = this.schedulerProConfig.assignments;
      const oldAssignmentsIds: any[] = allAssignments.filter((assignment: any) => assignment.eventId === jobDetails?.job_uid).map((assignment: any) => assignment.id);
      oldAssignmentsIds.forEach((removedId: any) => {
        _.remove(this.schedulerProConfig.assignments, { 'id': removedId });
        this.schedulerInstance.assignmentStore.remove(removedId);
      });
    }
    else {
      this.updateEventSchedulerAssignment(jobDetails, 'job');
      assignedTo?.forEach((assignee: any) => {
        const userUid = assignee?.user.user_uid;
        const teamUid = assignee?.team?.team_uid;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const isAssignedUserInScheduler = _.find(this.schedulerEmployees, { user_uid: userUid });
        if (isAssignedUserInScheduler) {
          this.addNewSchedulerRecord(jobDetails);
          this.createNewSchedulerResourceAndEvent(jobDetails, assignee.user, scheduledStartTime, scheduledEndTime, teamUid, false, true);
          this.setDistanceBetweenJobs();
        }
      });
    }
    this.resumeAllSchedulerEvents({ event: true, assignment: true });
  }

  updateNewNonJobEventInScheduler(nonJobEventDetails: any): void {
    this.suspendAllSchedulerEvents({ event: true, assignment: true });
    const assignedTo = nonJobEventDetails?.assigned_to;
    const eventStartTime = dayjs(nonJobEventDetails?.start_time);
    const eventEndTime = dayjs(nonJobEventDetails?.end_time);
    if (assignedTo?.length) {
      this.updateEventSchedulerAssignment(nonJobEventDetails, 'nonJobEvent');
      assignedTo?.forEach((assignee: any) => {
        const userUid = assignee?.user.user_uid;
        const teamUid = assignee?.team?.team_uid || null;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const isAssignedUserInScheduler = _.find(this.schedulerEmployees, { user_uid: userUid });
        if (isAssignedUserInScheduler) {
          this.createNewSchedulerNonJobEvent(nonJobEventDetails, assignee.user, eventStartTime, eventEndTime, teamUid, true);
        }
      });
    }
    else {
      const allAssignments: Object[] = this.schedulerProConfig.assignments;
      const oldAssignmentsIds: any[] = allAssignments.filter((assignment: any) => assignment.eventId === nonJobEventDetails?.event_uid).map((assignment: any) => assignment.id);
      oldAssignmentsIds.forEach((removedId: any) => {
        _.remove(this.schedulerProConfig.assignments, {'id': removedId});
        this.schedulerInstance.assignmentStore.remove(removedId);
      });
    }
    this.resumeAllSchedulerEvents({ event: true, assignment: true });
  }

  openNoTeamAlert(): void {
    this._sharedService.isNoTeamCreatedAlertIsOpened = true;
    this.onTeamClear();
    this.noTeamAlertDialogRef = this.matDialog.open(this.noTeamAlertDialogContent, {
      panelClass: ['w-120'],
      disableClose: true,
    });

    this.noTeamAlertDialogRef.afterClosed().subscribe((dialogData: any) => {
      this._sharedService.isNoTeamCreatedAlertIsOpened = false;
    });
  }

  createNewNonJobEvent(dragData: any): void {
    this.schedulerNewEventDialogInstance?.close();
    if (this._utilityService.isEmptyOrUndefined(dragData)) {
      this.nonJobEventCreateDrawerData.eventData = null;
    }
    else {
      const eventStartDateTime: string = dragData?.startDate;
      const eventEndDateTime: string = dragData?.endDate;
      const assignedTo: any[] = [{user: dragData?.user, team: dragData?.team}];
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const eventData: any = { assigned_to: assignedTo, start_time: eventStartDateTime, end_time: eventEndDateTime };
      this.nonJobEventCreateDrawerData.eventData = eventData;
    }
    this.nonJobEventCreateDrawerData.source = null;
    this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.create.title', state: 'new' };
    this.nonJobEventCreateDrawerData.openDrawer = true;
  }

  nonJobEventEmitHandler(event: any): void {
    if (event?.isClosed) {
      this.nonJobEventCreateDrawerData.openDrawer = false;
      if (event?.action === 'create' && event?.isCompleted) {
        if (event?.isRecurrence) {
          this.getNonJobEventData();
        }
        else {
          if (event?.data?.event_uids?.length) {
            this.updateNewNonJobEventData(event?.data?.event_uids?.[0]);
          }
        }
      }
      else if (event?.action === 'edit' && event?.isCompleted) {
        if (event?.isRecurrence) {
          this.closeNonJobEventPreview();
          this.getNonJobEventData();
        }
        else if (event?.data?.event_uid) {
          this.updateNewNonJobEventData(event?.data?.event_uid);
          if (this.nonJobEventCreateDrawerData.source === 'detailsPage') {
            this.openNonJobEventPreview(event?.data?.event_uid);
            this.nonJobEventCreateDrawerData.source = null;
          }
        }
      }
    }
  }

  editNonJobEvent(nonJobEventData: any): void {
    if (nonJobEventData?.is_recurrence) {
      const startDateTime = moment(nonJobEventData?.start_time).tz(this.selectedTimezone).format('YYYY-MM-DD HH:mm');
      const actionSelectorOption: ActionSelectorOption = {
        title: `${this._utilityService.getLocaleValue('non_job_event.recurrence.edit.title', 'Edit Recurring Non Job Event')}`,
        options: [
          {
            key: 'SINGLE_EVENT',
            optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.edit.event_only_title', 'Update this event only'),
            optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.event_only_message', 'Applies to this event only')} (${startDateTime})`
          },
          {
            key: 'ALL_FUTURE_EVENTS',
            optionTitle: this._utilityService.getLocaleValue('non_job_event.recurrence.edit.upcoming_event_title', 'Update this and upcoming events'),
            optionMessage: `${this._utilityService.getLocaleValue('non_job_event.recurrence.upcoming_event_message', 'Applies to this and upcoming events in the series.')}`
          }
        ],
        primaryActionButtonText: this._utilityService.getLocaleValue('proceed', 'proceed'),
        primaryActionButtonType: 'primary'
      };
      const actionSelectorDialogRef = this._zuperDialogService.openCustom(ActionSelectorComponent, { data: actionSelectorOption, extraClass: 'non-job-delete-recurrence-dialog' });
      actionSelectorDialogRef.afterClosed().subscribe((response: any) => {
        if (response?.isSelected) {
          if (response?.selectedType && ['SINGLE_EVENT', 'ALL_FUTURE_EVENTS'].includes(response?.selectedType)) {
            this.closeNonJobEventPreview();
            this.schedulerNewEventDialogInstance?.close();
            this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.edit.title', state: 'edit', editType: response?.selectedType };
            this.nonJobEventCreateDrawerData.openDrawer = true;
            this.nonJobEventCreateDrawerData.eventData = nonJobEventData;
          }
        }
      });
    }
    else {
      this.closeNonJobEventPreview();
      this.schedulerNewEventDialogInstance?.close();
      this.nonJobEventCreateDrawerData.options = { header: 'non_job_event.edit.title', state: 'edit', editType: 'SINGLE_EVENT' };
      this.nonJobEventCreateDrawerData.openDrawer = true;
      this.nonJobEventCreateDrawerData.eventData = nonJobEventData;
    }
  }

  openNonJobEventPreview(nonJobEventUid: string): void {
    if (nonJobEventUid) {
      this.nonJobEventDetailsDrawerData.nonJobEventUid = nonJobEventUid;
      this.nonJobEventDetailsDrawerData.openDrawer = true;
      this.nonJobEventDetailsDrawerData.options = { actions: { delete: true, edit: true } };
    }
  }

  closeNonJobEventPreview(): void {
    this.nonJobEventDetailsDrawerData.nonJobEventUid = null;
    this.nonJobEventDetailsDrawerData.openDrawer = false;
    this.nonJobEventDetailsDrawerData.options = null;
  }

  nonJobEventDetailsDrawerEmitter(event: any): void {
    if (event?.isClosed) {
      this.closeNonJobEventPreview();
    }
    if (event?.action === 'edit') {
      if (event?.eventDetails) {
        this.nonJobEventCreateDrawerData.source = 'detailsPage';
        this.editNonJobEvent(event?.eventDetails);
      }
    }
    else if (event?.action === 'delete') {
      if (event?.isRecurrence) {
        this.getNonJobEventData();
      }
      else {
        const eventUid: string = event?.eventUid;
        this.schedulerInstance?.eventStore.remove(eventUid);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.updateLocalRecordsAfterNonJobEventChanges({ event_uid: eventUid }, 'delete');
      }
    }
  }

  createNewTeam(): void {
    this._dispatchBoardService.createNewTeam();
    this.noTeamAlertDialogRef.close();
  }

  goBackFromCreateTeamAlert(): void {
    this.router.navigate(['/dashboard']);
    this.noTeamAlertDialogRef.close();
  }

  async setDistanceBetweenJobs(specificUsers: string[] = [], delay: number = 0): Promise<any> {
    const enable = this.metaData?.scheduler.display?.duration_between_jobs && this._utilityService.companyPolicy.dispatch_board.distance_time && this.currentView === 'DAY';
    if (enable && this.schedulerInstance) {
      const modeOfTransport: string = this.metaData?.scheduler?.mode_of_transport || 'CAR';
      this.schedulerInstance.features.eventBuffer.disabled = false;
      this.resetJobDistanceForAllEvents();
      const jobDistanceData = await this._dispatchBoardService.getDistanceBetweenJobs(this.schedulerEmployees, this.schedulerJobs, modeOfTransport, specificUsers);
      const customJobDistanceData = {};
      _.forEach(jobDistanceData, (distanceData: any) => {
        const legDetails = distanceData.leg_details;
        _.forEach(legDetails, (legDetail: any) => {
          customJobDistanceData[legDetail.start_location.job_uid] = legDetail;
        });
      });
      setTimeout(() => {
        _.forEach(jobDistanceData, (jobDistance: any) => {
          const userUid = jobDistance?.user_uid;
          if (userUid && this.schedulerInstance.resourceStore.allCount) {
            const resource: any = this.schedulerInstance.resourceStore.getById(userUid);
            if (resource) {
              const events = resource.events;
              if (events && events.length) {
                _.forEach(events, (event: any) => {
                  const jobUid = event.id;
                  if (customJobDistanceData.hasOwnProperty(jobUid)) {
                    const legDetail = customJobDistanceData[jobUid];
                    if (legDetail?.leg_time && typeof (legDetail?.leg_time) === 'number') {
                      const travelTime = Math.round(legDetail?.leg_time / 60000);
                      if (travelTime > 1) {
                        event.postamble = `${travelTime} minutes`;
                        event.data['travelDistanceData'] = legDetail;
                      }
                    }
                  }
                });
              }
            }
          }
        });
        this.schedulerInstance.eventStore.refreshData();
      }, delay);
    }
    else {
      this.disableSchedulerEventBuffer();
    }
  }

  disableSchedulerEventBuffer(): void {
    if (this.schedulerInstance) {
      this.schedulerInstance.features.eventBuffer.disabled = true;
    }
    this.resetJobDistanceForAllEvents();
  }

  resetJobDistanceForAllEvents(): void {
    if(this.schedulerInstance) {
      this.suspendAllSchedulerEvents({ event: true });
      const allEvents = this.schedulerInstance.eventStore.allRecords;
      _.forEach(allEvents, (event: any) => {
        event.preamble = null;
        event.postamble = null;
        event.data['travelDistanceData'] = null;
      });
      this.resumeAllSchedulerEvents({ event: true });
    }
  }

  //Service Territory
  onServiceTerritoryChange(event?: any): void {
    this.selectedServiceTerritoryDetails.name = event?.territory_name || '';
    this.selectedServiceTerritoryDetails.type = event?.territory_type || null;
    this.teamSearchPagination.serviceTerritoryFilterUid = this.selectedServiceTerritory !== 'ALL' ? this.selectedServiceTerritory : '';
    let radius: number = 0;
    if (event?.territory_type === 'RADIUS' && event?.territory_radius?.geo_cordinates?.length === 2) {
      this.selectedServiceTerritoryDetails.geoCords = event?.territory_radius?.geo_cordinates;
      radius = event?.territory_radius?.radius || 0;
      const bounds = this._mapService.getCircleBounds(this.selectedServiceTerritoryDetails.geoCords[0], this.selectedServiceTerritoryDetails.geoCords[1], radius);
      this._mapService.mapFitBoundByGeoCords.next(bounds);
    }
    else if (event?.territory_type === 'GEOFENCE') {
      this.selectedServiceTerritoryDetails.geoCords = event?.territory_coordinates;
      this._mapService.mapFitBoundByGeoCords.next(event?.territory_coordinates);
    }
    else {
      this.selectedServiceTerritoryDetails.geoCords = [];
    }
    this.saveServiceTerritorySchedulerPreference(this.selectedServiceTerritory, this.selectedServiceTerritoryDetails.name, this.selectedServiceTerritoryDetails.geoCords, this.selectedServiceTerritoryDetails.type, radius);
    this.teamSearchPagination.filterUid = '';
    this.teamSearchPagination.currentPage = 1;
    this.selectedTeam = null;
    this.schedulerFormGroup.get('selectedTeam').setValue(null);
    this.teams = of([]);
    this.getTeams(true).subscribe(() => {
      this.teams = of(_.uniqBy(this.teamPickerList, 'team_uid'));
      this.getGridData(this.gridParam).then((jobs: any) => {
        this.updateGridViewData(jobs);
      });
      this.getSchedulerData(true);
    });
  }

  //Routes
  routeDetailsDrawerEvent(event: any): void {
    this._dispatchBoardService.jobRouteTransferEmitter.next({ additionalParams: { type: 'routeDetailsOnCloseEmitter', event: { status: event ? 'open' : 'close', source: 'routeDetailsDrawerEvent' }, source: this.routePreviewDrawerData.source } });
    if (!event) {
      this._dispatchBoardService.previewRouteDetails.set({ show: false, routeDetailsUid: '', source: this.routePreviewDrawerData.source });
    }
  }

  routeDetailsEvent(event: any): void {
    this._dispatchBoardService.jobRouteTransferEmitter.next({ additionalParams: { type: 'routeDetailsOnCloseEmitter', event: event, source: this.routePreviewDrawerData.source } });
    if (event?.status === 'close') {
      this._dispatchBoardService.previewRouteDetails.set({ show: false, routeDetailsUid: '', source: this.routePreviewDrawerData.source });
    }
    if (event?.status === 'change') {
      if(this._dispatchBoardService.activeDispatchTab === 'JOBS' && this.metaData?.map?.layers?.routes) {
        const routeIndex = this.mapRouteData?.data?.findIndex((route: any) => route.route_uid === event?.data?.route_uid);
        if (routeIndex !== -1) {
          this.mapRouteData.data[routeIndex] = event?.data;
        } else {
          this.mapRouteData?.data?.push(event?.data);
        }
        this.mapRouteData['forceUpdate'] = true;
        this.updateMapRouteFilter();
      }
    }
    if (event?.status === 'delete') {
      this._dispatchBoardService.previewRouteDetails.set({ show: false, routeDetailsUid: '', source: this.routePreviewDrawerData.source });
      const routeIndex = this.mapRouteData?.data?.findIndex((route: any) => route.route_uid === event?.data?.route_uid);
      if (routeIndex !== -1) {
        this.mapRouteData.data.splice(routeIndex, 1);
      }
      this.mapRouteData['forceUpdate'] = true;
      this.updateMapRouteFilter();
    }
  }

  // Region: UI SDK

  async checkAndHandleForPreEventListenerFromSDK(key: string, values): Promise<boolean>{
    if(this._sdkEventService.checkForPreEventHandler(`dispatch_board.${key}`)){
      return this._sdkEventService.castPreEventListener(`dispatch_board.${key}`, values);
    }else{
      return Promise.resolve(true);
    }
  }
}


